import React, { useState, useEffect, useRef } from "react";

// Inject spinner CSS
if (typeof document !== "undefined" && !document.getElementById("tt-spin")) {
  const s = document.createElement("style");
  s.id = "tt-spin";
  s.textContent = "@keyframes spin{to{transform:rotate(360deg)}}";
  document.head.appendChild(s);
}

// ── Google OAuth constants ─────────────────────────────────────────────────
const GOOGLE_CLIENT_ID = "267287268087-su4nbe25tt03hslglm1ca9rofriejcci.apps.googleusercontent.com";
const SCOPES = "https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/drive openid email profile";
const OAUTH_REDIRECT_URI = window.location.origin; // https://taskstherapy.the2457design.com

// ─── TIME HELPERS ─────────────────────────────────────────────────────────────
const _now = new Date();
const addH = (h) => new Date(_now.getTime() + h * 3600000).toISOString();
const subH = (h) => new Date(_now.getTime() - h * 3600000).toISOString();
const fmt  = (iso) => new Date(iso).toLocaleString("en-GB", { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit", timeZone:"Asia/Singapore" });
const timeLeft = (iso) => {
  const d = new Date(iso) - new Date();
  if (d < 0) return { label:"Overdue", overdue:true };
  const h = Math.floor(d/3600000), m = Math.floor((d%3600000)/60000);
  return { label: h > 24 ? `${Math.floor(h/24)}d ${h%24}h` : `${h}h ${m}m`, overdue:false };
};
const mkAvatar = (n) => n.split(" ").map(p=>p[0]).join("").slice(0,2).toUpperCase();

// ─── STATIC CONFIG ───────────────────────────────────────────────────────────
// ─── APP LOGO (base64 PNG — white on transparent, 64×64) ────────────────────
const APP_LOGO_B64 = "data:image/png;base64,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";

// ─── RECURRENCE ──────────────────────────────────────────────────────────────
const RECUR_OPTIONS = [
  { value:"none",         label:"Does not repeat",      short:"" },
  { value:"daily",        label:"Daily",                short:"Daily" },
  { value:"weekly",       label:"Weekly",               short:"Weekly" },
  { value:"biweekly",     label:"Every 2 weeks",        short:"Bi-weekly" },
  { value:"monthly",      label:"Monthly",              short:"Monthly" },
  { value:"monthly_last", label:"Monthly (last day)",   short:"Month-end" },
  { value:"yearly",       label:"Yearly",               short:"Yearly" },
];

function nextRecurDeadline(rule, fromDate) {
  const d = new Date(fromDate);
  if      (rule==="daily")        d.setDate(d.getDate()+1);
  else if (rule==="weekly")       d.setDate(d.getDate()+7);
  else if (rule==="biweekly")     d.setDate(d.getDate()+14);
  else if (rule==="monthly")      d.setMonth(d.getMonth()+1);
  else if (rule==="monthly_last") d.setMonth(d.getMonth()+2, 0);
  else if (rule==="yearly")       d.setFullYear(d.getFullYear()+1);
  return d;
}

function recurDescription(rule, deadline) {
  if (!rule || rule==="none") return null;
  const next = nextRecurDeadline(rule, deadline);
  return `Next: ${next.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"})}`;
}

// ─────────────────────────────────────────────────────────────────────────────
const STATUS = {
  not_done:    { label:"Not Done",    color:"#ffffff", bg:"#dc2626", icon:"○" },
  in_progress: { label:"In Progress", color:"#ffffff", bg:"#d97706", icon:"◑" },
  done:        { label:"Done",        color:"#ffffff", bg:"#059669", icon:"●" },
};
const PRIORITY = {
  high:   { color:"#ffffff", bg:"#dc2626", label:"High"   },
  medium: { color:"#ffffff", bg:"#d97706", label:"Medium" },
  low:    { color:"#ffffff", bg:"#4b5563", label:"Low"    },
};
const THEMES = [
  { name:"Indigo",  primary:"#6366f1", secondary:"#8b5cf6", dark:"#1e1b4b", darker:"#312e81" },
  { name:"Emerald", primary:"#059669", secondary:"#0d9488", dark:"#064e3b", darker:"#065f46" },
  { name:"Rose",    primary:"#e11d48", secondary:"#db2777", dark:"#4c0519", darker:"#881337" },
  { name:"Amber",   primary:"#d97706", secondary:"#b45309", dark:"#451a03", darker:"#78350f" },
  { name:"Sky",     primary:"#0284c7", secondary:"#0369a1", dark:"#0c4a6e", darker:"#075985" },
  { name:"Violet",  primary:"#7c3aed", secondary:"#6d28d9", dark:"#2e1065", darker:"#4c1d95" },
  { name:"Slate",   primary:"#475569", secondary:"#334155", dark:"#0f172a", darker:"#1e293b" },
];
const CAT_ICONS = ["📋","💰","💻","🤝","👥","⚙️","📦","🎯","🔬","🏗","📊","🛡","🌐","✈️","🎨","📣","🔧","📱","🏥","🎓","🧪","🚀","💡","🔑","📐"];

// ─── SEED DATA ────────────────────────────────────────────────────────────────
const SEED_COMPANY = { name:"", logo:"", themeIdx:0 };

// ─── DEMO WORKSPACES ─────────────────────────────────────────────────────────
// In production each workspace = a separate Google Sheet
const DEMO_WORKSPACES = [];

const SEED_USERS = [];

// ─── ROLE CONFIG ──────────────────────────────────────────────────────────────
const ROLES = {
  manager:    { label:"Manager",    icon:"👑", color:"#ffffff", bg:"#7c3aed", desc:"Full access: manage users, categories, company settings, all tasks" },
  supervisor: { label:"Supervisor", icon:"🔷", color:"#ffffff", bg:"#0284c7", desc:"Can create tasks and sees tasks they create or are assigned to them" },
  staff:      { label:"Staff",      icon:"👤", color:"#ffffff", bg:"#059669", desc:"Can only view and update tasks assigned to them"                     },
};

const SEED_CATS = [];

const SEED_TASKS = [];

// ─── RICH TEXT ────────────────────────────────────────────────────────────────
const URL_RE = /(https?:\/\/[^\s<>"']+)/;
const MENTION_RE = /(@[\w][\w ]*)/;
const RichText = ({ text }) => {
  if (!text) return null;
  // Split on URLs FIRST (so @mention regex can't swallow "https"), then @mentions inside non-URL parts
  return (
    <span style={{ whiteSpace:"pre-wrap" }}>
      {text.split(URL_RE).map((chunk,i) =>
        chunk.match(/^https?:\/\//)
          ? <a key={i} href={chunk} target="_blank" rel="noopener noreferrer" style={{ color:"#2563eb", textDecoration:"underline", wordBreak:"break-all" }}>{chunk}</a>
          : <span key={i}>{chunk.split(MENTION_RE).map((seg,j) =>
              seg.startsWith("@")
                ? <span key={j} style={{ color:"#6366f1", fontWeight:700, background:"#eef2ff", borderRadius:4, padding:"0 3px" }}>{seg}</span>
                : seg
            )}</span>
      )}
    </span>
  );
};

// ─── MEDIA HELPERS ────────────────────────────────────────────────────────────
// Always upload to Drive. For images ≤500KB also keep a base64 thumbnail for
// inline preview without a round-trip. Videos / PDFs / docs → Drive ID only.
const THUMB_SIZE_LIMIT = 500 * 1024; // 500 KB

const readFileAsBase64 = (f) => new Promise((res) => {
  const r = new FileReader();
  r.onload = ev => res(ev.target.result);
  r.readAsDataURL(f);
});

// Upload a File object to a Drive folder, return Drive file metadata
const uploadFileToDrive = async (file, folderId, accessToken) => {
  const buildForm = () => {
    const meta = { name: file.name, parents: folderId ? [folderId] : [] };
    const f = new FormData();
    f.append("metadata", new Blob([JSON.stringify(meta)], { type: "application/json" }));
    f.append("file", file);
    return f;
  };
  const doUpload = async (token) => fetch(
    "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id,name,webViewLink",
    { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: buildForm() }
  );
  let res = await doUpload(accessToken);
  if (!res.ok && res.status === 401) {
    // Token expired — on web we can't silently refresh, just throw so caller handles it
    throw new Error("Upload failed: session expired (401). Please sign in again.");
  }
  if (!res.ok) throw new Error(`Drive upload failed: ${res.status}`);
  const driveFile = await res.json();
  // Share as public reader so anyone can view via thumbnail URL
  try {
    await fetch(`https://www.googleapis.com/drive/v3/files/${driveFile.id}/permissions`, {
      method: "POST",
      headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" },
      body: JSON.stringify({ role: "reader", type: "anyone" })
    });
  } catch(e) {}
  return driveFile;
};

// Process picked files: upload to Drive, use blob URL for instant preview + Drive thumbnail for persistent display
const processFiles = async (files, folderId, accessToken) => {
  return Promise.all(Array.from(files).map(async (f) => {
    const base = { type: f.type, name: f.name, size: f.size };
    const blobUrl = f.type.startsWith("image/") ? URL.createObjectURL(f) : null;
    // Try Drive upload if we have credentials
    if (accessToken && folderId) {
      try {
        const driveFile = await uploadFileToDrive(f, folderId, accessToken);
        const entry = {
          ...base,
          driveId: driveFile.id,
          driveUrl: driveFile.webViewLink,
          imgUrl: `https://drive.google.com/thumbnail?id=${driveFile.id}&sz=w600`
        };
        if (blobUrl) entry.blobUrl = blobUrl;
        return entry;
      } catch (e) {
        console.warn("Drive upload failed:", e);
        return { ...base, uploadError: e.message || "Upload failed" };
      }
    }
    // Fallback: base64 (offline / no credentials) — only safe for small files
    const dataUrl = await readFileAsBase64(f);
    return { ...base, dataUrl };
  }));
};

// ─── FILE TYPE HELPERS ────────────────────────────────────────────────────────
const FILE_TYPES = {
  image:    { test: t => t.startsWith("image/"),                           icon:"🖼️",  color:"#6366f1", bg:"#eef2ff", label:"Image"    },
  video:    { test: t => t.startsWith("video/"),                           icon:"🎬",  color:"#0ea5e9", bg:"#f0f9ff", label:"Video"    },
  pdf:      { test: t => t==="application/pdf",                            icon:"📄",  color:"#ef4444", bg:"#fef2f2", label:"PDF"      },
  word:     { test: t => t.includes("word") || t.includes("document"),     icon:"📝",  color:"#2563eb", bg:"#eff6ff", label:"Word"     },
  excel:    { test: t => t.includes("excel") || t.includes("spreadsheet"), icon:"📊",  color:"#16a34a", bg:"#f0fdf4", label:"Excel"    },
  ppt:      { test: t => t.includes("presentation") || t.includes("powerpoint"), icon:"📊", color:"#ea580c", bg:"#fff7ed", label:"PPT" },
  zip:      { test: t => t.includes("zip") || t.includes("rar") || t.includes("7z"), icon:"🗜️", color:"#57534e", bg:"#fafaf9", label:"Archive" },
  csv:      { test: t => t.includes("csv"),                                  icon:"📊",  color:"#16a34a", bg:"#f0fdf4", label:"CSV"      },
  csv:      { test: t => t.includes("csv"),                                icon:"📊",  color:"#16a34a", bg:"#f0fdf4", label:"CSV"      },
  text:     { test: t => t.startsWith("text/"),                            icon:"📃",  color:"#334155", bg:"#f8fafc", label:"Text"     },
  other:    { test: () => true,                                             icon:"📎",  color:"#334155", bg:"#f8fafc", label:"File"     },
};
const getFileType = (mimeType) => Object.values(FILE_TYPES).find(ft => ft.test(mimeType)) || FILE_TYPES.other;
const isMedia     = (mimeType) => mimeType.startsWith("image/") || mimeType.startsWith("video/");
const fmtSize     = (bytes) => bytes > 1048576 ? `${(bytes/1048576).toFixed(1)} MB` : bytes > 1024 ? `${(bytes/1024).toFixed(0)} KB` : `${bytes} B`;

// Accepted file types for the picker
const ACCEPT_ALL = "image/*,video/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,text/csv,application/csv,application/zip,application/x-rar-compressed,application/x-7z-compressed,image/heic,image/heif";

// ─── MEDIA / FILE ATTACH ──────────────────────────────────────────────────────
const MediaAttach = ({ attachments, setAttachments, accent="#6366f1", folderId=null, accessToken=null, onError=null }) => {
  const ref = useRef(null);
  const [uploading, setUploading] = React.useState(false);
  const onFiles = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    try {
      const loaded = await processFiles(files, folderId, accessToken);
      const failed = loaded.filter(f => f.uploadError);
      if (failed.length > 0 && onError) {
        onError("Upload failed: " + failed[0].uploadError);
      }
      const succeeded = loaded.filter(f => !f.uploadError);
      setAttachments(p => [...p, ...succeeded].slice(0, 8));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };
  const remove = (i) => setAttachments(p => p.filter((_,j) => j!==i));

  return (
    <div>
      {attachments.length > 0 && (
        <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:8 }}>
          {attachments.map((a,i) => {
            const ft = getFileType(a.type);
            return (
              <div key={i} style={{ position:"relative", borderRadius:8, overflow:"hidden", border:"1px solid #e2e8f0" }}>
                {a.type.startsWith("image/")
                  ? <img src={a.blobUrl || a.dataUrl || a.imgUrl || (a.driveId ? `https://drive.google.com/thumbnail?id=${a.driveId}&sz=w600` : "")} data-did={a.driveId||""} alt={a.name} style={{ width:72, height:72, objectFit:"cover", display:"block" }} onError={e=>{const el=e.target;const r=parseInt(el.dataset.r||"0");if(r<10&&el.dataset.did){el.dataset.r=r+1;setTimeout(()=>{el.src=`https://drive.google.com/thumbnail?id=${el.dataset.did}&sz=w600&t=${Date.now()}`;},r<3?5000:r<6?15000:30000);}else{el.style.display="none";}}} />
                  : <div style={{ width:72, height:72, background:ft.bg, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:2, padding:4 }}>
                      <span style={{ fontSize:22 }}>{ft.icon}</span>
                      <span style={{ color:ft.color, fontSize:11, textAlign:"center", maxWidth:64, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontWeight:600 }}>{a.name}</span>
                      <span style={{ color:"#334155", fontSize:11 }}>{fmtSize(a.size)}</span>
                    </div>
                }
                <button onClick={()=>remove(i)} style={{ position:"absolute", top:2, right:2, width:16, height:16, borderRadius:"50%", background:"rgba(0,0,0,0.6)", border:"none", color:"white", fontSize:12, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", padding:0, lineHeight:1 }}>✕</button>
              </div>
            );
          })}
          {attachments.length < 8 && (
            <button onClick={()=>ref.current?.click()} style={{ width:72, height:72, borderRadius:8, border:"1.5px dashed #cbd5e1", background:"#f8fafc", cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:3, fontFamily:"inherit" }}>
              <span style={{ fontSize:18, color:"#334155" }}>+</span>
              <span style={{ fontSize:11, color:"#334155" }}>Add more</span>
            </button>
          )}
        </div>
      )}
      <input ref={ref} type="file" accept={ACCEPT_ALL} multiple onChange={onFiles} style={{ display:"none" }} />
      {uploading && (
        <div style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 0", color:"#6366f1", fontSize:14 }}>
          <span style={{ display:"inline-block", width:14, height:14, border:"2px solid #6366f1", borderTopColor:"transparent", borderRadius:"50%", animation:"spin 0.8s linear infinite" }} />
          Uploading to Google Drive…
        </div>
      )}
      {!uploading && attachments.length === 0 && (
        <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
          {[
            { label:"📷 Photo",     accept:"image/*" },
            { label:"🎬 Video",     accept:"video/*" },
            { label:"📄 PDF / Doc", accept:"application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" },
            { label:"📊 Spreadsheet", accept:"application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/csv" },
            { label:"📁 Any file",  accept:ACCEPT_ALL },
          ].map(btn => (
            <button key={btn.label} onClick={()=>{ ref.current.accept=btn.accept; ref.current?.click(); }}
              style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"5px 10px", borderRadius:7, border:`1px solid ${accent}30`, background:`${accent}08`, color:accent, fontSize:14, cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>
              {btn.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

// ─── MEDIA / FILE GALLERY ─────────────────────────────────────────────────────
const MediaGallery = ({ attachments }) => {
  const [lightbox, setLightbox] = useState(null);
  if (!attachments || attachments.length === 0) return null;

  const mediaItems = attachments.filter(a => isMedia(a.type));
  const docItems   = attachments.filter(a => !isMedia(a.type));

  return (
    <>
      {/* Lightbox for images/videos */}
      {lightbox !== null && (
        <div onClick={()=>setLightbox(null)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.92)", zIndex:900, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
          {mediaItems[lightbox]?.type.startsWith("video/")
            ? <video src={mediaItems[lightbox].blobUrl || mediaItems[lightbox].dataUrl} controls autoPlay style={{ maxWidth:"100%", maxHeight:"90vh", borderRadius:10 }} onClick={e=>e.stopPropagation()} />
            : <img src={mediaItems[lightbox]?.blobUrl || mediaItems[lightbox]?.dataUrl || mediaItems[lightbox]?.imgUrl || (mediaItems[lightbox]?.driveId ? `https://drive.google.com/thumbnail?id=${mediaItems[lightbox].driveId}&sz=w1200` : "")} alt="" style={{ maxWidth:"100%", maxHeight:"90vh", borderRadius:10, objectFit:"contain" }} onClick={e=>e.stopPropagation()} />
          }
          <button onClick={()=>setLightbox(null)} style={{ position:"absolute", top:"calc(env(safe-area-inset-top, 0px) + 40px)", right:16, background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.3)", borderRadius:"50%", width:40, height:40, color:"white", fontSize:18, cursor:"pointer", zIndex:10 }}>✕</button>
          {mediaItems.length > 1 && <>
            <button onClick={e=>{e.stopPropagation();setLightbox((lightbox-1+mediaItems.length)%mediaItems.length);}} style={{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", background:"rgba(255,255,255,0.08)", border:"none", borderRadius:"50%", width:36, height:36, color:"white", fontSize:18, cursor:"pointer" }}>‹</button>
            <button onClick={e=>{e.stopPropagation();setLightbox((lightbox+1)%mediaItems.length);}} style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"rgba(255,255,255,0.08)", border:"none", borderRadius:"50%", width:36, height:36, color:"white", fontSize:18, cursor:"pointer" }}>›</button>
          </>}
          <div style={{ position:"absolute", bottom:16, left:"50%", transform:"translateX(-50%)", color:"rgba(255,255,255,0.95)", fontSize:14 }}>{mediaItems[lightbox]?.name}</div>
        </div>
      )}

      {/* Image / video grid */}
      {mediaItems.length > 0 && (
        <div style={{ display:"grid", gridTemplateColumns:mediaItems.length===1?"1fr":"1fr 1fr", gap:4, marginTop:8, borderRadius:10, overflow:"hidden" }}>
          {mediaItems.slice(0,4).map((a,i) => (
            <div key={i} onClick={()=>{ if(a.driveUrl) window.open(a.driveUrl,"_blank"); else setLightbox(i); }}
              style={{ position:"relative", cursor:"pointer", aspectRatio:"1", overflow:"hidden", background:"#0f172a" }}>
              {a.type.startsWith("video/") || (!a.blobUrl && !a.dataUrl && !a.driveId && !a.type.startsWith("image/"))
                ? <div style={{ width:"100%", height:"100%", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:4, background:"#1e293b" }}>
                    <span style={{ fontSize:28 }}>{"▶️"}</span>
                    <span style={{ color:"#94a3b8", fontSize:12, textAlign:"center", padding:"0 8px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"100%" }}>{a.name}</span>
                  </div>
                : <>
                  {(!a.blobUrl && !a.dataUrl && !a.imgUrl && a.driveId) && (
                    <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:6, background:"#1e293b", zIndex:1 }}>
                      <div style={{ width:28, height:28, border:"3px solid #334155", borderTopColor:"#6366f1", borderRadius:"50%", animation:"spin 1s linear infinite" }} />
                      <span style={{ color:"#94a3b8", fontSize:11, textAlign:"center" }}>Loading preview…</span>
                    </div>
                  )}
                  <img src={a.blobUrl || a.dataUrl || a.imgUrl || (a.driveId ? `https://drive.google.com/thumbnail?id=${a.driveId}&sz=w600` : "")} data-did={a.driveId||""} data-url={a.driveUrl||""} alt={a.name} style={{ width:"100%", height:"100%", objectFit:"cover", display:"block", position:"relative", zIndex:2 }}
                    onLoad={e=>{ const prev=e.target.previousSibling; if(prev) prev.style.display="none"; }}
                    onError={e=>{const el=e.target;const r=parseInt(el.dataset.r||"0");if(r<10&&el.dataset.did){el.dataset.r=r+1;setTimeout(()=>{el.src=`https://drive.google.com/thumbnail?id=${el.dataset.did}&sz=w600&t=${Date.now()}`;},r<3?5000:r<6?15000:30000);}else{el.style.display="none";const p=el.parentNode;if(p){p.style.background="#1e293b";const d=document.createElement("div");d.style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6;cursor:pointer;z-index:3";d.innerHTML='<span style="font-size:28">☁️</span><span style="color:#94a3b8;font-size:11;text-align:center">Tap to open</span>';d.onclick=()=>window.open(el.dataset.url,"_blank");p.appendChild(d);}}}} />
                </>
              }
              {i===3 && mediaItems.length > 4 && (
                <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,0.55)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                  <span style={{ color:"white", fontSize:22, fontWeight:700 }}>+{mediaItems.length-4}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Document list */}
      {docItems.length > 0 && (
        <div style={{ marginTop:mediaItems.length>0?8:8, display:"flex", flexDirection:"column", gap:5 }}>
          {docItems.map((a,i) => {
            const ft = getFileType(a.type);
            return (
              <a key={i}
                href={a.driveUrl || a.dataUrl || "#"}
                download={a.driveUrl ? undefined : a.name}
                target={a.driveUrl ? "_blank" : undefined}
                rel={a.driveUrl ? "noopener noreferrer" : undefined}
                style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 11px", borderRadius:9, background:ft.bg, border:`1px solid ${ft.color}20`, textDecoration:"none", cursor:"pointer" }}>
                <span style={{ fontSize:20, flexShrink:0 }}>{ft.icon}</span>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ color:"#1e293b", fontSize:15, fontWeight:600, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{a.name}</div>
                  <div style={{ color:"#334155", fontSize:13 }}>{ft.label} · {fmtSize(a.size)}{a.driveId ? " · ☁️ Drive" : ""}</div>
                </div>
                <span style={{ color:ft.color, fontSize:14, fontWeight:700, flexShrink:0 }}>{a.driveUrl ? "↗ Open" : "↓ Download"}</span>
              </a>
            );
          })}
        </div>
      )}
    </>
  );
};

// ─── MENTION TEXTAREA ─────────────────────────────────────────────────────────
const MentionBox = ({ value, onChange, placeholder, users, rows=3, accent="#6366f1" }) => {
  const [show, setShow]   = useState(false);
  const [query, setQuery] = useState("");
  const [atIdx, setAtIdx] = useState(-1);
  const ref = useRef(null);
  const hits = query.length > 0 ? users.filter(u => u.name.toLowerCase().includes(query.toLowerCase())) : [];

  const onCh = (e) => {
    const val = e.target.value;
    onChange(val);
    const before = val.slice(0, e.target.selectionStart);
    const ai = before.lastIndexOf("@");
    if (ai >= 0 && !before.slice(ai).includes(" ")) { setAtIdx(ai); setQuery(before.slice(ai+1)); setShow(true); }
    else setShow(false);
  };
  const pick = (u) => {
    onChange(value.slice(0,atIdx) + `@${u.name} ` + value.slice(ref.current.selectionStart));
    setShow(false); setQuery("");
    setTimeout(() => ref.current?.focus(), 0);
  };
  return (
    <div style={{ position:"relative" }}>
      <textarea ref={ref} value={value} onChange={onCh} placeholder={placeholder} rows={rows}
        style={{ width:"100%", padding:"10px 12px", borderRadius:9, border:"1px solid #e2e8f0", fontSize:16, resize:"none", boxSizing:"border-box", fontFamily:"inherit", outline:"none", color:"#334155", lineHeight:1.5 }} />
      {show && hits.length > 0 && (
        <div style={{ position:"absolute", bottom:"calc(100% + 4px)", left:0, background:"white", border:"1px solid #e2e8f0", borderRadius:10, boxShadow:"0 6px 20px rgba(0,0,0,0.12)", zIndex:400, overflow:"hidden", minWidth:200 }}>
          <div style={{ padding:"5px 10px", background:"#f8fafc", borderBottom:"1px solid #f1f5f9" }}>
            <span style={{ fontSize:12, color:"#334155", fontWeight:700, textTransform:"uppercase", letterSpacing:1 }}>Mention someone</span>
          </div>
          {hits.map(u => (
            <div key={u.id} onClick={() => pick(u)}
              style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 12px", cursor:"pointer", borderBottom:"1px solid #f8fafc", background:"white" }}
              onMouseEnter={e => e.currentTarget.style.background="#f0f4ff"}
              onMouseLeave={e => e.currentTarget.style.background="white"}>
              <div style={{ width:24, height:24, borderRadius:"50%", background:`linear-gradient(135deg,${accent},${accent}99)`, display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:12, fontWeight:700 }}>{u.avatar}</div>
              <div>
                <div style={{ color:"#1e293b", fontSize:15, fontWeight:600 }}>{u.name}</div>
                <div style={{ color:"#334155", fontSize:13 }}>{u.role}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ─── EMAIL BUILDER ────────────────────────────────────────────────────────────
const buildEmail = (tasks, user, company) => {
  const rel    = tasks.filter(t => (Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo]).includes(user.id) || t.createdBy === user.id);
  const missed = rel.filter(t => t.missedDeadline).length;
  const done   = rel.filter(t => t.status === "done").length;
  const prog   = rel.filter(t => t.status === "in_progress").length;
  return {
    subject:`[${company.name}] Task Progress${missed>0?` — ⚠️ ${missed} Missed`:""} · ${done} Done · ${prog} In Progress`,
    body:`Hi ${user.name},\n\nYour daily task summary from ${company.name}:\n\n✅ Completed: ${done}\n🔄 In Progress: ${prog}\n⚠️ Missed: ${missed}\n\nLog in to Tasks Therapy to review your tasks.\n\n— Tasks Therapy · ${company.name}`,
  };
};

// ─── SMALL SHARED COMPONENTS ─────────────────────────────────────────────────
const Av = ({ user, size=28, grad }) => (
  <div style={{ width:size, height:size, borderRadius:"50%", background:grad, display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:size*0.32, fontWeight:700, flexShrink:0 }}>{user?.avatar}</div>
);
const Lbl = ({ ch }) => <p style={{ color:"#334155", fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:1.2, margin:"0 0 6px" }}>{ch}</p>;
const Card = ({ children, mb=10, style={} }) => (
  <div style={{ background:"white", borderRadius:13, padding:14, marginBottom:mb, border:"1px solid #e2e8f0", ...style }}>{children}</div>
);

// ─── STORAGE & BACKUP HELPERS ────────────────────────────────────────────────
const LS = {
  company: "tt_company",
  users:   "tt_users",
  cats:    "tt_cats",
  tasks:   "tt_tasks",
  bkpCfg:  "tt_bkp_cfg",   // { intervalMs, lastBackup, enabled }
  actLog:  "tt_act_log",   // array of log entries
  seenWelcome: "tt_seen_welcome", // first-login welcome popup
  lastWsId: "tt_last_ws_id",     // last loaded workspace id
  lastWsList: "tt_last_ws_list", // cached workspace list
};

const lsGet = (key, fallback) => {
  try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; }
  catch { return fallback; }
};
const lsSet = (key, val) => {
  try { localStorage.setItem(key, JSON.stringify(val)); }
  catch(e) { console.warn("localStorage write failed:", e); }
};

const buildSnapshot = (company, users, cats, tasks, actLog) => ({
  version: 3,
  exportedAt: new Date().toISOString(),
  appName: "Tasks Therapy",
  company, users, cats, tasks, actLog,
});

const triggerDownload = (data, filename) => {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};

const bkpFilename = (companyName) => {
  const d = new Date(), p = n => String(n).padStart(2,"0");
  return `TasksTherapy_${companyName.replace(/\s+/g,"_")}_${d.getFullYear()}${p(d.getMonth()+1)}${p(d.getDate())}_${p(d.getHours())}${p(d.getMinutes())}.json`;
};

const BACKUP_OPTS = [
  { label:"Off",    ms:0          },
  { label:"Hourly", ms:3600000    },
  { label:"Daily",  ms:86400000   },
  { label:"Weekly", ms:604800000  },
];

const DEFAULT_BKP_CFG = { intervalMs:86400000, lastBackup:null, enabled:false };

// ═════════════════════════════════════════════════════════════════════════════
// TOAST NOTIFICATION COMPONENT — persistent until user dismisses
// ═════════════════════════════════════════════════════════════════════════════
const ToastContainer = ({ toasts, onDismiss, onAction }) => {
  if (!toasts || toasts.length === 0) return null;
  return (
    <div style={{ position:"fixed", top:12, left:"50%", transform:"translateX(-50%)", width:"calc(100% - 32px)", maxWidth:460, zIndex:9999, display:"flex", flexDirection:"column", gap:8, pointerEvents:"none" }}>
      {toasts.map(t => {
        const bg = t.type === "error" ? "#fef2f2" : t.type === "success" ? "#f0fdf4" : "#eef2ff";
        const border = t.type === "error" ? "#fecaca" : t.type === "success" ? "#bbf7d0" : "#c7d2fe";
        const color = t.type === "error" ? "#dc2626" : t.type === "success" ? "#15803d" : "#4338ca";
        const icon = t.type === "error" ? "⚠️" : t.type === "success" ? "✅" : "🔔";
        return (
          <div key={t.id} style={{ pointerEvents:"auto", background:bg, border:`1px solid ${border}`, borderRadius:12, padding:"10px 14px", display:"flex", alignItems:"flex-start", gap:10, boxShadow:"0 4px 20px rgba(0,0,0,0.12)", fontFamily:"'Georgia',serif", animation:"slideDown 0.3s ease-out" }}>
            <span style={{ fontSize:18, flexShrink:0, lineHeight:1 }}>{icon}</span>
            <div style={{ flex:1, minWidth:0 }}>
              <p style={{ margin:0, fontSize:14, color, fontWeight:600, lineHeight:1.4 }}>{t.message}</p>
              {t.sub && <p style={{ margin:"2px 0 0", fontSize:12, color:"#64748b", lineHeight:1.3 }}>{t.sub}</p>}
            </div>
            {t.actionLabel && (
              <button onClick={()=>onAction(t)} style={{ background:color, border:"none", borderRadius:7, padding:"4px 10px", color:"white", fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", flexShrink:0, whiteSpace:"nowrap" }}>
                {t.actionLabel}
              </button>
            )}
            <button onClick={()=>onDismiss(t.id)} style={{ background:"none", border:"none", color:"#94a3b8", fontSize:16, cursor:"pointer", padding:"0 2px", flexShrink:0, lineHeight:1 }}>✕</button>
          </div>
        );
      })}
    </div>
  );
};

// Inject toast slide-down animation
if (typeof document !== "undefined" && !document.getElementById("tt-toast-anim")) {
  const s = document.createElement("style");
  s.id = "tt-toast-anim";
  s.textContent = "@keyframes slideDown{from{opacity:0;transform:translateY(-16px)}to{opacity:1;transform:translateY(0)}}";
  document.head.appendChild(s);
}

// ═════════════════════════════════════════════════════════════════════════════
// MAIN APP
// ═════════════════════════════════════════════════════════════════════════════
// ── Deleted-user tracking (prevents Sheet reads from restoring deleted users) ─
const getDeletedIds = () => { try { return new Set(JSON.parse(localStorage.getItem("tt_deleted_ids") || "[]")); } catch(e) { return new Set(); } };
const addDeletedId = (id) => { try { const s = getDeletedIds(); s.add(id); localStorage.setItem("tt_deleted_ids", JSON.stringify([...s])); } catch(e) {} };
const clearDeletedIds = () => { try { localStorage.removeItem("tt_deleted_ids"); } catch(e) {} };

// ── Local Notifications helper (safe for web + Android) ──────────────────────
const getLocalNotifications = () => {
  try { return window.Capacitor?.Plugins?.LocalNotifications || null; } catch(e) { return null; }
};

export default function App() {
  // ── State — seeded from localStorage if available ──────────────────────────
  const [company, setCompany] = useState(() => lsGet(LS.company, SEED_COMPANY));
  const [users,   setUsers]   = useState(() => lsGet(LS.users,   SEED_USERS));
  const [cats,    setCats]    = useState(() => lsGet(LS.cats,     SEED_CATS));
  const [tasks,   setTasks]   = useState(() => lsGet(LS.tasks,    SEED_TASKS));
  const [me,      setMe]      = useState(null);
  const [authMode,setAuthMode]= useState("login");
  const [sel,     setSel]     = useState(null);
  const [actLog,  setActLog]  = useState(() => lsGet(LS.actLog,  []));
  const [bkpCfg,  setBkpCfg] = useState(() => lsGet(LS.bkpCfg,  DEFAULT_BKP_CFG));
  const [showBkp, setShowBkp] = useState(false);
  const [bkpMsg,  setBkpMsg]  = useState("");
  const [showMenu,setShowMenu]= useState(false);   // hamburger sidebar
  const importRef = useRef(null);

  // ── Simulated Google Sync state (preview mode) ────────────────────────────
  const [syncState, setSyncState] = useState("idle");
  const [syncMsg,   setSyncMsg]   = useState("Connected to Google Sheets");
  const [sbHeight,  setSbHeight]  = useState(0); // no native status bar on web
  const [gUser,     setGUser]     = useState(null);
  const [authMode2, setAuthMode2] = useState("choose");
  const [setupForm, setSetupForm] = useState({ name:"", themeIdx:0 });

  // ── Multi-workspace state ─────────────────────────────────────────────────
  const [workspaces,    setWorkspaces]    = useState([]);       // all workspaces for this google user
  const [activeWsId,    setActiveWsId]    = useState(null);     // currently loaded workspace id
  const [showWsSwitcher,setShowWsSwitcher]= useState(false);    // switcher overlay
  const [showAbout,     setShowAbout]     = useState(false);      // about page
  const [showWelcome,   setShowWelcome]   = useState(false);      // first-login welcome popup
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false); // workspace delete confirmation

  // ── Media storage preference ──────────────────────────────────────────────
  const [mediaStorage,  setMediaStorage]  = useState("drive"); // "drive" | "local"

  // ── Simulated Drive folder IDs (preview) ──────────────────────────────────
  const [rootFolderId,  setRootFolderId]  = useState("demo_root_folder_id");
  const [mediaFolderId, setMediaFolderId] = useState("demo_media_folder_id");
  const driveRootUrl  = `https://drive.google.com/drive/folders/${rootFolderId}`;
  const driveMediaUrl = `https://drive.google.com/drive/folders/${mediaFolderId}`;

  // ── Link-account flow (Option A) ─────────────────────────────────────────
  const [linkEmail,    setLinkEmail]    = useState("");
  const [linkErr,      setLinkErr]      = useState("");
  const [linkGUser,    setLinkGUser]    = useState(null); // the google account that signed in
  const [linkSheetId,  setLinkSheetId]  = useState("");    // workspace code from invite
  const isAndroid = /Android/i.test(navigator.userAgent);
  const [showClearConfirm,  setShowClearConfirm]  = useState(false);

  // ── Toast notifications (persistent until dismissed) ──────────────────────
  const [toasts, setToasts] = useState([]);
  const toastIdRef = useRef(0);
  const addToast = (message, type = "info", options = {}) => {
    const id = ++toastIdRef.current;
    setToasts(prev => [{ id, message, type, sub: options.sub || null, actionLabel: options.actionLabel || null, actionData: options.actionData || null }, ...prev].slice(0, 8));
    return id;
  };
  const dismissToast = (id) => setToasts(prev => prev.filter(t => t.id !== id));
  const handleToastAction = (toast) => {
    if (toast.actionData?.taskId) {
      const task = tasks.find(t => t.id === toast.actionData.taskId);
      if (task) setSel(task.id);
    }
    dismissToast(toast.id);
  };

  // ── Safe merge: reads users from Sheet but never restores locally deleted users
  const mergeUsersFromSheet = (sheetParsed) => {
    const deletedIds = getDeletedIds();
    const filtered = sheetParsed.filter(u => !deletedIds.has(u.id));
    setUsers(prev => {
      const sheetMap = new Map(filtered.map(u => [u.email?.toLowerCase(), u]));
      return prev
        .filter(u => !deletedIds.has(u.id))
        .map(u => {
          const s = sheetMap.get(u.email?.toLowerCase());
          if (s) return { ...u, pending: s.pending, googleId: s.googleId || u.googleId };
          return u;
        });
    });
  };

  // ── Invite email state ────────────────────────────────────────────────────
  const [showInviteEmail, setShowInviteEmail] = useState(false);
  const [invEmailTarget,  setInvEmailTarget]  = useState(null); // user obj
  const [invEmailSent,    setInvEmailSent]    = useState(false);
  const [invTab,setInvTab]=useState("existing");

  // ── Create task: inline invite state ──────────────────────────────────────
  const [showQuickInvite, setShowQuickInvite] = useState(false);
  const [quickInvEmail,   setQuickInvEmail]   = useState("");
  const [quickInvRole,    setQuickInvRole]    = useState("staff");
  const [quickInvMsg,     setQuickInvMsg]     = useState("");

  // Read-only pull from Sheet: merge users + tasks, detect @mentions
  // Does NOT write back — auto-sync useEffect handles all writes via debounce
  const simulateSync = async () => {
    setSyncState("syncing"); setSyncMsg("Syncing...");
    try {
      const ws = workspaces.find(w => w.id === activeWsId);
      if (!ws?.sheetId) { setSyncState("idle"); setSyncMsg(""); return; }

      const token = gUser?.accessToken;
      if (!token) { setSyncState("idle"); setSyncMsg(""); return; }

      // READ latest from Sheet — single batchGet for Users + Tasks
      const sheetRes = await fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${ws.sheetId}/values:batchGet?ranges=Users&ranges=Tasks`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!sheetRes.ok) {
        if (sheetRes.status === 401) {
          // Token expired — GIS has no silent refresh, prompt re-sign-in
          setSyncState("error"); setSyncMsg("Session expired — please sign out and sign in again.");
          addToast("Session expired — sign out and sign in again to continue syncing.", "error");
        } else {
          setSyncState("error"); setSyncMsg("Sync failed — check connection");
        }
        return;
      }

      const sheetData = await sheetRes.json();
      const [usersRange, tasksRange] = sheetData.valueRanges || [];

      // Merge Users (pending/googleId — never restore deleted)
      const userRows = usersRange?.values || [];
      if (userRows.length >= 2) {
        const hdrs = userRows[0];
        const sheetParsedUsers = userRows.slice(1).map(row => {
          const o = {}; hdrs.forEach((h, i) => { o[h] = row[i] || ""; });
          if ("pending" in o) o.pending = o.pending===true||o.pending==="true"||o.pending==="TRUE";
          return o;
        });
        mergeUsersFromSheet(sheetParsedUsers);
      }

      // Merge Tasks: pull in comments/updates/statusLog from other users
      const taskRows = tasksRange?.values || [];
      if (taskRows.length >= 2) {
        const tHdrs = taskRows[0];
        const parseF = (val) => { if (!val) return []; try { return JSON.parse(val); } catch { return []; } };
        const sheetTaskMap = {};
        taskRows.slice(1).forEach(row => {
          const obj = {}; tHdrs.forEach((h, i) => { obj[h] = row[i] || ""; });
          if (obj.id) sheetTaskMap[obj.id] = {
            updates: parseF(obj.updates),
            comments: parseF(obj.comments),
            statusLog: parseF(obj.statusLog),
            status: obj.status || "",
            missedDeadline: obj.missedDeadline === "true" || obj.missedDeadline === "TRUE",
            title: obj.title || "",
            deadline: obj.deadline || "",
          };
        });
        // Functional update — always gets the LATEST local state (no stale closure)
        setTasks(prev => {
          let changed = false;
          const next = prev.map(t => {
            const s = sheetTaskMap[t.id];
            if (!s) return t;
            // Preserve local blobUrl/dataUrl thumbnails for media items that came from Sheet
            const withLocalUrls = (sheetItems, localItems) => {
              const localMap = {};
              (localItems||[]).forEach(item => (item.media||[]).forEach(m => { if (m.driveId && (m.blobUrl || m.dataUrl)) localMap[m.driveId] = m.blobUrl || m.dataUrl; }));
              return sheetItems.map(item => ({ ...item, media: (item.media||[]).map(m => localMap[m.driveId] ? { ...m, blobUrl: localMap[m.driveId] } : m) }));
            };
            const mergedUpdates = s.updates.length > (t.updates||[]).length ? withLocalUrls(s.updates, t.updates) : (t.updates||[]);
            const mergedComments = s.comments.length > (t.comments||[]).length ? withLocalUrls(s.comments, t.comments) : (t.comments||[]);
            const mergedStatusLog = s.statusLog.length > (t.statusLog||[]).length ? s.statusLog : (t.statusLog||[]);
            // Use Sheet status if it has more history (another user changed it)
            const mergedStatus = s.statusLog.length > (t.statusLog||[]).length ? s.status : t.status;
            const mergedMissed = s.missedDeadline || t.missedDeadline;
            if (mergedUpdates.length !== (t.updates||[]).length || mergedComments.length !== (t.comments||[]).length || mergedStatusLog.length !== (t.statusLog||[]).length) changed = true;
            return { ...t, updates: mergedUpdates, comments: mergedComments, statusLog: mergedStatusLog, status: mergedStatus, missedDeadline: mergedMissed };
          });
          return changed ? next : prev; // only return new array if something actually changed
        });

        // @mention notification check — uses sheetTaskMap from batchGet (no extra fetch)
        try {
          if (me?.name) {
            const lastCheck = parseInt(localStorage.getItem("tt_last_mention_check") || "0");
            const now = Date.now();
            const myName = me.name.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            const mentionRe = new RegExp(`@${myName}`, "i");
            const mentions = [];
            const newUnreadIds = new Set();
            Object.entries(sheetTaskMap).forEach(([taskId, s]) => {
              const taskTitle = s.title || "a task";
              [...(s.updates || []), ...(s.comments || [])].forEach(item => {
                const itemTime = new Date(item.timestamp).getTime();
                if (itemTime > lastCheck && mentionRe.test(item.message || "")) {
                  const poster = userRows.slice(1).find(r => r[0] === item.userId);
                  const posterName = poster?.[1] || "Someone";
                  mentions.push({ posterName, taskTitle, taskId, deadline: s.deadline || "", time: itemTime });
                  newUnreadIds.add(taskId);
                }
              });
            });
            if (mentions.length > 0) {
              setUnreadMentions(prev => {
                const next = new Set([...prev, ...newUnreadIds]);
                try { localStorage.setItem("tt_unread_mentions", JSON.stringify([...next])); } catch(e) {}
                return next;
              });
              try {
                const existingDetails = JSON.parse(localStorage.getItem("tt_mention_details") || "[]");
                const detailsByTask = {};
                existingDetails.forEach(d => { detailsByTask[d.taskId] = d; });
                mentions.forEach(m => { detailsByTask[m.taskId] = { taskId: m.taskId, taskTitle: m.taskTitle, posterName: m.posterName, deadline: m.deadline }; });
                localStorage.setItem("tt_mention_details", JSON.stringify(Object.values(detailsByTask)));
              } catch(e) {}
              // Toast for new mentions
              mentions.forEach(m => {
                addToast(`${m.posterName} mentioned you in "${m.taskTitle}"`, "info", { sub: m.deadline ? `📋 ${m.taskTitle} · Due: ${new Date(m.deadline).toLocaleDateString("en-GB",{day:"numeric",month:"short",timeZone:"Asia/Singapore"})}` : `📋 ${m.taskTitle}`, actionLabel: "View", actionData: { taskId: m.taskId } });
              });
            }
            localStorage.setItem("tt_last_mention_check", String(now));
          }
        } catch(e) { /* mention check is non-critical — never block sync */ }
      }

      // DO NOT write tasks back here — auto-sync useEffect handles all writes
      // Writing here would use stale closure tasks and overwrite Sheet data
      setSyncState("idle"); setSyncMsg("Saved " + new Date().toLocaleTimeString());
    } catch(e) {
      setSyncState("error"); setSyncMsg("Sync failed — check connection");
    }
  };

  // Simulate Apps Script auto-deploy
  // ── Local Push Notifications ─────────────────────────────────────────────
  const scheduleNotifications = async (notifSettings, taskData, userMe, companyData) => {
    try {
      const LocalNotifications = getLocalNotifications();
      if (!LocalNotifications) return false;
      const perm = await LocalNotifications.requestPermissions();
      if (perm.display !== "granted") return false;
      // Cancel existing Tasks Therapy notifications
      await LocalNotifications.cancel({ notifications: [{ id:1001 }, { id:1002 }] });
      const { morningEnabled, morningTime, eveningEnabled, eveningTime } = notifSettings;
      const now = new Date();
      const toSchedule = [];
      const myTasks = taskData || [];
      const openCount   = myTasks.filter(t=>t.status!=="done").length;
      const overdueCount = myTasks.filter(t=>t.status!=="done"&&t.deadline&&new Date(t.deadline)<now).length;
      const doneCount   = myTasks.filter(t=>t.status==="done").length;
      const inProgCount = myTasks.filter(t=>t.status==="inprogress").length;
      const todayStr = now.toDateString();
      const dueToday = myTasks.filter(t=>{
        if(t.status==="done") return false;
        const d=new Date(t.deadline); d.setHours(0,0,0,0);
        const today=new Date(); today.setHours(0,0,0,0);
        return t.deadline && d.getTime()===today.getTime();
      }).length;

      // Include unread @mention details — stored by simulateSync, cleared when user reads task
      let mentionDetails = [];
      try { mentionDetails = JSON.parse(localStorage.getItem("tt_mention_details") || "[]"); } catch(e) {}
      const mentionCount = mentionDetails.length;
      const mentionSuffix = mentionCount > 0 ? ` · 🔔 ${mentionCount} mention${mentionCount > 1 ? "s" : ""}` : "";
      if (morningEnabled) {
        const [mh, mm] = (morningTime||"08:00").split(":").map(Number);
        const mDate = new Date(); mDate.setHours(mh, mm, 0, 0);
        if (mDate <= now) mDate.setDate(mDate.getDate()+1);
        const morningBody = (overdueCount>0
          ? `⚠️ ${overdueCount} overdue · ${dueToday} due today · ${openCount} open tasks`
          : dueToday>0
            ? `📅 ${dueToday} due today · ${openCount} open tasks · ${inProgCount} in progress`
            : `✅ Nothing due today · ${openCount} open tasks`) + mentionSuffix;
        toSchedule.push({ id:1001, title:`🌅 Good morning, ${userMe?.name?.split(" ")[0]||"there"}! — ${companyData?.name||"Tasks Therapy"}`, body: morningBody, schedule:{ at: mDate, repeats:true, every:"day" }, sound: null, smallIcon: "ic_notification", channelId: "tasks_therapy" });
      }
      if (eveningEnabled) {
        const [eh, em] = (eveningTime||"17:00").split(":").map(Number);
        const eDate = new Date(); eDate.setHours(eh, em, 0, 0);
        if (eDate <= now) eDate.setDate(eDate.getDate()+1);
        const eveningBody = (doneCount>0
          ? `✅ ${doneCount} completed · ${openCount} still open · ${overdueCount>0?`⚠️ ${overdueCount} overdue`:""}`
          : `📋 ${openCount} tasks still open · ${inProgCount} in progress${overdueCount>0?` · ⚠️ ${overdueCount} overdue`:""}`) + mentionSuffix;
        toSchedule.push({ id:1002, title:`🌇 End of Day — ${companyData?.name||"Tasks Therapy"}`, body: eveningBody.trim(), schedule:{ at: eDate, repeats:true, every:"day" }, sound: null, smallIcon: "ic_notification", channelId: "tasks_therapy" });
      }
      if (toSchedule.length > 0) {
        await LocalNotifications.schedule({ notifications: toSchedule });
      }
      return true;
    } catch(e) {
      console.warn("Notification scheduling failed:", e);
      return false;
    }
  };

  const cancelNotifications = async () => {
    try {
      const LN = getLocalNotifications();
      if (LN) await LN.cancel({ notifications: [{ id:1001 }, { id:1002 }] });
    } catch(e) {}
  };

  const theme   = THEMES[company.themeIdx ?? 0] || THEMES[0];
  const grad    = `linear-gradient(135deg,${theme.primary},${theme.secondary})`;
  const headerBg= `linear-gradient(135deg,${theme.dark},${theme.darker})`;

  // auth
  const [lEmail,setLEmail]=useState(""); const [lPass,setLPass]=useState(""); const [lErr,setLErr]=useState("");
  const [reg,setReg]=useState({ name:"",email:"",password:"",confirm:"",role:"staff" }); const [rErr,setRErr]=useState("");

  // panels
  const [showNotif,setShowNotif]=useState(false);
  const [showTaskLog,setShowTaskLog]=useState(false);
  const [notifSched,setNotifSched]=useState(() => { try { const s=JSON.parse(localStorage.getItem("tt_notif_sched")||"null"); return s||{ enabled:true, morningEnabled:true, morningTime:"08:00", eveningEnabled:true, eveningTime:"17:00" }; } catch(e) { return { enabled:true, morningEnabled:true, morningTime:"08:00", eveningEnabled:true, eveningTime:"17:00" }; } });
  const [showCatMgr,setShowCatMgr]=useState(false);
  const [showCreate,setShowCreate]=useState(false);
  const [showInvite,setShowInvite]=useState(false);
  const [showPrefs,setShowPrefs]=useState(false);
  const [showUserMgr,setShowUserMgr]=useState(false);

  // user manager
  const [umPanel,setUmPanel]=useState("list"); // "list"|"add"|"edit"
  const [umEdit,setUmEdit]=useState(null);
  const [umForm,setUmForm]=useState({ name:"",email:"",role:"staff",dept:"Operations" });
  const [umErr,setUmErr]=useState("");

  // search/filter
  const [search,setSearch]=useState(""); const [fSt,setFSt]=useState("all"); const [fCat,setFCat]=useState("all");

  // signature
  const [sigModal,setSigModal]=useState(null); const [sigInput,setSigInput]=useState("");

  // new task
  const [nt,setNt]=useState({ title:"",description:"",priority:"medium",assignedTo:[],supervisorId:"",deadline:"",categoryId:"cat1" });

  // per-task inputs
  const [updIn,setUpdIn]=useState({}); const [comIn,setComIn]=useState({});
  const [updMedia,setUpdMedia]=useState({}); // { [taskId]: [{dataUrl,type,name}] }
  const [comMedia,setComMedia]=useState({}); // { [taskId]: [{dataUrl,type,name}] }

  // new task media
  const [ntMedia,setNtMedia]=useState([]);

  // category manager
  const [catEdit,setCatEdit]=useState(null);    // null = adding new; obj = editing
  const [catForm,setCatForm]=useState({ name:"",color:"#6366f1",icon:"📋" });
  const [catErr,setCatErr]  =useState("");
  const [catPanel,setCatPanel]=useState("list"); // "list" | "form"

  // prefs
  const [pf,setPf]=useState({ name:"",logo:"",themeIdx:0 });
  const logoRef=useRef(null);

  // invite
  const [invEmail,setInvEmail]=useState(""); const [invRole,setInvRole]=useState("staff"); const [invMsg,setInvMsg]=useState("");

  const [notifs,setNotifs]=useState([]);
  const [unreadMentions, setUnreadMentions] = useState(() => {
    try { return new Set(JSON.parse(localStorage.getItem("tt_unread_mentions") || "[]")); }
    catch(e) { return new Set(); }
  });

  useEffect(() => {
    if (!me) return;
    const arr=[];
    const canSeeAll = me.role==="manager"||me.role==="supervisor";
    const supervisorCanSee = me.role === "supervisor";
    tasks.forEach(t => {
      const d    = new Date(t.deadline)-new Date();
      const assignees = Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo].filter(Boolean); const isMe = assignees.includes(me.id), mine=t.createdBy===me.id;
      const asgn = users.find(u=>assignees.includes(u.id));
      const asgnName = asgn?.name || "Unassigned";
      const due = t.deadline ? ` · Due: ${new Date(t.deadline).toLocaleDateString("en-GB",{day:"numeric",month:"short",timeZone:"Asia/Singapore"})}` : "";
      if (t.missedDeadline&&(canSeeAll||supervisorCanSee)) arr.push({id:`m${t.id}`,  type:"missed",  msg:`Missed: "${t.title}" — ${asgnName}${due}`, task:t, time:t.deadline});
      if (d>0&&d<7200000&&t.status!=="done") {
        if (isMe)         arr.push({id:`d${t.id}`, type:"urgent", msg:`Due <2h: "${t.title}"${due}`, task:t, time:new Date().toISOString()});
        if (canSeeAll||supervisorCanSee) arr.push({id:`md${t.id}`,type:"urgent", msg:`Deadline soon: "${t.title}" — ${asgnName}${due}`, task:t, time:new Date().toISOString()});
      }
      if (!(t.updates||[]).length&&t.status==="not_done"&&isMe) arr.push({id:`n${t.id}`,type:"reminder",msg:`No updates on "${t.title}"${due}`,task:t,time:new Date().toISOString()});
      if (t.status==="done"&&(mine||canSeeAll||supervisorCanSee)) arr.push({id:`dn${t.id}`,type:"done",msg:`"${t.title}" completed by ${asgnName}`,task:t,time:(t.statusLog||[]).at(-1)?.timestamp});
    });
    // ── @mention entries — unread mentions from simulateSync ──
    // Stored in tt_mention_details: [{ taskId, taskTitle, posterName, deadline }]
    // Appear in bell panel, clickable to jump directly to the task
    try {
      const mentionDetails = JSON.parse(localStorage.getItem("tt_mention_details") || "[]");
      mentionDetails.forEach(m => {
        if (!unreadMentions.has(m.taskId)) return; // only show unread
        const task = tasks.find(t => t.id === m.taskId);
        if (!task) return; // task must exist to navigate to it
        arr.unshift({ // unshift = mentions appear at top of list
          id: `mention_${m.taskId}`,
          type: "mention",
          msg: `🔔 ${m.posterName} mentioned you in "${m.taskTitle}"${m.deadline ? ` · Due: ${new Date(m.deadline).toLocaleDateString("en-GB",{day:"numeric",month:"short",timeZone:"Asia/Singapore"})}` : ""}`,
          task,
          time: m.time || new Date().toISOString(),
        });
      });
    } catch(e) {}
    setNotifs(arr);
  },[me,tasks,users,company,unreadMentions]);

  // ── Build task log email previews ────────────────────────────────────────
  const buildTaskLog = () => {
    if (!me) return [];
    const now    = new Date();
    const today  = now.toDateString();
    const canSeeAll = me.role==="manager";
    const myTasks = canSeeAll ? tasks
      : me.role==="supervisor" ? tasks.filter(t=>(Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo]).includes(me.id)||t.createdBy===me.id)
      : tasks.filter(t=>(Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo]).includes(me.id));
    const doneToday = myTasks.filter(t=>t.status==="done"&&new Date(t.statusLog?.at(-1)?.timestamp||0).toDateString()===today);
    const overdue   = myTasks.filter(t=>t.missedDeadline||(new Date(t.deadline)<now&&t.status!=="done"));
    const dueToday  = myTasks.filter(t=>new Date(t.deadline).toDateString()===today&&t.status!=="done");
    const inProg    = myTasks.filter(t=>t.status==="in_progress");
    const noUpdate  = myTasks.filter(t=>t.status==="not_done"&&!t.updates?.length);
    const urgent    = myTasks.filter(t=>t.priority==="high"&&t.status!=="done");
    const dateStr   = now.toLocaleDateString("en-US",{weekday:"long",month:"short",day:"numeric"});

    const morningBody = canSeeAll
      ? `Good morning ${me.name},\n\nTeam overview for ${dateStr}:\n\n`
        +`📋 SUMMARY\n  • Open tasks: ${myTasks.filter(t=>t.status!=="done").length}  |  In progress: ${inProg.length}  |  Due today: ${dueToday.length}  |  Overdue: ${overdue.length}\n\n`
        +(overdue.length>0?`⚠️ OVERDUE (${overdue.length})\n${overdue.map(t=>`  • ${t.title} — ${(Array.isArray(t.assignedTo)?t.assignedTo.map(id=>users.find(u=>u.id===id)?.name).filter(Boolean).join(", "):users.find(u=>u.id===t.assignedTo)?.name)||"?"}`).join("\n")}\n\n`:"")
        +(dueToday.length>0?`📅 DUE TODAY (${dueToday.length})\n${dueToday.map(t=>`  • ${t.title} — ${(Array.isArray(t.assignedTo)?t.assignedTo.map(id=>users.find(u=>u.id===id)?.name).filter(Boolean).join(", "):users.find(u=>u.id===t.assignedTo)?.name)||"?"}`).join("\n")}\n\n`:"✅ Nothing due today.\n\n")
        +(noUpdate.length>0?`🔇 NO UPDATES YET (${noUpdate.length})\n${noUpdate.map(t=>`  • ${t.title} — ${(Array.isArray(t.assignedTo)?t.assignedTo.map(id=>users.find(u=>u.id===id)?.name).filter(Boolean).join(", "):users.find(u=>u.id===t.assignedTo)?.name)||"?"}`).join("\n")}\n\n`:"")
        +`— Tasks Therapy · ${company.name}`
      : `Good morning ${me.name},\n\nYour tasks for ${dateStr}:\n\n`
        +`📋 YOUR DAY  |  Assigned: ${myTasks.length}  |  Due today: ${dueToday.length}  |  Overdue: ${overdue.length}\n\n`
        +(overdue.length>0?`⚠️ OVERDUE — action first:\n${overdue.map(t=>`  • ${t.title}`).join("\n")}\n\n`:"")
        +(dueToday.length>0?`📅 DUE TODAY:\n${dueToday.map(t=>`  • ${t.title} [${t.priority}]`).join("\n")}\n\n`:"✅ Nothing due today.\n\n")
        +(urgent.length>0?`🔴 HIGH PRIORITY:\n${urgent.map(t=>`  • ${t.title}`).join("\n")}\n\n`:"")
        +`Have a productive day!\n— Tasks Therapy · ${company.name}`;

    const eodBody = canSeeAll
      ? `Good evening ${me.name},\n\nEnd-of-day report for ${dateStr}:\n\n`
        +`✅ COMPLETED TODAY (${doneToday.length})\n`
        +(doneToday.length>0?doneToday.map(t=>`  • ${t.title} — ${(Array.isArray(t.assignedTo)?t.assignedTo.map(id=>users.find(u=>u.id===id)?.name).filter(Boolean).join(", "):users.find(u=>u.id===t.assignedTo)?.name)||"?"}`).join("\n")+"\n\n":"  (none today)\n\n")
        +`🔄 STILL IN PROGRESS (${inProg.length})\n`
        +(inProg.length>0?inProg.map(t=>`  • ${t.title} — ${(Array.isArray(t.assignedTo)?t.assignedTo.map(id=>users.find(u=>u.id===id)?.name).filter(Boolean).join(", "):users.find(u=>u.id===t.assignedTo)?.name)||"?"}`).join("\n")+"\n\n":"  (none)\n\n")
        +`📅 TOMORROW'S OPEN TASKS (${myTasks.filter(t=>t.status!=="done").length})\n`
        +myTasks.filter(t=>t.status!=="done").slice(0,6).map(t=>`  • ${t.title}`).join("\n")
        +`\n\n— Tasks Therapy · ${company.name}`
      : `Good evening ${me.name},\n\nYour end-of-day summary for ${dateStr}:\n\n`
        +`✅ COMPLETED TODAY\n`
        +(doneToday.length>0?doneToday.map(t=>`  • ${t.title}`).join("\n")+"\n\n":"  (nothing marked done today)\n\n")
        +`📋 CARRY FORWARD TO TOMORROW\n`
        +(myTasks.filter(t=>t.status!=="done").length>0
          ?myTasks.filter(t=>t.status!=="done").map(t=>`  • ${t.title} [${STATUS[t.status]?.label}]`).join("\n")+"\n\n"
          :"  All done — great work! 🎉\n\n")
        +`Remember to update your task status before you log off.\n— Tasks Therapy · ${company.name}`;

    return [
      { id:"log1", type:"morning", subject:`🌅 Morning Briefing — ${dateStr} · ${company.name}`, body:morningBody, to:me.email, scheduled:`${notifSched.morningTime} daily` },
      { id:"log2", type:"evening", subject:`🌇 End-of-Day Report — ${dateStr} · ${company.name}`, body:eodBody,     to:me.email, scheduled:`${notifSched.eveningTime} daily` },
    ];
  };

  // ── Persist to localStorage on every relevant change ─────────────────────
  useEffect(() => { lsSet(LS.company, company); }, [company]);


  useEffect(() => { lsSet(LS.users,   users);   }, [users]);
  useEffect(() => { lsSet(LS.cats,    cats);     }, [cats]);
  useEffect(() => { lsSet(LS.tasks,   tasks);    }, [tasks]);
  useEffect(() => { lsSet(LS.actLog,  actLog);   }, [actLog]);
  useEffect(() => { lsSet(LS.bkpCfg,  bkpCfg);  }, [bkpCfg]);
  useEffect(() => { try { localStorage.setItem("tt_notif_sched", JSON.stringify(notifSched)); } catch(e) {} }, [notifSched]);

  // ── Auto-sync to Google Sheet whenever data changes ───────────────────────
  const syncTimerRef = useRef(null);
  const idleTimerRef = useRef(null);  // auto sign-out after idle
  const idleWarnRef  = useRef(null);  // warning before sign-out
  const [showIdleWarn, setShowIdleWarn] = useState(false);
  const taskRefreshRef = useRef(null);

  // Auto-refresh task detail every 30 seconds so manager sees staff updates quickly
  useEffect(() => {
    if (sel && activeWsId && gUser?.accessToken) {
      taskRefreshRef.current = setInterval(() => { simulateSync(); }, 30000);
    } else {
      if (taskRefreshRef.current) clearInterval(taskRefreshRef.current);
    }
    return () => { if (taskRefreshRef.current) clearInterval(taskRefreshRef.current); };
  }, [sel, activeWsId]); // eslint-disable-line
  useEffect(() => {
    if (!activeWsId || !gUser?.accessToken) return;
    const ws = workspaces.find(w => w.id === activeWsId);
    if (!ws?.sheetId) return;
    // Debounce: wait 3s after last change before syncing
    if (syncTimerRef.current) clearTimeout(syncTimerRef.current);
    syncTimerRef.current = setTimeout(() => {
      setSyncState("syncing"); setSyncMsg("Syncing...");
      syncToSheet(ws.sheetId, { company, users, tasks, cats, attachFolderId: ws.attachFolderId || "" })
        .then(() => { setSyncState("idle"); setSyncMsg("Saved " + new Date().toLocaleTimeString()); })
        .catch(() => { setSyncState("error"); setSyncMsg("Sync failed — check connection. Try signing out and back in."); });
    }, 3000);
    return () => { if (syncTimerRef.current) clearTimeout(syncTimerRef.current); };
  }, [tasks, users, cats, company, activeWsId, gUser]); // eslint-disable-line

  // ── Sync immediately when tab goes to background / pull on foreground ───
  useEffect(() => {
    const handleVisibility = () => {
      if (!activeWsId || !gUser?.accessToken) return;
      const ws = workspaces.find(w => w.id === activeWsId);
      if (!ws?.sheetId) return;
      if (document.visibilityState === "hidden") {
        // Tab going to background — flush writes immediately
        if (syncTimerRef.current) clearTimeout(syncTimerRef.current);
        syncToSheet(ws.sheetId, { company, users, tasks, cats }).catch(() => {});
      } else if (document.visibilityState === "visible") {
        // Tab coming to foreground — pull latest from Sheet
        // simulateSync is now read-only so no write loop
        simulateSync();
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, [tasks, users, cats, company, activeWsId, gUser]); // eslint-disable-line

  // ── Activity logger helper ────────────────────────────────────────────────
  const logActivity = (action, detail="") => {
    const entry = { id:`log${Date.now()}`, ts:new Date().toISOString(), userId:me?.id||"system", userName:me?.name||"System", action, detail };
    setActLog(p => [entry, ...p].slice(0, 200)); // keep last 200 entries
  };

  // ── Backup helpers ────────────────────────────────────────────────────────
  const doBackup = (silent=false) => {
    const snap = buildSnapshot(company, users, cats, tasks, actLog);
    const name = bkpFilename(company.name);
    triggerDownload(snap, name);
    const ts = new Date().toISOString();
    setBkpCfg(p => ({...p, lastBackup:ts}));
    logActivity("backup", name);
    if (!silent) setBkpMsg(`✅ Backup saved: ${name}`);
    return ts;
  };

  // Auto-backup timer
  useEffect(() => {
    if (!bkpCfg.enabled || !bkpCfg.intervalMs) return;
    const check = () => {
      if (!bkpCfg.lastBackup) { doBackup(true); return; }
      const elapsed = Date.now() - new Date(bkpCfg.lastBackup).getTime();
      if (elapsed >= bkpCfg.intervalMs) doBackup(true);
    };
    check(); // run immediately on mount / settings change
    const id = setInterval(check, Math.min(bkpCfg.intervalMs, 3600000)); // check at most every hour
    return () => clearInterval(id);
  }, [bkpCfg.enabled, bkpCfg.intervalMs]); // eslint-disable-line

  // ── Import from JSON ──────────────────────────────────────────────────────
  const doImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (ev) => {
      try {
        const snap = JSON.parse(ev.target.result);
        if (!snap.company || !snap.users || !snap.tasks) throw new Error("Invalid backup file");
        const exportedAt = snap.exportedAt ? new Date(snap.exportedAt).toLocaleString() : "unknown date";
        // Warn before overwriting
        const confirmed = true; // window.confirm not supported on Android WebView
        if (snap.company)  { setCompany(snap.company);  lsSet(LS.company, snap.company);  }
        if (snap.users)    { setUsers(snap.users);       lsSet(LS.users,   snap.users);    }
        if (snap.cats)     { setCats(snap.cats);         lsSet(LS.cats,    snap.cats);     }
        if (snap.tasks)    { setTasks(snap.tasks);       lsSet(LS.tasks,   snap.tasks);    }
        if (snap.actLog)   { setActLog(snap.actLog);     lsSet(LS.actLog,  snap.actLog);   }
        // Push restored data back to the Google Sheet (overwrite)
        const bkpWs = workspaces.find(w => w.id === activeWsId);
        await syncToSheet(bkpWs?.sheetId || activeWsId, {
          company: snap.company,
          users: snap.users,
          tasks: snap.tasks,
          cats: snap.cats || [],
        });
        setBkpMsg(`✅ Restore complete — Google Sheet updated with data from ${exportedAt}`);
        setMe(null); // force re-login after restore
      } catch(err) {
        setBkpMsg(`❌ Import failed: ${err.message}`);
      }
    };
    reader.readAsText(file);
    e.target.value = "";
  };

  // ── Clear all data ────────────────────────────────────────────────────────
  const clearAllData = async () => {
    localStorage.setItem("tt_signed_out", "1"); // set FIRST before state changes
    // Delete Tasks Therapy folder + index file from Drive (full factory reset)
    try {
      const token = gUser?.accessToken;
      if (token) {
        // Delete the index JSON file
        const idxRes = await fetch(
          "https://www.googleapis.com/drive/v3/files?q=name%3D'tasks-therapy-index.json'+and+trashed%3Dfalse&fields=files(id)",
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const idxData = await idxRes.json();
        for (const file of (idxData.files || [])) {
          await fetch(`https://www.googleapis.com/drive/v3/files/${file.id}`,
            { method: "DELETE", headers: { Authorization: `Bearer ${token}` } });
        }
        // Delete the Tasks Therapy parent folder (contains all workspace folders + Sheets)
        const folderRes = await fetch(
          "https://www.googleapis.com/drive/v3/files?q=name%3D'Tasks%20Therapy'+and+mimeType%3D'application%2Fvnd.google-apps.folder'+and+trashed%3Dfalse&fields=files(id)",
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const folderData = await folderRes.json();
        for (const folder of (folderData.files || [])) {
          await fetch(`https://www.googleapis.com/drive/v3/files/${folder.id}`,
            { method: "DELETE", headers: { Authorization: `Bearer ${token}` } });
        }
      }
    } catch(e) {}
    // Clear all local storage
    Object.keys(localStorage).forEach(k => { if (k.startsWith("tt_")) localStorage.removeItem(k); });
    localStorage.setItem("tt_signed_out", "1");
    setCompany(SEED_COMPANY); setUsers(SEED_USERS); setCats(SEED_CATS);
    setTasks(SEED_TASKS); setActLog([]); setBkpCfg(DEFAULT_BKP_CFG);
    setMe(null); setGUser(null); setWorkspaces([]); setActiveWsId(null);
    setShowMenu(false); setShowPrefs(false); setShowBkp(false);
    setAuthMode2("choose");
    try { window.google?.accounts?.id?.disableAutoSelect(); } catch(e) {}
  };

  // ── Auth
  const doLogin = () => {
    const u=users.find(x=>x.email.toLowerCase()===lEmail.toLowerCase()&&x.pw===lPass);
    if(u){setMe(u);setLErr("");}else setLErr("Invalid email or password.");
  };
  const doReg = () => {
    if(!reg.name||!reg.email||!reg.password) return setRErr("All fields are required.");
    if(reg.password!==reg.confirm) return setRErr("Passwords don't match.");
    if(users.find(u=>u.email.toLowerCase()===reg.email.toLowerCase())) return setRErr("Email already registered.");
    const nu={id:`u${Date.now()}`,name:reg.name.trim(),email:reg.email.trim(),pw:reg.password,role:reg.role,avatar:mkAvatar(reg.name),dept:"Operations"};
    setUsers(p=>[...p,nu]); setMe(nu);
  };

  // ── Status
  const changeStatus=(tid,ns)=>{setSigModal({tid,ns});setSigInput("");};
  const confirmSig=()=>{
    if(!sigInput.trim())return;
    const task=tasks.find(t=>t.id===sigModal.tid);
    setTasks(p=>p.map(t=>t.id!==sigModal.tid?t:{...t,status:sigModal.ns,missedDeadline:sigModal.ns==="done"?false:t.missedDeadline,statusLog:[...t.statusLog,{status:sigModal.ns,timestamp:new Date().toISOString(),userId:me.id,signature:sigInput}]}));
    if(sigModal.ns==="done"&&task?.recurrence&&task.recurrence!=="none") setTimeout(()=>spawnNextOccurrence(task),150);
    logActivity("status_changed", `"${task?.title}" → ${STATUS[sigModal.ns].label}`);
    simulateSync();
    setSigModal(null);
  };

  // ── Updates / Comments
  const addUpd=(tid)=>{
    const m=(updIn[tid]||"").trim(), media=updMedia[tid]||[];
    if(!m&&!media.length)return;
    setTasks(p=>p.map(t=>t.id!==tid?t:{...t,updates:[...t.updates,{id:`u${Date.now()}`,userId:me.id,message:m,media,timestamp:new Date().toISOString(),localTimestamp:new Date().toLocaleString("en-GB",{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit",timeZoneName:"short",timeZone:"Asia/Singapore"}),type:"progress"}]}));
    setUpdIn(p=>({...p,[tid]:""})); setUpdMedia(p=>({...p,[tid]:[]}));
  };
  const addCom=(tid)=>{
    const m=(comIn[tid]||"").trim(), media=comMedia[tid]||[];
    if(!m&&!media.length)return;
    setTasks(p=>p.map(t=>t.id!==tid?t:{...t,comments:[...(t.comments||[]),{id:`c${Date.now()}`,userId:me.id,message:m,media,timestamp:new Date().toISOString(),localTimestamp:new Date().toLocaleString("en-GB",{day:"2-digit",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit",timeZoneName:"short",timeZone:"Asia/Singapore"})}]}));
    setComIn(p=>({...p,[tid]:""})); setComMedia(p=>({...p,[tid]:[]}));
  };

  // ── Task creation
  const createTask=()=>{
    if(!nt.title||!nt.assignedTo.length||!nt.deadline)return;
    const tid=`t${Date.now()}`;
    const newTask = { id:tid, ...nt, media:ntMedia, createdBy:me.id, createdAt:new Date().toISOString(),
      status:"not_done", updates:[], comments:[],
      statusLog:[{status:"not_done",timestamp:new Date().toISOString(),userId:me.id,signature:me.name}],
      remindersSent:{staff:false,manager:false}, missedDeadline:false,
      recurrence:nt.recurrence||"none", recurParentId:null,
    };
    const updatedTasks = [newTask, ...tasks];
    setTasks(updatedTasks);
    logActivity("task_created", nt.title+(nt.recurrence&&nt.recurrence!=="none"?` (🔁 ${RECUR_OPTIONS.find(r=>r.value===nt.recurrence)?.short})`:""));
    // Write to Sheet immediately with the correct tasks array — no stale closure
    const ws = workspaces.find(w => w.id === activeWsId);
    if (ws?.sheetId) syncToSheet(ws.sheetId, { company, users, tasks: updatedTasks, cats }).catch(()=>{});
    setShowCreate(false);
    setNt({title:"",description:"",priority:"medium",assignedTo:[],supervisorId:"",deadline:"",categoryId:cats[0]?.id||"cat1",recurrence:"none"});
    setNtMedia([]);
  };

  // ── Spawn next occurrence when a recurring task is marked done ─────────────
  const spawnNextOccurrence=(task)=>{
    if(!task.recurrence||task.recurrence==="none")return;
    const nextDeadline=nextRecurDeadline(task.recurrence, task.deadline);
    const next={
      id:`t${Date.now()}`, title:task.title, description:task.description,
      priority:task.priority, assignedTo:Array.isArray(task.assignedTo)?task.assignedTo:[task.assignedTo].filter(Boolean), categoryId:task.categoryId,
      recurrence:task.recurrence, recurParentId:task.recurParentId||task.id,
      deadline:nextDeadline.toISOString(), createdBy:task.createdBy,
      createdAt:new Date().toISOString(), status:"not_done",
      updates:[], comments:[], media:[],
      statusLog:[{status:"not_done",timestamp:new Date().toISOString(),userId:me.id,signature:me.name}],
      remindersSent:{staff:false,manager:false}, missedDeadline:false,
    };
    setTasks(p=>[next,...p]);
    logActivity("task_spawned",`🔁 Next: "${task.title}" → ${nextDeadline.toLocaleDateString()}`);
  };

  // ── Delete task (manager/supervisor, done tasks only prompt; any task possible with confirm)
  const [delModal, setDelModal]   = useState(null); // { taskId, title, hasMedia, mediaCount }
  const confirmDeleteTask = () => {
    if (!delModal) return;
    const updatedTasks = tasks.filter(t => t.id !== delModal.taskId);
    setTasks(updatedTasks);
    logActivity("task_deleted", delModal.title);
    setDelModal(null);
    setSel(null);
    const ws = workspaces.find(w => w.id === activeWsId);
    if (ws?.sheetId) syncToSheet(ws.sheetId, { company, users, tasks: updatedTasks, cats }).catch(()=>{});
  };

  // ── Category CRUD
  const openNewCat  = () => { setCatEdit(null);  setCatForm({name:"",color:"#6366f1",icon:"📋"}); setCatErr(""); setCatPanel("form"); };
  const openEditCat = (cat) => { setCatEdit(cat); setCatForm({name:cat.name,color:cat.color,icon:cat.icon||"📋"}); setCatErr(""); setCatPanel("form"); };
  const saveCat = () => {
    if (!catForm.name.trim()) return setCatErr("Category name is required.");
    const dup = cats.find(c => c.name.toLowerCase()===catForm.name.trim().toLowerCase() && c.id!==catEdit?.id);
    if (dup) return setCatErr("A category with that name already exists.");
    if (catEdit) {
      setCats(p=>p.map(c=>c.id===catEdit.id?{...c,name:catForm.name.trim(),color:catForm.color,icon:catForm.icon}:c));
    } else {
      setCats(p=>[...p,{id:`cat${Date.now()}`,name:catForm.name.trim(),color:catForm.color,icon:catForm.icon}]);
    }
    setCatEdit(null); setCatPanel("list"); setCatErr("");
  };
  const delCat = (id) => {
    const n = tasks.filter(t=>t.categoryId===id).length;
    if (n>0) return alert(`Cannot delete — ${n} task(s) use this category. Reassign them first.`);
    const updatedCats = cats.filter(c=>c.id!==id);
    setCats(updatedCats);
    if (fCat===id) setFCat("all");
    const ws = workspaces.find(w => w.id === activeWsId);
    if (ws?.sheetId) syncToSheet(ws.sheetId, { company, users, tasks, cats: updatedCats }).catch(()=>{});
  };

  // ── Prefs
  const openPrefs = () => { setPf({name:company.name,logo:company.logo,themeIdx:company.themeIdx||0}); setShowPrefs(true); };
  const savePrefs = () => {
    const newCompany = {name:pf.name||company.name, logo:pf.logo, themeIdx:pf.themeIdx};
    setCompany(newCompany);
    // Save logo separately — too large for the main company object in some cases
    if (pf.logo) { try { localStorage.setItem("tt_company_logo", pf.logo); } catch(e) { console.warn("Logo too large for localStorage:", e); } }
    if (notifSched.enabled) scheduleNotifications(notifSched, tasks, me, newCompany);
    else cancelNotifications();
    // Sync company changes to Sheet immediately (logo excluded if too large — handled by makeRows)
    const ws = workspaces.find(w => w.id === activeWsId);
    if (ws?.sheetId) syncToSheet(ws.sheetId, { company: newCompany, users, tasks, cats }).catch(()=>{});
    // Update workspace name in local list AND Drive index so it persists after sign-out/sign-in
    if (pf.name && pf.name !== company.name) {
      const updatedWs = workspaces.map(w => w.id === activeWsId ? {...w, name: pf.name} : w);
      setWorkspaces(updatedWs);
      try { localStorage.setItem("tt_last_ws_list", JSON.stringify(updatedWs)); } catch(e) {}
      saveWorkspaceIndex(updatedWs, gUser).catch(()=>{});
    }
    setShowPrefs(false);
  };
  // ── Central sign-out function — resets all state cleanly ─────────────────
  const doSignOut = async (preserveWsList = true) => {
    try { localStorage.setItem("tt_signed_out", "1"); } catch(e) {} // set FIRST
    // 1. Save data first
    try {
      const ws = workspaces.find(w => w.id === activeWsId);
      if (ws?.sheetId) await syncToSheet(ws.sheetId, {company, users, tasks, cats});
    } catch(e) {}
    // 2. Clear localStorage — keep workspace list, welcome flag, and company logo
    try {
      const wsList = preserveWsList ? localStorage.getItem("tt_last_ws_list") : null;
      const seenWelcome = localStorage.getItem("tt_seen_welcome");
      const savedLogo = localStorage.getItem("tt_company_logo");
      Object.keys(localStorage).forEach(k => { if (k.startsWith("tt_")) localStorage.removeItem(k); });
      if (wsList) localStorage.setItem("tt_last_ws_list", wsList);
      if (seenWelcome) localStorage.setItem("tt_seen_welcome", seenWelcome);
      if (savedLogo) localStorage.setItem("tt_company_logo", savedLogo);
      localStorage.setItem("tt_signed_out", "1"); // prevent auto-restore on resume
    } catch(e) {}
    clearDeletedIds(); // fresh start on sign out
    // 3. Disable Google auto-select
    try { window.google?.accounts?.id?.disableAutoSelect(); } catch(e) {}
    // 4. Reset all React state
    setMe(null);
    setGUser(null);
    setWorkspaces([]);
    setActiveWsId(null);
    setCompany(SEED_COMPANY);
    setUsers(SEED_USERS);
    setTasks(SEED_TASKS);
    setCats(SEED_CATS);
    setShowMenu(false);
    setShowPrefs(false);
    setShowWsSwitcher(false);
    setShowDeleteConfirm(false);
    setAuthMode2("choose");
  };

  const onLogo = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    const img = new Image();
    const objectUrl = URL.createObjectURL(f);
    img.onload = () => {
      const MAX = 120;
      const ratio = Math.min(MAX / img.width, MAX / img.height, 1);
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * ratio);
      canvas.height = Math.round(img.height * ratio);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      const compressed = canvas.toDataURL("image/png", 0.8);
      setPf(p => ({ ...p, logo: compressed }));
      URL.revokeObjectURL(objectUrl);
    };
    img.src = objectUrl;
  };

  // ── Invite
  const sendInvite=()=>{
    if(!invEmail.trim())return;
    if(users.find(u=>u.email.toLowerCase()===invEmail.toLowerCase())){setInvMsg("⚠️ Email already registered.");return;}
    const newUser={id:`u${Date.now()}`,name:invEmail.split("@")[0],email:invEmail.trim(),pw:"",role:invRole,avatar:invEmail.slice(0,2).toUpperCase(),dept:"Operations",pending:true};
    const updatedUsers1 = [...users, newUser];
    setUsers(updatedUsers1);
    // Sync immediately with full updated list so pending:true reaches the Sheet
    const ws1 = workspaces.find(w=>w.id===activeWsId);
    if (ws1?.sheetId) syncToSheet(ws1.sheetId, {company, users:updatedUsers1, tasks, cats}).catch(()=>{});
    setInvEmailTarget(newUser);
    setInvEmailSent(false);
    setInvMsg(`✅ User added! Now send them an email invite so they know how to sign in.`);
    setInvEmail("");
  };

  // Build the invite email body
  const buildInviteEmail = (targetUser) => {
    const appUrl = "https://play.google.com/store/apps/details?id=com.tasktherapy.app";
    const ws = workspaces.find(w=>w.id===activeWsId);
    const subject = `You're invited to join ${company.name} on Tasks Therapy`;
    const body = `Hi ${targetUser?.name || "there"},

${me?.name} has invited you to join ${company.name}'s task management app — Tasks Therapy.

━━━━━━━━━━━━━━━━━━━━━━
HOW TO GET STARTED
━━━━━━━━━━━━━━━━━━━━━━

1. Download the app:
   ${appUrl}

2. Open the app and sign in with this Google account:
   ${targetUser?.email}

3. When asked to choose a workspace, tap "Join existing workspace"

4. Enter this Workspace Code:
   ${ws?.sheetId || "Ask your manager for the workspace code"}

5. You'll be taken straight to the ${company.name} workspace.

━━━━━━━━━━━━━━━━━━━━━━
INSTALL ON YOUR ANDROID PHONE
━━━━━━━━━━━━━━━━━━━━━━

• Download from Google Play using the link above
• Install and open the app
• Sign in with your Google account

━━━━━━━━━━━━━━━━━━━━━━

Your role: ${targetUser?.role?.toUpperCase() || "STAFF"}
Company: ${company.name}

If you have any trouble signing in, reply to this email.

— ${me?.name}
${company.name} · Powered by Tasks Therapy`;
    return { subject, body };
  };

  // Share invite via native Android share sheet (like Slack / WhatsApp share)
  const openMailInvite = async (targetUser) => {
    const { subject, body } = buildInviteEmail(targetUser);
    try {
      // navigator.share opens the native Android share sheet — Gmail, WhatsApp, Telegram, etc.
      await navigator.share({ title: subject, text: body });
    } catch(e) {
      // User cancelled or share not supported — copy to clipboard as fallback
      try { await navigator.clipboard.writeText(body); }
      catch(e2) {}
      alert("Invite message copied! Paste it into Gmail, WhatsApp, or any messaging app.");
    }
    setInvEmailSent(true);
  };

  // Quick invite from create task panel
  const doQuickInvite = () => {
    if (!quickInvEmail.trim()) return;
    if (users.find(u=>u.email.toLowerCase()===quickInvEmail.toLowerCase())) { setQuickInvMsg("⚠️ Already in the system — select them in the dropdown above."); return; }
    const newUser = { id:`u${Date.now()}`, name:quickInvEmail.split("@")[0], email:quickInvEmail.trim(), pw:"", role:quickInvRole, avatar:quickInvEmail.slice(0,2).toUpperCase(), dept:"Operations", pending:true };
    const updatedUsers2 = [...users, newUser];
    setUsers(updatedUsers2);
    const ws2 = workspaces.find(w=>w.id===activeWsId);
    if (ws2?.sheetId) syncToSheet(ws2.sheetId, {company, users:updatedUsers2, tasks, cats}).catch(()=>{});
    setNt(p=>({...p,assignedTo:[newUser.id]}));
    openMailInvite(newUser);
    setQuickInvMsg(`✅ ${newUser.name} added & invite email opened! They're now selected as assignee.`);
    setShowQuickInvite(false);
    setQuickInvEmail("");
  };

  // ── User Manager CRUD (manager only)
  const openAddUser  = () => { setUmEdit(null); setUmForm({name:"",email:"",role:"staff",dept:"Operations"}); setUmErr(""); setUmPanel("add"); };
  const openEditUser = (u) => { setUmEdit(u); setUmForm({name:u.name,email:u.email,role:u.role,dept:u.dept||"Operations"}); setUmErr(""); setUmPanel("edit"); };
  const saveUser = () => {
    if (!umForm.name.trim()||!umForm.email.trim()) return setUmErr("Name and Google email are required.");
    const dup = users.find(u=>u.email.toLowerCase()===umForm.email.trim().toLowerCase()&&u.id!==umEdit?.id);
    if (dup) return setUmErr("This Google email is already registered.");
    if (umEdit) {
      setUsers(p=>p.map(u=>u.id!==umEdit.id?u:{...u,name:umForm.name.trim(),email:umForm.email.trim(),role:umForm.role,dept:umForm.dept,avatar:mkAvatar(umForm.name)}));
      if (me.id===umEdit.id) setMe(p=>({...p,name:umForm.name.trim(),email:umForm.email.trim(),role:umForm.role,dept:umForm.dept,avatar:mkAvatar(umForm.name)}));
      logActivity("user_updated", umForm.name);
      setUmPanel("list"); setUmEdit(null); setUmErr("");
    } else {
      const newU = {id:`u${Date.now()}`,name:umForm.name.trim(),email:umForm.email.trim(),pw:"",role:umForm.role,avatar:mkAvatar(umForm.name),dept:umForm.dept||"Operations",pending:true};
      const updatedUsers3 = [...users, newU];
      setUsers(updatedUsers3);
      const ws3 = workspaces.find(w=>w.id===activeWsId);
      if (ws3?.sheetId) syncToSheet(ws3.sheetId, {company, users:updatedUsers3, tasks, cats}).catch(()=>{});
      logActivity("user_added", umForm.name);
      setUmPanel("list"); setUmEdit(null); setUmErr("");
      // Open share invite immediately after adding
      openMailInvite(newU);
    }
  };
  const deleteUser = async (uid) => {
    if (uid===me.id) { setSyncMsg("You cannot delete your own account."); setSyncState("error"); return; }
    if (tasks.some(t=>(Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo]).includes(uid))) { setSyncMsg("Cannot delete — user has tasks assigned. Reassign them first."); setSyncState("error"); return; }
    const u=users.find(x=>x.id===uid);
    logActivity("user_removed", u?.name||uid);
    const updatedUsers = users.filter(x=>x.id!==uid);
    addDeletedId(uid);
    setUsers(updatedUsers);
    const ws = workspaces.find(w=>w.id===activeWsId);
    if (ws?.sheetId) {
      setSyncState("syncing"); setSyncMsg("Removing user…");
      try {
        await syncToSheet(ws.sheetId, { company, users: updatedUsers, tasks, cats });
        setSyncState("idle"); setSyncMsg("Saved " + new Date().toLocaleTimeString());
      } catch(e) {
        setSyncState("error"); setSyncMsg("Delete sync failed — try again.");
      }
    }
  };

  // ── Filters
  const canSeeAll = me?.role==="manager";
  const canManageTasks = me?.role==="manager"||me?.role==="supervisor"; // create/edit/delete tasks
  const myTasks = me ? (
    canSeeAll ? tasks
    : me.role==="supervisor" ? tasks.filter(t=>(Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo]).includes(me.id)||t.createdBy===me.id)
    : tasks.filter(t=>(Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo]).includes(me.id))
  ) : [];
  const filtered = myTasks.filter(t=>{
    const q=search.toLowerCase(), cat=cats.find(c=>c.id===t.categoryId), asgnIds=Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo].filter(Boolean), asgn=users.find(u=>u.id===asgnIds[0]);
    return (!q||[t.title,t.description,asgn?.name||"",cat?.name||""].some(s=>s.toLowerCase().includes(q)))
      &&(fSt==="all"||t.status===fSt)&&(fCat==="all"||t.categoryId===fCat);
  });
  const getCat=(id)=>cats.find(c=>c.id===id);
  const stats={total:myTasks.length,done:myTasks.filter(t=>t.status==="done").length,prog:myTasks.filter(t=>t.status==="in_progress").length,missed:myTasks.filter(t=>t.missedDeadline).length};

  // shared style helpers
  const inp = { width:"100%", padding:"10px 12px", borderRadius:9, border:"1px solid #e2e8f0", fontSize:16, boxSizing:"border-box", fontFamily:"inherit", outline:"none", color:"#334155" };
  const lbl = { color:"#334155", fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:1.2, display:"block", marginBottom:5 };
  const BtnPrimary = ({ch,onClick,style={}}) => <button onClick={onClick} style={{ background:grad, border:"none", borderRadius:10, color:"white", fontSize:16, fontWeight:700, cursor:"pointer", fontFamily:"inherit", padding:"11px 0", ...style }}>{ch}</button>;

  // ── Sync status bar (simulated) ──────────────────────────────────────────
  const SyncBar = () => (
    <div style={{ position:"sticky", top:0, zIndex:60 }}>
      {/* Dark safe-area cap — keeps phone status bar icons visible */}
      <div style={{ background:theme.darker, height:sbHeight }} />
      <div style={{ display:"flex", alignItems:"center", gap:8, padding:"5px 16px", background:syncState==="error"?"#fef2f2":syncState==="syncing"?"#fffbeb":"#f0fdf4", borderBottom:"1px solid #e2e8f0" }}>
      <span style={{ fontSize:14 }}>{syncState==="syncing"?"⏳":syncState==="error"?"❌":"✅"}</span>
      <span style={{ fontSize:13, color:syncState==="error"?"#ef4444":syncState==="syncing"?"#d97706":"#10b981", flex:1 }}>
        {syncState==="syncing"?"Syncing to Google Sheets…":syncMsg}
      </span>
      {gUser && null}
      <button onClick={simulateSync} style={{ fontSize:12, color:"#334155", background:"none", border:"1px solid #e2e8f0", borderRadius:5, padding:"2px 7px", cursor:"pointer", fontFamily:"inherit" }}>↺ Sync</button>
    </div>
    </div>
  );

  // ── Signature modal (shared)
  const SigModal = () => !sigModal ? null : (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:500, display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
      <div style={{ background:"white", borderRadius:"20px 20px 0 0", padding:26, width:"100%", maxWidth:560, boxSizing:"border-box", fontFamily:"'Georgia',serif", fontSize:16, paddingBottom:"max(26px, calc(26px + env(safe-area-inset-bottom)))" }}>
        <h3 style={{ margin:"0 0 6px", color:"#1e293b", fontSize:17 }}>Confirm Status Change</h3>
        <p style={{ color:"#334155", fontSize:16, margin:"0 0 14px" }}>Changing to <strong style={{ color:STATUS[sigModal.ns].color }}>{STATUS[sigModal.ns].label}</strong>. Sign to confirm.</p>
        <label style={lbl}>Your Signature</label>
        <input value={sigInput} onChange={e=>setSigInput(e.target.value)} placeholder="Type your full name"
          autoFocus
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="words"
          onBlur={e=>{ e.preventDefault(); e.target.focus(); }}
          style={{ ...inp, fontStyle:"italic", fontSize:17, border:`1.5px solid ${theme.primary}`, marginBottom:14 }} />
        <div style={{ display:"flex", gap:10 }}>
          <button onClick={()=>setSigModal(null)} style={{ flex:1, padding:11, borderRadius:10, border:"1px solid #e2e8f0", background:"white", color:"#334155", fontSize:16, cursor:"pointer", fontFamily:"inherit" }}>Cancel</button>
          <button onClick={confirmSig} disabled={!sigInput.trim()} style={{ flex:2, padding:11, borderRadius:10, border:"none", background:sigInput.trim()?grad:"#e2e8f0", color:sigInput.trim()?"white":"#94a3b8", fontSize:16, fontWeight:700, cursor:sigInput.trim()?"pointer":"not-allowed", fontFamily:"inherit" }}>✍️ Confirm & Sign</button>
        </div>
      </div>
    </div>
  );

  // ══════════════════════════════════════════════════════════════════════════
  // AUTH SCREEN
  // ══════════════════════════════════════════════════════════════════════════


  // ── First-login welcome popup ─────────────────────────────────────────────
  const WelcomePopup = () => {
    if (!showWelcome) return null;
    const dismiss = () => {
      lsSet(LS.seenWelcome, true);
      setShowWelcome(false);
    };
    return (
      <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:700, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
        <div style={{ background:"white", borderRadius:20, padding:28, width:"100%", maxWidth:360, boxSizing:"border-box", fontFamily:"inherit", textAlign:"center", boxShadow:"0 24px 60px rgba(0,0,0,0.25)" }}>

          {/* Logo */}
          <img src={APP_LOGO_B64} alt="Tasks Therapy"
            style={{ width:64, height:64, objectFit:"contain", marginBottom:14,
              filter:"invert(35%) sepia(80%) saturate(500%) hue-rotate(210deg)" }} />

          {/* Title */}
          <h2 style={{ margin:"0 0 6px", fontSize:18, color:"#1e293b", fontWeight:700 }}>
            Welcome to Tasks Therapy! 👋
          </h2>
          <p style={{ margin:"0 0 20px", fontSize:16, color:"#334155", lineHeight:1.6 }}>
            New here? Learn how to get the most out of the app — from creating tasks and inviting your team, to understanding your role and keeping your data safe.
          </p>

          {/* Tip box */}
          <div style={{ display:"flex", alignItems:"flex-start", gap:10, padding:"11px 14px", borderRadius:11, background:"#f0fdf4", border:"1px solid #bbf7d0", marginBottom:20, textAlign:"left" }}>
            <span style={{ fontSize:16, flexShrink:0 }}>💡</span>
            <p style={{ margin:0, fontSize:14, color:"#166534", lineHeight:1.6 }}>
              Go to <strong>☰ Menu → ℹ️ About App</strong> anytime to read the full guide, FAQs, and contact support.
            </p>
          </div>

          {/* Buttons */}
          <button onClick={()=>{ dismiss(); setShowAbout(true); }}
            style={{ width:"100%", padding:"12px", borderRadius:12, border:"none", background:`linear-gradient(135deg,${theme.primary},${theme.secondary})`, color:"white", fontSize:16, fontWeight:700, cursor:"pointer", fontFamily:"inherit", marginBottom:9 }}>
            📖 Read the Guide Now
          </button>
          <button onClick={dismiss}
            style={{ width:"100%", padding:"11px", borderRadius:12, border:"1px solid #e2e8f0", background:"white", color:"#334155", fontSize:16, cursor:"pointer", fontFamily:"inherit" }}>
            I'll explore on my own
          </button>

        </div>
      </div>
    );
  };

  // ── About App page ───────────────────────────────────────────────────────
  const AboutPage = () => {
    const [open, setOpen] = useState(null);
    if (!showAbout) return null;

    const DEV_LOGO_B64 = "data:image/png;base64,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";
const APP_VERSION = "1.1.35";
    const SUPPORT_EMAIL = "taskstherapy@the2457design.com";
const PRIVACY_URL = "https://apps.the2457design.com/#privacy";

    const sections = [
      {
        id:"about", icon:null, title:"What is Tasks Therapy?",  // icon:null = use logo image
        content: `Tasks Therapy is a simple, secure team task manager designed for small to medium teams. Managers create and assign tasks, supervisors track their work, and staff update their progress — all in one place.\n\nThere's no complex setup. Everything syncs automatically through your Google account, so your whole team stays on the same page without needing a separate server or IT support.`
      },
      {
        id:"workspace", icon:"🏢", title:"What is a workspace?",
        content: `A workspace is a self-contained environment for one company or project. Each workspace has its own tasks, users, categories, and settings — completely separate from any other workspace.\n\nUnder the hood, each workspace is a single Google Sheet stored in the Manager's Google Drive. Everything your team does is saved there.\n\nOne Google account, multiple workspaces\nYou can belong to more than one workspace with the same Google account. For example, you might be a Manager in your own company and a Staff member in a client's project. Each workspace is independent and your role can be different in each one.\n\nSwitching between workspaces\n→ Tap your company name in the dashboard header, or\n→ Go to ☰ Menu → Switch Workspace\nThe app loads the selected workspace instantly — no need to sign in again.\n\nCreating a new workspace\nAnyone can create their own workspace — you don't need to be a Manager elsewhere. Go to ☰ Menu → ＋ New Workspace. You will automatically become the Manager of any workspace you create.\n\nJoining a workspace\nYou join a workspace by invitation only. A Manager adds your email address and sends you an invite. On first sign-in, the app finds your workspace automatically. If your Google email is different from your invite email, tap "I was invited" and enter the email your manager used.`
      },
      {
        id:"data", icon:"📊", title:"How your data is stored",
        content: `Your tasks, users, and settings are stored in a Google Sheet that lives in your own Google Drive — not on our servers. This means:\n\n• You own your data completely\n• You can open the Sheet directly in Google Sheets anytime\n• If you stop using the app, your data is still in your Drive\n\nMedia files (photos, videos, documents) attached to tasks are stored in a Google Drive folder called "Tasks Therapy — [Your Company]". On Android, a local cache copy is kept on your device for offline viewing.`
      },
      {
        id:"privacy", icon:"🔒", title:"Privacy — what we collect",
        content: `Tasks Therapy does not collect, store, or transmit any of your personal data or task data to our servers.\n\nWe do not have access to:\n• Your tasks or task details\n• Your team members' information\n• Your Google Drive files\n• Your usage history\n\nAll data flows directly between your device and your own Google account. Task data lives in your Google Sheet. Media files (photos, videos, documents) are stored in your Google Drive. The app simply acts as an interface to both.\n\n🔗 Full Privacy Policy`
      },
      {
        id:"backup", icon:"💾", title:"Backup & restore",
        content: `Because your data lives in Google Drive, it is automatically backed up by Google whenever you make changes.\n\nAdditionally, the app includes a manual backup feature (Manager only) under Menu → Backup & Storage. This exports a JSON snapshot of all tasks and settings to your device, which can be used to restore data if needed.\n\nTo restore: go to Backup & Storage → Import Backup and select your saved file.`
      },
      {
        id:"tasks", icon:"✅", title:"How to use tasks",
        content: `Creating a task (Manager / Supervisor only):\n1. Tap the + button on the dashboard\n2. Fill in the title, description, category, priority, deadline and recurrence\n3. Assign it to a team member\n4. Tap Create Task — note that task details cannot be edited after creation\n\nUpdating a task (Staff):\n1. Tap any task card to open it\n2. Change the status (e.g. In Progress → Done)\n3. Sign your name to confirm the status change\n4. Add a comment or attach a file as an update\n\nRecurring tasks automatically create the next occurrence when the current one is marked Done.`
      },
      {
        id:"invite", icon:"✉️", title:"How to invite users & sign in",
        content: `Inviting a team member (Manager only):\n1. Go to Menu → User Settings → Add User\n2. Enter their name, the email address they use, and their role\n3. Tap Send Invite — they'll receive an email with instructions\n\nSigning in (new staff member):\n1. Open the app and tap Continue with Google\n2. Sign in with your Google account\n3. If your Google email matches your invite email — you're in\n4. If you used a different email to sign up to Google, tap "I was invited" and enter the email your manager used\n\nOnce linked, your Google account is remembered for future sign-ins.`
      },
      {
        id:"roles", icon:"👥", title:"How roles & permissions work",
        content: `There are three roles in Tasks Therapy:\n\n🟣 Manager\n• Full access to everything\n• Creates and assigns tasks to anyone\n• Manages users, categories, company settings\n• Sees all tasks in the workspace\n\n🔷 Supervisor\n• Can create and assign tasks\n• Sees tasks they created and tasks assigned to them\n• Cannot manage users or company settings\n\n🟢 Staff\n• Can view and update tasks assigned to them\n• Cannot create tasks or see other team members' tasks\n• Updates progress via status changes, comments and file attachments`
      },
      {
        id:"faq", icon:"❓", title:"FAQ & Troubleshooting",
        content: `I can't sign in\n→ Make sure you're using the same Google account linked to your invite. If unsure, tap "I was invited" and enter your invite email.\n\nMy tasks aren't showing\n→ Check your role — Staff only see tasks assigned to them. If you're expecting to see a task, ask your manager to confirm it was assigned to you.\n\nI'm not receiving notifications\n→ Make sure notifications are enabled for Tasks Therapy in your phone's Settings. You can also check notification settings in Menu → Company Preferences.\n\nI accidentally marked a task as done\n→ Tap the task, change the status back, and sign to confirm. Activity is logged so managers can see the history.\n\nThe app is slow or not loading\n→ Check your internet connection. The app requires Google account access to sync. A cached version is available offline but won't show the latest updates.`
      },
      {
        id:"contact", icon:"📬", title:"Contact & Support",
        content: `If you have questions, feedback, or run into an issue that isn't covered here, please reach out to us.\n\n📧 ${SUPPORT_EMAIL}\n🌐 apps.the2457design.com\n\nWe aim to respond within 1–2 business days. When contacting support, please include:\n• Your app version (shown below)\n• A short description of the issue\n• Your role (Manager / Supervisor / Staff)`
      },
    ];

    return (
      <div style={{ position:"fixed", inset:0, background:"white", zIndex:400, display:"flex", flexDirection:"column", fontFamily:"inherit", paddingTop:sbHeight }}>
        {/* Header */}
        <div style={{ background:`linear-gradient(135deg,${theme.dark},${theme.darker})`, padding:"16px 18px", display:"flex", alignItems:"center", gap:12, flexShrink:0 }}>
          <button onClick={()=>setShowAbout(false)} style={{ background:"rgba(255,255,255,0.1)", border:"none", borderRadius:8, width:32, height:32, color:"white", fontSize:16, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>←</button>
          <div>
            <h2 style={{ color:"white", margin:0, fontSize:16, fontWeight:700 }}>About Tasks Therapy</h2>
            <p style={{ color:"rgba(255,255,255,0.92)", margin:0, fontSize:13 }}>v{APP_VERSION}</p>
          </div>
        </div>

        {/* Scrollable content */}
        <div style={{ flex:1, overflowY:"auto", padding:"16px 18px 32px" }}>

          {/* Accordion sections */}
          {sections.map(sec => (
            <div key={sec.id} style={{ marginBottom:8, borderRadius:12, border:"1px solid #e2e8f0", overflow:"hidden" }}>
              {/* Section header */}
              <button onClick={()=>setOpen(open===sec.id?null:sec.id)}
                style={{ width:"100%", display:"flex", alignItems:"center", gap:10, padding:"13px 15px", background:open===sec.id?`${theme.primary}08`:"white", border:"none", cursor:"pointer", fontFamily:"inherit", textAlign:"left" }}>
                {sec.icon
                  ? <span style={{ fontSize:18, flexShrink:0 }}>{sec.icon}</span>
                  : <img src={APP_LOGO_B64} alt="logo" style={{ width:20, height:20, objectFit:"contain", flexShrink:0, filter:"invert(35%) sepia(80%) saturate(500%) hue-rotate(210deg)" }} />
                }
                <span style={{ flex:1, fontSize:16, fontWeight:600, color:"#1e293b" }}>{sec.title}</span>
                <span style={{ color:"#334155", fontSize:17, transition:"transform 0.2s", transform:open===sec.id?"rotate(180deg)":"rotate(0deg)" }}>⌄</span>
              </button>
              {/* Section content */}
              {open===sec.id && (
                <div style={{ padding:"4px 15px 15px 43px", background:`${theme.primary}04`, borderTop:"1px solid #f1f5f9" }}>
                  {sec.content.split("\n").map((line,i) => (
                    line==="" ? <div key={i} style={{ height:8 }} />
                    : line.startsWith("•") || line.startsWith("→") ? <div key={i} style={{ fontSize:15, color:"#334155", lineHeight:1.7, paddingLeft:4 }}>{line}</div>
                    : line.startsWith("🔗") ? <a key={i} href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={{ display:"flex", alignItems:"center", gap:6, textDecoration:"none", marginTop:4 }}><span style={{ fontSize:15 }}>🔗</span><span style={{ fontSize:15, color:theme.primary, fontWeight:600, textDecoration:"underline" }}>Full Privacy Policy</span></a>
                    : line.startsWith("🔗") ? <a key={i} href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={{ display:"flex", alignItems:"center", gap:6, textDecoration:"none", marginTop:4 }}><span style={{ fontSize:15 }}>🔗</span><span style={{ fontSize:15, color:theme.primary, fontWeight:600 }}>Full Privacy Policy ›</span></a>
                    : line.startsWith("🌐") ? <a key={i} href="https://apps.the2457design.com" target="_blank" rel="noopener noreferrer" style={{ display:"flex", alignItems:"center", gap:6, textDecoration:"none", marginTop:2 }}><img src={DEV_LOGO_B64} style={{ width:16, height:16, borderRadius:3, objectFit:"contain", flexShrink:0 }} alt="" /><span style={{ fontSize:15, color:"#334155" }}>apps.the2457design.com</span></a>
                    : line.match(/^[🟣🔷🟢📧]/) ? <div key={i} style={{ fontSize:15, color:"#1e293b", fontWeight:700, marginTop:6 }}>{line}</div>
                    : line.match(/^\d\./) ? <div key={i} style={{ fontSize:15, color:"#334155", lineHeight:1.7, paddingLeft:4 }}>{line}</div>
                    : <p key={i} style={{ fontSize:15, color:"#334155", lineHeight:1.7, margin:"2px 0" }}>{line}</p>
                  ))}
                </div>
              )}
            </div>
          ))}

          {/* Contact shortcut */}
          <a href={`mailto:${SUPPORT_EMAIL}`} onClick={e=>{e.preventDefault();window.open(`mailto:${SUPPORT_EMAIL}`,"_blank");}}
            style={{ display:"flex", alignItems:"center", gap:12, padding:"14px 16px", borderRadius:12, background:`${theme.primary}08`, border:`1px solid ${theme.primary}20`, marginTop:12, textDecoration:"none" }}>
            <span style={{ fontSize:22 }}>📧</span>
            <div>
              <div style={{ fontSize:15, fontWeight:700, color:theme.primary }}>Email Support</div>
              <div style={{ fontSize:13, color:"#334155" }}>{SUPPORT_EMAIL}</div>
            </div>
            <span style={{ marginLeft:"auto", color:theme.primary, fontSize:17 }}>›</span>
          </a>



        </div>
      </div>
    );
  };

  // ── Workspace switcher overlay ───────────────────────────────────────────
  const WsSwitcher = () => !showWsSwitcher ? null : (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:600, display:"flex", alignItems:"flex-end", justifyContent:"center" }}
      onClick={()=>setShowWsSwitcher(false)}>
      <div style={{ background:"white", borderRadius:"20px 20px 0 0", padding:24, width:"100%", maxWidth:560, maxHeight:"88vh", overflowY:"auto", boxSizing:"border-box", fontFamily:"inherit" }}
        onClick={e=>e.stopPropagation()}>

        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18 }}>
          <div>
            <h3 style={{ margin:"0 0 2px", fontSize:17, color:"#1e293b" }}>🏢 Switch Workspace</h3>
            <p style={{ margin:0, fontSize:14, color:"rgba(255,255,255,0.9)" }}>Signed in as {gUser?.email}</p>
          </div>
          <button onClick={()=>setShowWsSwitcher(false)} style={{ background:"#f1f5f9", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>✕</button>
        </div>

        {workspaces.map(ws => {
          const isActive = ws.id === activeWsId;
          const ROLE_COLORS = { manager:"#7c3aed", supervisor:"#2563eb", staff:"#059669" };
          const ROLE_BG     = { manager:"#f5f3ff", supervisor:"#eff6ff", staff:"#f0fdf4" };
          const rc  = ROLE_COLORS[ws.role] || "#64748b";
          const rbg = ROLE_BG[ws.role]     || "#f8fafc";
          return (
            <div key={ws.id}
              onClick={()=>{ if(!isActive){ loadWorkspace(ws); } else { setShowWsSwitcher(false); } }}
              style={{ display:"flex", alignItems:"center", gap:13, padding:"13px 14px", borderRadius:13, marginBottom:9, background:isActive?"#f8fafc":"white", border:`1.5px solid ${isActive?theme.primary:"#e2e8f0"}`, cursor:"pointer" }}>
              {(()=>{ const cachedLogo = ws.logo || (()=>{ try { return localStorage.getItem(`tt_ws_logo_${ws.id}`) || ""; } catch(e) { return ""; } })(); return (
              <div style={{ width:46, height:46, borderRadius:12, background:isActive?`${theme.primary}12`:"#f1f5f9", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, overflow:"hidden" }}>
                {cachedLogo ? <img src={cachedLogo} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} /> : <span style={{ color:isActive?theme.primary:"#475569", fontSize:16, fontWeight:700, letterSpacing:0.5 }}>{(ws.name||"W").slice(0,2).toUpperCase()}</span>}
              </div>); })()}
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ display:"flex", alignItems:"center", gap:7, marginBottom:3 }}>
                  <span style={{ color:"#1e293b", fontSize:16, fontWeight:700 }}>{ws.name}</span>
                  {isActive && <span style={{ fontSize:12, color:theme.primary, background:`${theme.primary}12`, padding:"1px 6px", borderRadius:8, fontWeight:700 }}>Current</span>}
                </div>
                <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                  <span style={{ fontSize:12, color:rc, background:rbg, padding:"1px 7px", borderRadius:8, fontWeight:700, textTransform:"uppercase", letterSpacing:0.4 }}>{ws.role}</span>
                  <span style={{ color:"#334155", fontSize:13 }}>{ws.taskCount} tasks · {ws.memberCount} members</span>
                </div>
                <div style={{ color:"#334155", fontSize:12, marginTop:2 }}>Last active {ws.lastActive}</div>
              </div>
              {isActive
                ? <span style={{ color:theme.primary, fontSize:18 }}>✓</span>
                : <span style={{ color:"#475569", fontSize:16 }}>›</span>}
            </div>
          );
        })}

        <div style={{ borderTop:"1px solid #f1f5f9", margin:"8px 0 12px" }} />

        <div onClick={()=>{ setShowWsSwitcher(false); setMe(null); setAuthMode2("setup"); }}
          style={{ display:"flex", alignItems:"center", gap:13, padding:"12px 14px", borderRadius:12, background:"white", border:"1.5px dashed #e2e8f0", cursor:"pointer", marginBottom:10 }}>
          <div style={{ width:46, height:46, borderRadius:12, background:"#f8fafc", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22, flexShrink:0, color:"#334155" }}>＋</div>
          <div>
            <div style={{ color:"#334155", fontSize:16, fontWeight:600 }}>Create new workspace</div>
            <div style={{ color:"#334155", fontSize:13 }}>Anyone can create their own workspace — you'll be the Manager</div>
          </div>
        </div>

        <button onClick={()=>doSignOut(true)}
          style={{ width:"100%", padding:"10px", background:"#fef2f2", border:"1px solid #fecaca", borderRadius:10, color:"#dc2626", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
          Sign Out
        </button>
      </div>
    </div>
  );

  // ── Google OAuth via Google Identity Services ────────────────────────────
  // Loads the GSI script once then triggers token popup
  const syncToSheet = async (sheetId, data) => {
    const token = gUser?.accessToken;
    if (!token || !sheetId) return;
    const stripDataUrls = (val) => {
      // Remove local-only fields before writing to Sheet
      if (!Array.isArray(val)) return val;
      return val.map(item => {
        if (item && typeof item === "object" && Array.isArray(item.media)) {
          return {
            ...item,
            media: item.media.map(m => {
              const { blobUrl, dataUrl, uploadError, thumbUrl, ...rest } = m; // keep imgUrl in Sheet
              return rest;
            })
          };
        }
        if (item && typeof item === "object") {
          const { blobUrl, dataUrl, uploadError, thumbUrl, imgUrl, ...rest } = item;
          return rest;
        }
        return item;
      });
    };
    const makeRows = (headers, items) => {
      const dataRows = items.map(item => headers.map(h => {
        const v = item[h];
        if (Array.isArray(v) || (v && typeof v === "object")) return JSON.stringify(stripDataUrls(v));
        if (h === "logo") { const lv = v || ""; return lv.length < 40000 ? lv : ""; } // only write logo if small enough for Sheet cell
        // For pending: if user has googleId they already joined — never write pending=true
        if (h === "pending") return (item.googleId && item.googleId !== "") ? "false" : (v ? "true" : "false");
        if (typeof v === "boolean") return v ? "true" : "false"; // always write as string
        return v ?? "";
      }));
      // Pad with empty rows to overwrite any leftover rows from previous larger datasets
      const PAD_TOTAL = 300;
      const emptyRow = headers.map(() => "");
      while (dataRows.length < PAD_TOTAL) dataRows.push(emptyRow);
      return [headers, ...dataRows];
    };
    const companyHeaders = ["name","logo","themeIdx","attachFolderId"];
    const userHeaders = ["id","name","email","role","avatar","dept","pending","googleId"];
    const taskHeaders = ["id","title","description","priority","assignedTo","supervisorId","categoryId","deadline","status","createdBy","createdAt","recurrence","recurParentId","missedDeadline","statusLog","updates","comments","media"];
    const catHeaders = ["id","name","icon","color"];
    // Include attachFolderId from workspace index so staff can find upload folder
    const currentWs = workspaces.find(w => w.sheetId === sheetId);
    const companyWithFolder = { ...data.company, attachFolderId: currentWs?.attachFolderId || data.attachFolderId || "" };
    const userMap = {};
    (data.users || []).forEach(u => { userMap[u.id] = u.name || u.email || u.id; });
    const fmtReadable = (iso, local) => {
      if (local) return local;
      try { return new Date(iso).toLocaleString("en-GB", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit", timeZone:"Asia/Singapore" }); }
      catch(e) { return iso || ""; }
    };
    const buildReadable = (items) => (items || []).map(item => {
      const who = userMap[item.userId] || item.userId || "";
      const when = fmtReadable(item.timestamp, item.localTimestamp);
      const msg = (item.message || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
      return `[${when}] ${who}:\n${msg}`;
    }).join("\n---\n");
    // Build human-readable columns for Tasks sheet (columns S=19, T=20)
    // Written AFTER main sync — separate batchUpdate so failure here never affects main sync
    const readableHeader = [["updates_readable", "comments_readable"]];
    const readableRows = (data.tasks || []).map(t => [
      buildReadable(t.updates),
      buildReadable(t.comments)
    ]);

    const valueRanges = [
      { range: "Company!A1", values: makeRows(companyHeaders, [companyWithFolder]) },
      { range: "Users!A1",   values: makeRows(userHeaders,   data.users)   },
      { range: "Tasks!A1",   values: makeRows(taskHeaders,   data.tasks)   },
      { range: "Categories!A1", values: makeRows(catHeaders, data.cats)    },
    ];
    try {
      const res = await fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values:batchUpdate`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          body: JSON.stringify({ valueInputOption: "RAW", data: valueRanges })
        }
      );
      if (!res.ok) {
        if (res.status === 401) {
          // Token expired — GIS has no silent refresh, clear session and prompt re-auth
          try { localStorage.removeItem("tt_session"); localStorage.setItem("tt_signed_out","1"); } catch(e) {}
          setGUser(null); setMe(null); setAuthMode2("choose");
        } else {
          console.error("Sheet sync failed:", res.status);
          throw new Error(`Sync failed: ${res.status}`);
        }
      }
      // Write human-readable columns (S/T) — separate so failure never affects main sync
      try {
        await fetch(
          `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values:batchUpdate`,
          {
            method: "POST",
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            body: JSON.stringify({
              valueInputOption: "RAW",
              data: [{ range: "Tasks!S1", values: [...readableHeader, ...readableRows] }]
            })
          }
        );
      } catch(e) { /* readable columns are non-critical */ }
    } catch (e) { console.error("Sheet sync failed:", e); throw e; }
  };

  // ── Google Sign-In via Google Identity Services (GIS) ──────────────────────

  // Auto-refresh users from Sheet whenever User Settings panel opens
  useEffect(() => {
    if (!showUserMgr || !gUser?.accessToken) return;
    const ws = workspaces.find(w => w.id === activeWsId);
    if (!ws?.sheetId) return;
    fetch(`https://sheets.googleapis.com/v4/spreadsheets/${ws.sheetId}/values/Users`,
      { headers: { Authorization: `Bearer ${gUser.accessToken}` } })
      .then(r => r.json())
      .then(d => {
        const rows = d.values || [];
        if (rows.length < 2) return;
        const h = rows[0];
        const parsed = rows.slice(1).map(row => {
          const o = {};
          h.forEach((k, i) => { o[k] = row[i] || ""; });
          if ("pending" in o) o.pending = o.pending === true || o.pending === "true" || o.pending === "TRUE";
          return o;
        });
        mergeUsersFromSheet(parsed);
      })
      .catch(() => {});
  }, [showUserMgr]); // eslint-disable-line
  const [tokenError, setTokenError] = useState("");

  // Notification channel creation is Android/Capacitor-only; getLocalNotifications() returns null on web so this is a safe no-op

  // ── Handle OAuth redirect (token in URL hash) ────────────────────────────
  useEffect(() => {
    if (me || gUser) return; // already logged in
    // Check for OAuth redirect response in URL hash
    const hash = window.location.hash;
    if (hash && hash.includes("access_token")) {
      const params = new URLSearchParams(hash.substring(1));
      const accessToken = params.get("access_token");
      // Clear hash from URL to prevent token leaking in history
      window.history.replaceState(null, "", window.location.pathname);
      if (accessToken) {
        setAuthMode2("connecting");
        setTokenError("");
        (async () => {
          try {
            const profileRes = await fetch("https://www.googleapis.com/oauth2/v2/userinfo", {
              headers: { Authorization: `Bearer ${accessToken}` }
            });
            const profile = await profileRes.json();
            const gu = { email: profile.email, name: profile.name || "", picture: profile.picture || null, accessToken };
            setGUser(gu);
            try { localStorage.setItem("tt_session", JSON.stringify(gu)); } catch(e) {}
            await discoverWorkspaces(gu);
          } catch(e) {
            console.error("OAuth redirect handling failed:", e);
            setTokenError(e?.message || "Sign-in failed after redirect.");
            setAuthMode2("choose");
          }
        })();
        return; // Don't try session restore — we're handling the redirect
      }
    }
    // Session restore (no redirect — check localStorage)
    try {
      if (localStorage.getItem("tt_signed_out") === "1") {
        localStorage.removeItem("tt_signed_out");
        return;
      }
      const saved = localStorage.getItem("tt_session");
      if (!saved) return;
      const gu = JSON.parse(saved);
      if (!gu?.email || !gu?.accessToken) return;
      setGUser(gu);
      setAuthMode2("connecting");
      setTimeout(() => discoverWorkspaces(gu), 100);
    } catch(e) { console.error("Session restore failed:", e); }
  }, []); // eslint-disable-line
  // ── Auto sign-out after 30 min idle ─────────────────────────────────────
  const IDLE_WARN_MS  = 29 * 60 * 1000; // warn at 29 min
  const IDLE_OUT_MS   = 30 * 60 * 1000; // sign out at 30 min
  const resetIdleTimer = () => {
    if (!me) return; // only track idle when signed in
    setShowIdleWarn(false);
    if (idleWarnRef.current)  clearTimeout(idleWarnRef.current);
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    idleWarnRef.current  = setTimeout(() => setShowIdleWarn(true),  IDLE_WARN_MS);
    idleTimerRef.current = setTimeout(() => { setShowIdleWarn(false); doSignOut(true); }, IDLE_OUT_MS);
  };
  useEffect(() => {
    if (me) {
      resetIdleTimer();
    } else {
      // Signed out — clear timers
      if (idleWarnRef.current)  clearTimeout(idleWarnRef.current);
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
      setShowIdleWarn(false);
    }
    return () => {
      if (idleWarnRef.current)  clearTimeout(idleWarnRef.current);
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    };
  }, [me]); // eslint-disable-line

  // ── Web keyboard: Escape key closes the topmost open panel ─────────────────
  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      if (showMenu)        { setShowMenu(false);       return; }
      if (showNotif)       { setShowNotif(false);      return; }
      if (showTaskLog)     { setShowTaskLog(false);    return; }
      if (showCreate)      { setShowCreate(false);     return; }
      if (showUserMgr)     { setShowUserMgr(false);    return; }
      if (showCatMgr)      { setShowCatMgr(false);     return; }
      if (showBkp)         { setShowBkp(false);        return; }
      if (showPrefs)       { setShowPrefs(false);      return; }
      if (showAbout)       { setShowAbout(false);      return; }
      if (showWsSwitcher)  { setShowWsSwitcher(false); return; }
      if (showWelcome)     { setShowWelcome(false);    return; }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [showMenu, showNotif, showTaskLog, showCreate, showUserMgr, showCatMgr, showBkp, showPrefs, showAbout, showWsSwitcher, showWelcome]); // eslint-disable-line

    const doGoogleSignIn = () => {
    // Standard OAuth 2.0 implicit redirect — bypasses GIS library entirely
    const params = new URLSearchParams({
      client_id: GOOGLE_CLIENT_ID,
      redirect_uri: OAUTH_REDIRECT_URI,
      response_type: "token",
      scope: SCOPES,
      prompt: "select_account",
      include_granted_scopes: "true",
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  };

  // Search user's Drive for a Tasks Therapy index JSON file
  const discoverWorkspaces = async (gu) => {
    try {
      const res = await fetch(
        "https://www.googleapis.com/drive/v3/files?q=name%3D'tasks-therapy-index.json'+and+trashed%3Dfalse&fields=files(id,name)",
        { headers: { Authorization: `Bearer ${gu.accessToken}` } }
      );
      const data = await res.json();
      if (data.files && data.files.length > 0) {
        // Load the index file to get workspace list
        const fileRes = await fetch(
          `https://www.googleapis.com/drive/v3/files/${data.files[0].id}?alt=media`,
          { headers: { Authorization: `Bearer ${gu.accessToken}` } }
        );
        const index = await fileRes.json();
        const found = index.workspaces || [];
        setWorkspaces(found);
        // Cache workspace list locally so it survives token expiry
        try { localStorage.setItem("tt_last_ws_list", JSON.stringify(found)); } catch(e) {}
        // Ensure workspace folders are shared as writer/anyone (for existing workspaces)
        const shareFolderIfNeeded = async (fileId) => {
          if (!fileId) return;
          try {
            await fetch(`https://www.googleapis.com/drive/v3/files/${fileId}/permissions`, {
              method: "POST",
              headers: { Authorization: `Bearer ${gu.accessToken}`, "Content-Type": "application/json" },
              body: JSON.stringify({ role: "writer", type: "anyone" })
            });
          } catch(e) {}
        };
        found.forEach(ws => {
          if (ws.folderId) shareFolderIfNeeded(ws.folderId).catch(()=>{});
          if (ws.attachFolderId && ws.attachFolderId !== ws.folderId) shareFolderIfNeeded(ws.attachFolderId).catch(()=>{});
        });
        // Silently migrate any old folders into Tasks Therapy parent folder
        migrateOldFolders(gu.accessToken, found).catch(()=>{});
        if (found.length >= 1) {
          setAuthMode2("pick_workspace");
        } else {
          setAuthMode2("new_user");
        }
      } else {
        // No index file in Drive — check localStorage cache before treating as new user
        try {
          const cached = JSON.parse(localStorage.getItem("tt_last_ws_list") || "[]");
          if (cached.length > 0) {
            setWorkspaces(cached);
            setAuthMode2("pick_workspace");
            return;
          }
        } catch(e2) {}
        setWorkspaces([]);
        setAuthMode2("new_user");
      }
    } catch (e) {
      console.error("Drive discovery failed:", e);
      // Token may be expired — fall back to cached workspace list from localStorage
      try {
        const cached = JSON.parse(localStorage.getItem("tt_last_ws_list") || "[]");
        if (cached.length > 0) {
          setWorkspaces(cached);
          setAuthMode2("pick_workspace");
          return;
        }
      } catch(e2) {}
      setWorkspaces([]);
      setAuthMode2("new_user");
    }
  };

  // Save workspace index back to Drive
  const saveWorkspaceIndex = async (workspaceList, gu) => {
    const token = gu?.accessToken || gUser?.accessToken;
    if (!token) return;
    try {
      // Check if index file already exists
      const searchRes = await fetch(
        "https://www.googleapis.com/drive/v3/files?q=name%3D'tasks-therapy-index.json'+and+trashed%3Dfalse&fields=files(id)",
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const searchData = await searchRes.json();
      const body = JSON.stringify({ workspaces: workspaceList });
      const blob = new Blob([body], { type: "application/json" });
      const form = new FormData();
      form.append("metadata", new Blob([JSON.stringify({ name: "tasks-therapy-index.json", mimeType: "application/json" })], { type: "application/json" }));
      form.append("file", blob);
      if (searchData.files?.length > 0) {
        // Update existing
        await fetch(`https://www.googleapis.com/upload/drive/v3/files/${searchData.files[0].id}?uploadType=multipart`, {
          method: "PATCH", headers: { Authorization: `Bearer ${token}` }, body: form
        });
      } else {
        // Create new
        await fetch("https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart", {
          method: "POST", headers: { Authorization: `Bearer ${token}` }, body: form
        });
      }
    } catch (e) { console.error("Index save failed:", e); }
  };

  // Load a workspace — pulls live data from Google Sheet
  const loadWorkspace = async (ws, gu) => {
    const token = gu?.accessToken || gUser?.accessToken;
    setActiveWsId(ws.id);
    lsSet(LS.lastWsId, ws.id);
    setAuthMode2("connecting");

    try {
      if (token && ws.sheetId) {
        // Pull all sheets from the Google Sheet
        const res = await fetch(
          `https://sheets.googleapis.com/v4/spreadsheets/${ws.sheetId}/values:batchGet?ranges=Company&ranges=Users&ranges=Tasks&ranges=Categories`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!res.ok) {
          if (res.status === 401) {
            // Token expired — clear session and send back to sign-in
            try { localStorage.removeItem("tt_session"); localStorage.setItem("tt_signed_out","1"); } catch(e) {}
            setGUser(null); setMe(null); setAuthMode2("choose");
            return;
          }
          if (res.status === 404) {
            // Workspace Sheet no longer exists — manager may have deleted it
            try {
              const wsList = JSON.parse(localStorage.getItem("tt_last_ws_list") || "[]");
              const updated = wsList.filter(w => w.sheetId !== ws.sheetId);
              localStorage.setItem("tt_last_ws_list", JSON.stringify(updated));
            } catch(e) {}
            setWorkspaces(prev => prev.filter(w => w.sheetId !== ws.sheetId));
            setActiveWsId(null);
            setAuthMode2("pick_workspace");
            setSyncState("error");
            setSyncMsg("Workspace not found — ask your manager for a new code and tap Join.");
            return;
          }
          throw new Error(`Sheet fetch failed: ${res.status}`);
        }
        const data = await res.json();
        const [companyRange, usersRange, tasksRange, catsRange] = data.valueRanges || [];
        const parseRows = (range) => {
          const rows = range?.values || [];
          if (rows.length < 2) return [];
          const headers = rows[0];
          return rows.slice(1).map(row => {
            const obj = {};
            headers.forEach((h, i) => { obj[h] = row[i] || ""; });
            // Parse JSON fields
            ["assignedTo","media","updates","comments","statusLog"].forEach(k => {
              if (obj[k]) try { obj[k] = JSON.parse(obj[k]); } catch { obj[k] = []; }
            });
            // Parse boolean fields — Sheet stores as string "true"/"false"
            if ("pending" in obj) obj.pending = obj.pending === true || obj.pending === "true" || obj.pending === "TRUE" || obj.pending === "True";
            return obj;
          }).filter(obj => obj.id);
        };
        const companyRow = companyRange?.values?.[1] || [];
        const companyHeaders = companyRange?.values?.[0] || [];
        const companyObj = {};
        companyHeaders.forEach((h, i) => companyObj[h] = companyRow[i] || "");
        // Logo: try Sheet first (so staff gets it), then localStorage fallback
        const savedLogo = (companyObj.logo && companyObj.logo.startsWith("data:")) ? companyObj.logo
          : localStorage.getItem("tt_company_logo") || (() => { try { return JSON.parse(localStorage.getItem(LS.company) || "{}").logo || ""; } catch(e) { return ""; } })();
        // Cache logo locally if we got it from Sheet
        if (companyObj.logo && companyObj.logo.startsWith("data:")) {
          try { localStorage.setItem("tt_company_logo", companyObj.logo); } catch(e) {}
        }
        // Cache logo per-workspace so picker screen can show it without API calls
        if (savedLogo) { try { localStorage.setItem(`tt_ws_logo_${ws.id}`, savedLogo); } catch(e) {} }
        setCompany({ name: companyObj.name || ws.name, logo: savedLogo, themeIdx: parseInt(companyObj.themeIdx) || 0 });
        const allUsers = parseRows(usersRange).filter(u => !getDeletedIds().has(u.id));
        setUsers(allUsers);
        const rawTasks = parseRows(tasksRange);
        // Deduplicate recurring tasks: same chain root + same deadline = keep first only
        const nowLoad = new Date();
        const seenChainDeadlines = new Set();
        const dedupedTasks = rawTasks.filter(t => {
          const rootId = t.recurParentId || t.id;
          const key = `${rootId}|${t.deadline}`;
          if (seenChainDeadlines.has(key)) return false;
          seenChainDeadlines.add(key);
          return true;
        });
        const didDeduplicate = dedupedTasks.length < rawTasks.length;
        const chainMap = {};
        dedupedTasks.forEach(t => {
          const rootId = t.recurParentId || t.id;
          if (!chainMap[rootId]) chainMap[rootId] = [];
          chainMap[rootId].push(t);
        });
        const autoSpawnedLoad = [];
        const updatedLoadedTasks = dedupedTasks.map(t => {
          const rootId = t.recurParentId || t.id;
          const chain = chainMap[rootId] || [];
          const hasFutureTask = chain.some(c => new Date(c.deadline) >= nowLoad);
          const alreadySpawned = autoSpawnedLoad.some(s => s.recurParentId === rootId);
          if (
            t.recurrence && t.recurrence !== "none" &&
            t.status !== "done" &&
            t.deadline && new Date(t.deadline) < nowLoad &&
            !hasFutureTask &&
            !alreadySpawned
          ) {
            const escalated = { ...t, priority: "high", missedDeadline: true };
            const nextDeadline = nextRecurDeadline(t.recurrence, t.deadline);
            const spawned = {
              id: `t${Date.now()}${autoSpawnedLoad.length}`,
              title: t.title, description: t.description,
              priority: t.priority,
              assignedTo: Array.isArray(t.assignedTo) ? t.assignedTo : [t.assignedTo].filter(Boolean),
              categoryId: t.categoryId, supervisorId: t.supervisorId || "",
              recurrence: t.recurrence, recurParentId: rootId,
              deadline: nextDeadline.toISOString(), createdBy: t.createdBy,
              createdAt: new Date().toISOString(), status: "not_done",
              updates: [], comments: [], media: [],
              statusLog: [{ status: "not_done", timestamp: new Date().toISOString(), userId: "system", signature: "Auto-spawned" }],
              missedDeadline: false,
            };
            autoSpawnedLoad.push(spawned);
            return escalated;
          }
          return t;
        });
        const finalTasks = autoSpawnedLoad.length > 0 ? [...autoSpawnedLoad, ...updatedLoadedTasks] : updatedLoadedTasks;
        setTasks(finalTasks);
        // Sync to Sheet if tasks were spawned OR duplicates were cleaned up
        if (autoSpawnedLoad.length > 0 || didDeduplicate) {
          const ws2 = ws;
          setTimeout(() => {
            syncToSheet(ws2.sheetId, { company: { name: companyObj.name || ws.name, logo: savedLogo, themeIdx: parseInt(companyObj.themeIdx) || 0 }, users: parseRows(usersRange).filter(u => !getDeletedIds().has(u.id)), tasks: finalTasks, cats: parseRows(catsRange) }).catch(() => {});
          }, 2000);
        }
        setCats(parseRows(catsRange));
        // Find current user in the sheet — match by email first, then by googleId (in case emails differ)
        const signedInEmail = (gu?.email || gUser?.email)?.toLowerCase();
        const currentUser = allUsers.find(u => u.email?.toLowerCase() === signedInEmail)
          || allUsers.find(u => u.googleId?.toLowerCase() === signedInEmail);
        if (currentUser) {
          // Force pending:false — user is signed in so they have joined
          setMe({ ...currentUser, pending: false, googleId: currentUser.googleId || signedInEmail });
        } else {
          // Manager creating a new workspace — or first sign-in before invite is set up
          setMe({ id:"u_manager", name: gu?.name || gUser?.name, email: gu?.email || gUser?.email, role:"manager", avatar:(gu?.name||"?").slice(0,2).toUpperCase(), dept:"" });
        }
        // Resolve upload folder — must be set before dashboard shows
        // attachFolderId: manager has it in ws object; staff reads it from Company Sheet
        let resolvedAttachFolder = ws.attachFolderId || companyObj.attachFolderId || "";
        if (!resolvedAttachFolder && ws.sheetId && token) {
          try {
            const parentId = ws.folderId || await fetch(
              `https://www.googleapis.com/drive/v3/files/${ws.sheetId}?fields=parents`,
              { headers: { Authorization: `Bearer ${token}` } }
            ).then(r => r.json()).then(d => d.parents?.[0]).catch(() => null);
            if (parentId) {
              const folderSearch = await fetch(
                `https://www.googleapis.com/drive/v3/files?q=name%3D'Attachments'+and+'${parentId}'+in+parents+and+mimeType%3D'application%2Fvnd.google-apps.folder'+and+trashed%3Dfalse&fields=files(id)`,
                { headers: { Authorization: `Bearer ${token}` } }
              ).then(r => r.json());
              resolvedAttachFolder = folderSearch.files?.[0]?.id || parentId;
              const updatedWsList = workspaces.map(w => w.id === ws.id ? { ...w, attachFolderId: resolvedAttachFolder } : w);
              setWorkspaces(updatedWsList);
              try { localStorage.setItem("tt_last_ws_list", JSON.stringify(updatedWsList)); } catch(e) {}
              saveWorkspaceIndex(updatedWsList, gu || gUser).catch(()=>{});
            }
          } catch(e) {}
        }
        setRootFolderId(ws.folderId || "");
        setMediaFolderId(resolvedAttachFolder || ws.folderId || "");
        // Schedule notifications after workspace loads
        const loadedCompany = { name: companyObj.name || ws.name, logo: savedLogo, themeIdx: parseInt(companyObj.themeIdx) || 0 };
        const loadedMe = allUsers.find(u => u.email?.toLowerCase() === signedInEmail) || gu;
        setTimeout(()=>scheduleNotifications(notifSched, finalTasks, loadedMe, loadedCompany), 3000);
      } else {
        // Fallback to cached data
        setCompany({ name: ws.name, logo: ws.logo || "", themeIdx: ws.themeIdx || 0 });
        setUsers(ws.users || []);
        setTasks(ws.tasks || []);
        setCats(ws.cats || []);
        setMe(ws.me || null);
      }
    } catch (e) {
      console.error("Failed to load workspace from Sheet:", e);
      // Fallback to cached
      setCompany({ name: ws.name, logo: ws.logo || "", themeIdx: ws.themeIdx || 0 });
      setUsers(ws.users || []);
      setTasks(ws.tasks || []);
      setCats(ws.cats || []);
      setMe(ws.me || null);
    }
    setAuthMode2("done");
    setShowWsSwitcher(false);
    if (!lsGet(LS.seenWelcome, false)) {
      setTimeout(() => setShowWelcome(true), 600);
    }
  };

  // Write all data back to Google Sheet (called after any mutation)
  // User enters the email they were invited under → we match & link
  const doLinkAccount = async () => {
    if (!linkEmail.trim()) { setLinkErr("Please enter the email your manager used to invite you."); return; }
    if (!linkSheetId.trim()) { setLinkErr("Please enter the Workspace Code from your invite email."); return; }
    setLinkErr("Connecting...");
    try {
      const token = linkGUser?.accessToken;
      if (!token) { setLinkErr("No access token. Please sign in again."); return; }
      // Fetch users from the workspace sheet
      const res = await fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${linkSheetId.trim()}/values/Users`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) {
        const errBody = await res.json().catch(() => ({}));
        const status = res.status;
        if (status === 403) setLinkErr(`Access denied (403). Make sure the Sheet is shared as "Anyone with link can edit" in Google Drive. Code used: ${linkSheetId.trim().slice(0,12)}...`);
        else if (status === 404) setLinkErr(`Workspace not found (404). The code entered doesn't match any Sheet. Code used: ${linkSheetId.trim().slice(0,12)}... — copy the code fresh from the manager's User Settings.`);
        else if (status === 401) setLinkErr("Sign-in expired (401). Please tap Sign out and sign in again.");
        else setLinkErr(`Could not connect (${status}). Code used: ${linkSheetId.trim().slice(0,12)}...`);
        return;
      }
      const data = await res.json();
      const rows = data.values || [];
      if (rows.length < 2) { setLinkErr("Workspace found but no users listed. Ask your manager to check."); return; }
      const headers = rows[0];
      const sheetUsers = rows.slice(1).map(row => {
        const obj = {};
        headers.forEach((h, i) => { obj[h] = row[i] || ""; });
        return obj;
      });
      const match = sheetUsers.find(u => u.email?.toLowerCase() === linkEmail.trim().toLowerCase());
      if (!match) { setLinkErr("No account found with that email in this workspace. Check the spelling or ask your manager."); return; }
      // Also fetch company + workspace name for index
      const res2 = await fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${linkSheetId.trim()}/values/Company`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data2 = await res2.json();
      const companyRow = data2.values?.[1] || [];
      const companyHeaders = data2.values?.[0] || [];
      const companyObj = {};
      companyHeaders.forEach((h, i) => companyObj[h] = companyRow[i] || "");
      const wsName = companyObj.name || "Workspace";
      // Build workspace entry and save to index
      const newWs = { id: "ws_" + linkSheetId.trim(), name: wsName, sheetId: linkSheetId.trim(), role: match.role };
      const existingWsList = JSON.parse(localStorage.getItem("tt_last_ws_list") || "[]");
      const updatedList = [...existingWsList.filter(w => w.sheetId !== linkSheetId.trim()), newWs];
      localStorage.setItem("tt_last_ws_list", JSON.stringify(updatedList));
      // Save workspace index to Drive so it persists across sign-ins
      await saveWorkspaceIndex(updatedList, linkGUser);
      // Mark user as no longer pending and write back to Sheet
      const linked = { ...match, googleId: linkGUser.email, googleEmail: linkGUser.email, pending: false };
      try {
        // Fetch all users, update this one, write back
        const allUsersRes = await fetch(
          `https://sheets.googleapis.com/v4/spreadsheets/${linkSheetId.trim()}/values/Users`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const allUsersData = await allUsersRes.json();
        const allRows = allUsersData.values || [];
        if (allRows.length >= 2) {
          const hdrs = allRows[0];
          const emailIdx = hdrs.indexOf("email");
          const pendingIdx = hdrs.indexOf("pending");
          const googleIdIdx = hdrs.indexOf("googleId");
          // Find which row number the user is on (1-indexed, row 1 = headers, row 2 = first data row)
          const userRowIdx = allRows.findIndex((row, i) => i > 0 && row[emailIdx]?.toLowerCase() === linkEmail.trim().toLowerCase());
          if (userRowIdx > 0) {
            const sheetRowNum = userRowIdx + 1; // 1-indexed for Sheets API
            // Build targeted updates for just the cells we need to change
            const updates = [];
            if (pendingIdx !== -1) {
              updates.push({ range: `Users!${String.fromCharCode(65+pendingIdx)}${sheetRowNum}`, values: [["false"]] });
            }
            if (googleIdIdx !== -1) {
              updates.push({ range: `Users!${String.fromCharCode(65+googleIdIdx)}${sheetRowNum}`, values: [[linkGUser.email]] });
            }
            if (updates.length > 0) {
              const batchRes = await fetch(
                `https://sheets.googleapis.com/v4/spreadsheets/${linkSheetId.trim()}/values:batchUpdate`,
                {
                  method: "POST",
                  headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                  body: JSON.stringify({ valueInputOption: "RAW", data: updates })
                }
              );
              if (!batchRes.ok) console.warn("Cell update failed:", batchRes.status);
            }
          }
        }
      } catch(e) { console.warn("Pending update failed:", e); }
      setGUser(linkGUser);
      setMe(linked);
      setWorkspaces(updatedList);
      setActiveWsId(newWs.id);
      await loadWorkspace(newWs, linkGUser);
      // After loadWorkspace, force pending:false for this user (Sheet may lag)
      setMe(prev => ({ ...prev, pending: false }));
      setUsers(prev => prev.map(u => u.email?.toLowerCase() === linkEmail.trim().toLowerCase() ? { ...u, pending: false, googleId: linkGUser.email } : u));
      setLinkErr("");
    } catch(e) {
      setLinkErr("Something went wrong. Please try again.");
    }
  };


  // ── Migrate existing folders into Tasks Therapy parent ─────────────────────
  const migrateOldFolders = async (token, wslist) => {
    if (!token || !wslist?.length) return;
    try {
      const parentSearch = await fetch(
        "https://www.googleapis.com/drive/v3/files?q=name%3D'Tasks%20Therapy'+and+mimeType%3D'application%2Fvnd.google-apps.folder'+and+trashed%3Dfalse+and+'root'+in+parents&fields=files(id)",
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const parentData = await parentSearch.json();
      let parentFolderId = parentData.files?.[0]?.id || "";
      if (!parentFolderId) {
        const parentRes = await fetch("https://www.googleapis.com/drive/v3/files", {
          method: "POST",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          body: JSON.stringify({ name: "Tasks Therapy", mimeType: "application/vnd.google-apps.folder" })
        });
        const parentFolder = await parentRes.json();
        parentFolderId = parentFolder.id || "";
      }
      if (!parentFolderId) return;
      for (const ws of wslist) {
        if (!ws.folderId) continue;
        try {
          const fileRes = await fetch(
            `https://www.googleapis.com/drive/v3/files/${ws.folderId}?fields=parents`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const fileData = await fileRes.json();
          const parents = fileData.parents || [];
          if (parents.includes(parentFolderId)) continue;
          await fetch(
            `https://www.googleapis.com/drive/v3/files/${ws.folderId}?addParents=${parentFolderId}&removeParents=${parents.join(",")}`,
            { method: "PATCH", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, body: JSON.stringify({}) }
          );
        } catch(e) {}
      }
    } catch(e) {}
  };

  const doGoogleCreateCompany = async () => {
    if (!setupForm.name.trim()) return;
    setAuthMode2("creating");
    const token = gUser?.accessToken;
    const wsId = "ws_" + Date.now();
    const companyName = setupForm.name.trim();
    const managerUser = {
      id: "u1", name: gUser?.name || "Manager", email: gUser?.email || "",
      role: "manager", avatar: (gUser?.name||"M").split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase(),
      dept: "Management", pending: false, googleId: gUser?.email || ""
    };
    const initCompany = { name: companyName, logo: "", themeIdx: setupForm.themeIdx || 0 };
    const initCats = SEED_CATS;
    const initTasks = [];

    try {
      if (token) {
        // 0. Find or create parent "Tasks Therapy" folder in Drive root
        const parentSearch = await fetch(
          "https://www.googleapis.com/drive/v3/files?q=name%3D'Tasks%20Therapy'+and+mimeType%3D'application%2Fvnd.google-apps.folder'+and+trashed%3Dfalse+and+'root'+in+parents&fields=files(id,name)",
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const parentData = await parentSearch.json();
        let parentFolderId = parentData.files?.[0]?.id || "";
        if (!parentFolderId) {
          const parentRes = await fetch("https://www.googleapis.com/drive/v3/files", {
            method: "POST",
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            body: JSON.stringify({ name: "Tasks Therapy", mimeType: "application/vnd.google-apps.folder" })
          });
          const parentFolder = await parentRes.json();
          parentFolderId = parentFolder.id || "";
        }

        // 1. Create company folder inside Tasks Therapy parent
        const folderRes = await fetch("https://www.googleapis.com/drive/v3/files", {
          method: "POST",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          body: JSON.stringify({ name: companyName, mimeType: "application/vnd.google-apps.folder", parents: parentFolderId ? [parentFolderId] : [] })
        });
        const folder = await folderRes.json();
        const folderId = folder.id || "";

        // 2. Create Google Sheet
        const sheetRes = await fetch("https://sheets.googleapis.com/v4/spreadsheets", {
          method: "POST",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          body: JSON.stringify({
            properties: { title: `Tasks Therapy — ${companyName}` },
            sheets: [
              { properties: { title: "Company" } },
              { properties: { title: "Users" } },
              { properties: { title: "Tasks" } },
              { properties: { title: "Categories" } },
            ]
          })
        });
        const sheet = await sheetRes.json();
        const sheetId = sheet.spreadsheetId || "";

        // 3. Create Attachments subfolder inside workspace folder
        let attachFolderId = folderId;
        try {
          const attachRes = await fetch("https://www.googleapis.com/drive/v3/files", {
            method: "POST",
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            body: JSON.stringify({ name: "Attachments", mimeType: "application/vnd.google-apps.folder", parents: [folderId] })
          });
          const attachFolder = await attachRes.json();
          attachFolderId = attachFolder.id || folderId;
        } catch(e) { console.warn("Attachments folder creation failed:", e); }

        // 4. Move Sheet into workspace folder
        try {
          await fetch(`https://www.googleapis.com/drive/v3/files/${sheetId}?addParents=${folderId}&removeParents=root`, {
            method: "PATCH",
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            body: JSON.stringify({})
          });
        } catch(e) { console.warn("Sheet move failed:", e); }

        // 4b. Share Sheet so invited users can read AND write with their own Google token
        try {
          await fetch(`https://www.googleapis.com/drive/v3/files/${sheetId}/permissions`, {
            method: "POST",
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            body: JSON.stringify({ role: "writer", type: "anyone" })
          });
        } catch(e) { console.warn("Sheet sharing failed:", e); }

        // 5. Write initial data
        await syncToSheet(sheetId, { company: initCompany, users: [managerUser], tasks: initTasks, cats: initCats });

        // 6. Save workspace index (ADD to existing workspaces)
        const newWs = { id: wsId, name: companyName, sheetId, folderId, attachFolderId, themeIdx: setupForm.themeIdx || 0, logo: "" };
        const updatedWorkspaces = [...workspaces, newWs];
        await saveWorkspaceIndex(updatedWorkspaces, gUser);
        setWorkspaces(updatedWorkspaces);
        setActiveWsId(wsId);
        setRootFolderId(folderId);
        setMediaFolderId(attachFolderId);
      }
    } catch(e) {
      console.error("Create workspace failed:", e);
    }

    setCompany(initCompany);
    setUsers([managerUser]);
    setCats(initCats);
    setTasks(initTasks);
    setMe(managerUser);
    setAuthMode2("done");
    // Schedule notifications for new workspace
    setTimeout(()=>scheduleNotifications(notifSched, initTasks, managerUser, initCompany), 2000);
  };

  if (!me) {
    const GoogleBtn = ({ onClick, white, children }) => (
      <button onClick={onClick} style={{ width:"100%", padding:13, background:white?"white":"transparent", border:white?"none":`1.5px solid rgba(255,255,255,0.25)`, borderRadius:12, color:white?"#1e293b":"white", fontSize:17, fontWeight:700, cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:10, marginBottom: white?12:0 }}>
        <svg width="18" height="18" viewBox="0 0 18 18"><path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/><path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"/><path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z"/><path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z"/></svg>
        {children}
      </button>
    );

    return (
      <div style={{ minHeight:"100vh", background:`linear-gradient(150deg,${theme.dark},${theme.darker} 50%,${theme.dark})`, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"system-ui,-apple-system,sans-serif", fontSize:16, padding:16, paddingTop:16+sbHeight }}>
        <div style={{ width:"100%", maxWidth:400 }}>

          {/* Branding */}
          <div style={{ textAlign:"center", marginBottom:32 }}>
            <img src={APP_LOGO_B64} alt="Tasks Therapy" style={{ width:80, height:80, display:"block", margin:"0 auto 8px", objectFit:"contain" }} />
            <h1 style={{ color:"#e2e8f0", fontSize:28, fontWeight:700, margin:"0 0 4px", letterSpacing:"-0.5px" }}>Tasks Therapy</h1>
            <p style={{ color:"white", fontSize:15, margin:0 }}>Team Task Manager — Easy & Simple</p>
          </div>

          {/* ── CONNECTING ── */}
          {authMode2==="connecting" && (
            <div style={{ background:"rgba(255,255,255,0.07)", backdropFilter:"blur(20px)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:16, padding:32, textAlign:"center" }}>
              <div style={{ fontSize:36, marginBottom:12 }}>⏳</div>
              <p style={{ color:"white", fontSize:17, margin:0, fontWeight:600 }}>Connecting to Google…</p>
            </div>
          )}

          {/* ── CREATING SHEET ── */}
          {authMode2==="creating" && (
            <div style={{ background:"rgba(255,255,255,0.07)", backdropFilter:"blur(20px)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:16, padding:32, textAlign:"center" }}>
              <div style={{ fontSize:36, marginBottom:12 }}>📊</div>
              <p style={{ color:"white", fontSize:17, fontWeight:700, margin:"0 0 6px" }}>Creating your Google Sheet…</p>
              <p style={{ color:"rgba(255,255,255,0.92)", fontSize:15, margin:0 }}>Setting up TasksTherapy — {setupForm.name}</p>
            </div>
          )}

          {/* ── COMPANY SETUP ── */}
          {authMode2==="setup" && (
            <div style={{ background:"rgba(255,255,255,0.07)", backdropFilter:"blur(20px)", border:"1px solid rgba(255,255,255,0.15)", borderRadius:16, padding:24 }}>
              <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:14 }}>
                <button onClick={()=>setAuthMode2(workspaces.length>0?"pick_workspace":"new_user")}
                  style={{ background:"rgba(255,255,255,0.1)", border:"none", borderRadius:8, width:30, height:30, color:"white", fontSize:15, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>←</button>
                <div>
                  <h3 style={{ color:"white", margin:0, fontSize:16 }}>🏢 Set up your workspace</h3>
                  <p style={{ color:"rgba(255,255,255,0.95)", fontSize:14, margin:0 }}>You'll be the Manager of this workspace</p>
                </div>
              </div>
              <p style={{ color:"rgba(255,255,255,0.95)", fontSize:15, margin:"0 0 16px" }}>A Google Sheet will be created in your Drive as the database for your whole team.</p>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", marginBottom:4 }}>
                <label style={{ ...lbl, color:"rgba(255,255,255,0.95)", margin:0 }}>Company Name</label>
                <span style={{ fontSize:12, color: setupForm.name.length>=23?"#f87171":"rgba(255,255,255,0.35)" }}>{setupForm.name.length}/25</span>
              </div>
              <input value={setupForm.name} onChange={e=>setSetupForm(p=>({...p,name:e.target.value.slice(0,25)}))} placeholder="e.g. Acme Corp" maxLength={25}
                style={{ width:"100%", padding:"10px 12px", borderRadius:9, border:"1px solid rgba(255,255,255,0.2)", background:"rgba(255,255,255,0.1)", color:"white", fontSize:16, boxSizing:"border-box", fontFamily:"inherit", marginBottom:16, outline:"none" }} />
              <label style={{ ...lbl, color:"rgba(255,255,255,0.95)" }}>Theme</label>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:6, marginBottom:20 }}>
                {THEMES.map((t,i)=>(
                  <button key={i} onClick={()=>setSetupForm(p=>({...p,themeIdx:i}))}
                    style={{ padding:"8px 4px", borderRadius:8, border:setupForm.themeIdx===i?`2px solid ${t.primary}`:"1.5px solid rgba(255,255,255,0.15)", background:setupForm.themeIdx===i?`${t.primary}30`:"transparent", cursor:"pointer" }}>
                    <div style={{ width:20, height:20, borderRadius:"50%", background:`linear-gradient(135deg,${t.primary},${t.secondary})`, margin:"0 auto 4px" }} />
                    <div style={{ fontSize:11, color:setupForm.themeIdx===i?t.primary:"rgba(255,255,255,0.4)" }}>{t.name}</div>
                  </button>
                ))}
              </div>
              {/* Drive structure preview */}
              {setupForm.name.trim() && (
                <div style={{ background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", borderRadius:10, padding:"10px 13px", marginBottom:14, fontFamily:"monospace" }}>
                  <p style={{ color:"rgba(255,255,255,0.95)", fontSize:12, margin:"0 0 7px", textTransform:"uppercase", letterSpacing:1 }}>Will be created in your Google Drive:</p>
                  <div style={{ fontSize:14, color:"#e2e8f0" }}>
                    <div style={{ marginBottom:3 }}>📁 <strong>Tasks Therapy — {setupForm.name}</strong></div>
                    <div style={{ paddingLeft:16, color:"white" }}>
                      <div style={{ marginBottom:2 }}>📊 TasksTherapy_Data</div>
                      <div>📁 Media</div>
                    </div>
                  </div>
                </div>
              )}
              <button onClick={doGoogleCreateCompany} disabled={!setupForm.name.trim()}
                style={{ width:"100%", padding:13, background:grad, border:"none", borderRadius:12, color:"white", fontSize:17, fontWeight:700, cursor:setupForm.name.trim()?"pointer":"not-allowed", fontFamily:"inherit", opacity:setupForm.name.trim()?1:0.5 }}>
                Create Company & Drive Folder →
              </button>
            </div>
          )}

          {/* ── LINK ACCOUNT — Google email not recognised ── */}
          {authMode2==="link" && (
            <div style={{ background:"rgba(255,255,255,0.06)", backdropFilter:"blur(20px)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:16, padding:26 }}>
              {/* Google account shown */}
              <div style={{ display:"flex", alignItems:"center", gap:10, background:"rgba(255,255,255,0.08)", borderRadius:10, padding:"10px 13px", marginBottom:18 }}>
                <svg width="18" height="18" viewBox="0 0 18 18"><path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/><path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"/><path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z"/><path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z"/></svg>
                <div>
                  <div style={{ color:"white", fontSize:15, fontWeight:700 }}>Signed in as {linkGUser?.name}</div>
                  <div style={{ color:"white", fontSize:13 }}>{linkGUser?.email}</div>
                </div>
              </div>

              <h3 style={{ color:"white", margin:"0 0 6px", fontSize:16 }}>One more step 👋</h3>
              <p style={{ color:"white", fontSize:15, margin:"0 0 18px", lineHeight:1.6 }}>
                Your Google account isn't linked to a profile yet. Enter the email your manager used to invite you — it might be your work email, not your Gmail.
              </p>

              <label style={{ color:"rgba(255,255,255,0.95)", fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:1.2, display:"block", marginBottom:6 }}>Workspace Code (from your invite email)</label>
              <input
                value={linkSheetId}
                onChange={e=>{ setLinkSheetId(e.target.value.trim()); setLinkErr(""); }}
                placeholder="Paste the Workspace Code here"
                style={{ width:"100%", padding:"11px 13px", borderRadius:10, border:"1px solid rgba(255,255,255,0.2)", background:"rgba(255,255,255,0.1)", color:"white", fontSize:15, boxSizing:"border-box", marginBottom:14, fontFamily:"inherit" }}
              />
              <label style={{ color:"rgba(255,255,255,0.95)", fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:1.2, display:"block", marginBottom:6 }}>Email you were invited under</label>
              <input
                value={linkEmail}
                onChange={e=>{ setLinkEmail(e.target.value); setLinkErr(""); }}
                onKeyDown={e=>e.key==="Enter"&&doLinkAccount()}
                placeholder="e.g. john@yourcompany.com"
                style={{ width:"100%", padding:"11px 13px", borderRadius:10, border:`1.5px solid ${linkErr?"#f87171":"rgba(255,255,255,0.2)"}`, background:"rgba(255,255,255,0.1)", color:"white", fontSize:16, boxSizing:"border-box", fontFamily:"inherit", outline:"none", marginBottom:10 }}
              />

              {linkErr && (
                <div style={{ background:"rgba(239,68,68,0.15)", border:"1px solid rgba(239,68,68,0.3)", borderRadius:8, padding:"8px 12px", marginBottom:12 }}>
                  <p style={{ color:"#fca5a5", fontSize:14, margin:0, lineHeight:1.5 }}>{linkErr}</p>
                </div>
              )}

              <button onClick={doLinkAccount}
                style={{ width:"100%", padding:13, background:grad, border:"none", borderRadius:11, color:"white", fontSize:17, fontWeight:700, cursor:"pointer", fontFamily:"inherit", marginBottom:12 }}>
                Link My Account →
              </button>

              <p style={{ color:"white", fontSize:13, textAlign:"center", margin:"0 0 16px", lineHeight:1.6 }}>
                This links your Google account to your profile — you won't be asked again.
              </p>


            </div>
          )}

          {/* ── WORKSPACE PICKER ── */}
          {authMode2==="pick_workspace" && (
            <div style={{ background:"rgba(255,255,255,0.06)", backdropFilter:"blur(20px)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:16, padding:24 }}>
              {/* Google account badge */}
              <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:20 }}>
                <div style={{ width:36, height:36, borderRadius:"50%", background:grad, display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:16, fontWeight:700, flexShrink:0 }}>
                  {gUser?.name?.slice(0,2).toUpperCase()||"?"}
                </div>
                <div>
                  <div style={{ color:"white", fontSize:16, fontWeight:700 }}>{gUser?.name}</div>
                  <div style={{ color:"white", fontSize:13 }}>{gUser?.email}</div>
                </div>
              </div>

              <h3 style={{ color:"white", margin:"0 0 4px", fontSize:16 }}>Choose a workspace</h3>
              <p style={{ color:"white", fontSize:15, margin:"0 0 16px" }}>
                {workspaces.length} workspace{workspaces.length!==1?"s":""} found for your account
              </p>

              {workspaces.map(ws => {
                const ROLE_COLORS = { manager:"#a78bfa", supervisor:"#60a5fa", staff:"#34d399" };
                const rc = ROLE_COLORS[ws.role] || "#94a3b8";
                return (
                  <div key={ws.id} onClick={()=>loadWorkspace(ws)}
                    style={{ display:"flex", alignItems:"center", gap:12, padding:"13px 14px", borderRadius:12, marginBottom:9, background:"rgba(255,255,255,0.07)", border:"1px solid rgba(255,255,255,0.12)", cursor:"pointer", transition:"background 0.15s" }}
                    onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.13)"}
                    onMouseLeave={e=>e.currentTarget.style.background="rgba(255,255,255,0.07)"}>
                    {/* Logo / icon */}
                    {(()=>{ const cachedLogo = ws.logo || (()=>{ try { return localStorage.getItem(`tt_ws_logo_${ws.id}`) || ""; } catch(e) { return ""; } })(); return (
                    <div style={{ width:42, height:42, borderRadius:11, background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.15)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, overflow:"hidden" }}>
                      {cachedLogo ? <img src={cachedLogo} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} /> : <span style={{ color:"rgba(255,255,255,0.9)", fontSize:16, fontWeight:700, letterSpacing:0.5 }}>{(ws.name||"W").slice(0,2).toUpperCase()}</span>}
                    </div>); })()}
                    {/* Info */}
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ color:"white", fontSize:16, fontWeight:700, marginBottom:2 }}>{ws.name}</div>
                      <div style={{ display:"flex", alignItems:"center", gap:6, flexWrap:"wrap" }}>
                        <span style={{ fontSize:12, color:rc, background:`${rc}20`, padding:"1px 7px", borderRadius:9, fontWeight:700, textTransform:"uppercase", letterSpacing:0.5 }}>{ws.role}</span>
                        <span style={{ color:"white", fontSize:13 }}>·</span>
                        <span style={{ color:"white", fontSize:13 }}>{ws.taskCount} tasks</span>
                        <span style={{ color:"white", fontSize:13 }}>·</span>
                        <span style={{ color:"white", fontSize:13 }}>{ws.memberCount} members</span>
                      </div>
                      <div style={{ color:"white", fontSize:12, marginTop:3 }}>Last active {ws.lastActive}</div>
                    </div>
                    {/* Arrow */}
                    <span style={{ color:"white", fontSize:16 }}>›</span>
                  </div>
                );
              })}

              {/* Create new workspace */}
              <div onClick={()=>setAuthMode2("setup")}
                style={{ display:"flex", alignItems:"center", gap:12, padding:"11px 14px", borderRadius:12, marginBottom:10, background:"transparent", border:"1px dashed rgba(255,255,255,0.2)", cursor:"pointer" }}>
                <div style={{ width:42, height:42, borderRadius:11, background:"transparent", border:"1px dashed rgba(255,255,255,0.2)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0, color:"white" }}>
                  ＋
                </div>
                <div>
                  <div style={{ color:"white", fontSize:16, fontWeight:600 }}>Create new workspace</div>
                  <div style={{ color:"white", fontSize:13 }}>For your own team or project — you'll be the Manager</div>
                </div>
              </div>

              {/* Join with code */}
              <div onClick={()=>{ setLinkGUser(gUser); setLinkSheetId(""); setLinkEmail(gUser?.email||""); setAuthMode2("link"); }}
                style={{ display:"flex", alignItems:"center", gap:12, padding:"11px 14px", borderRadius:12, marginBottom:10, background:"transparent", border:"1px dashed rgba(255,255,255,0.2)", cursor:"pointer" }}>
                <div style={{ width:42, height:42, borderRadius:11, background:"transparent", border:"1px dashed rgba(255,255,255,0.2)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0, color:"white" }}>
                  🔑
                </div>
                <div>
                  <div style={{ color:"white", fontSize:16, fontWeight:600 }}>Join a workspace</div>
                  <div style={{ color:"white", fontSize:13 }}>Enter a workspace code from your invite email</div>
                </div>
              </div>

              {/* Sign out link — allows clearing expired session (v59) */}
              <button onClick={()=>doSignOut(true)}
                style={{ display:"block", margin:"12px auto 0", background:"none", border:"none", color:"rgba(255,255,255,0.6)", fontSize:14, cursor:"pointer", fontFamily:"inherit", textDecoration:"underline" }}>
                Sign out
              </button>
            </div>
          )}

          {/* ── ANDROID BLOCK OVERLAY — forces app install on Android ── */}
          {isAndroid && (
            <div style={{ position:"fixed", inset:0, zIndex:900, background:`linear-gradient(150deg,${theme.dark},${theme.darker} 50%,${theme.dark})`, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
              <div style={{ width:"100%", maxWidth:360, textAlign:"center" }}>
                <img src={APP_LOGO_B64} alt="Tasks Therapy" style={{ width:88, height:88, display:"block", margin:"0 auto 16px", objectFit:"contain" }} />
                <h2 style={{ color:"#e2e8f0", fontSize:24, fontWeight:700, margin:"0 0 8px", letterSpacing:"-0.3px" }}>Tasks Therapy</h2>
                <p style={{ color:"rgba(255,255,255,0.85)", fontSize:15, margin:"0 0 28px", lineHeight:1.6 }}>
                  This app is available on Google Play.<br/>
                  Please install the Android app for the best experience with push notifications and offline access.
                </p>
                <button onClick={()=>{ window.open("https://play.google.com/store/apps/details?id=com.tasktherapy.app","_blank"); }}
                  style={{ width:"100%", padding:"14px 20px", background:"#1a73e8", border:"none", borderRadius:12, color:"white", fontSize:16, fontWeight:700, cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:10 }}>
                  <svg width="20" height="22" viewBox="0 0 20 22" fill="none"><path d="M1.57 0.34C1.21 0.72 1 1.3 1 2.04V19.96C1 20.7 1.21 21.28 1.57 21.66L1.65 21.74L11.78 11.61V11.5V11.39L1.65 1.26L1.57 0.34Z" fill="#4285F4"/><path d="M15.15 15.01L11.78 11.61V11.5V11.39L15.16 7.99L15.26 8.04L19.26 10.32C20.37 10.95 20.37 12.05 19.26 12.69L15.26 14.96L15.15 15.01Z" fill="#FBBC04"/><path d="M15.26 14.96L11.78 11.5L1.57 21.66C1.95 22.06 2.56 22.11 3.25 21.71L15.26 14.96Z" fill="#EA4335"/><path d="M15.26 8.04L3.25 1.29C2.56 0.89 1.95 0.94 1.57 1.34L11.78 11.5L15.26 8.04Z" fill="#34A853"/></svg>
                  Open in Google Play
                </button>
                <p style={{ color:"rgba(255,255,255,0.5)", fontSize:12, marginTop:20 }}>The web version is available on desktop and iPhone.</p>
              </div>
            </div>
          )}

          {/* ── LANDING: single sign-in button ── */}
          {authMode2==="choose" && (
            <div style={{ background:"rgba(255,255,255,0.06)", backdropFilter:"blur(20px)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:18, padding:28 }}>
              <GoogleBtn onClick={doGoogleSignIn} white>Continue with Google</GoogleBtn>
              {tokenError && <p style={{ color:"#f87171", fontSize:13, marginTop:10, textAlign:"center" }}>{tokenError}</p>}
              <p style={{ color:"rgba(255,255,255,0.92)", fontSize:15, textAlign:"center", margin:"14px 0 0", lineHeight:1.7 }}>
                New or returning — we'll figure it out after sign-in.<br/>
                No separate registration needed.
              </p>
            </div>
          )}

          {/* ── NEW USER — first time, no workspaces found ── */}
          {authMode2==="new_user" && (
            <div style={{ background:"rgba(255,255,255,0.06)", backdropFilter:"blur(20px)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:16, padding:24 }}>
              {/* Google account badge */}
              <div style={{ display:"flex", alignItems:"center", gap:10, background:"rgba(255,255,255,0.08)", borderRadius:10, padding:"10px 13px", marginBottom:20 }}>
                <svg width="16" height="16" viewBox="0 0 18 18"><path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/><path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"/><path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z"/><path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z"/></svg>
                <div style={{ flex:1 }}>
                  <div style={{ color:"white", fontSize:15, fontWeight:700 }}>{gUser?.name}</div>
                  <div style={{ color:"white", fontSize:13 }}>{gUser?.email}</div>
                </div>
                <span style={{ fontSize:12, color:"#34d399", background:"rgba(52,211,153,0.15)", padding:"2px 8px", borderRadius:8 }}>Signed in ✓</span>
              </div>

              <h3 style={{ color:"white", margin:"0 0 6px", fontSize:16 }}>Welcome to Tasks Therapy 👋</h3>
              <p style={{ color:"rgba(255,255,255,0.95)", fontSize:15, margin:"0 0 20px", lineHeight:1.6 }}>No workspaces found for your account yet. What would you like to do?</p>

              {/* Option 1: Create workspace */}
              <div onClick={()=>setAuthMode2("setup")}
                style={{ display:"flex", alignItems:"flex-start", gap:13, padding:"14px 15px", borderRadius:13, marginBottom:10, background:"rgba(255,255,255,0.07)", border:"1px solid rgba(255,255,255,0.12)", cursor:"pointer" }}>
                <div style={{ fontSize:24, flexShrink:0 }}>🏢</div>
                <div>
                  <div style={{ color:"white", fontSize:16, fontWeight:700, marginBottom:3 }}>Create a new workspace</div>
                  <div style={{ color:"rgba(255,255,255,0.92)", fontSize:14, lineHeight:1.5 }}>I'm a manager setting up Tasks Therapy for my team or project</div>
                </div>
              </div>

              {/* Option 2: I was invited */}
              <div onClick={()=>{ setLinkGUser(gUser); setAuthMode2("link"); }}
                style={{ display:"flex", alignItems:"flex-start", gap:13, padding:"14px 15px", borderRadius:13, marginBottom:10, background:"rgba(255,255,255,0.07)", border:"1px solid rgba(255,255,255,0.12)", cursor:"pointer" }}>
                <div style={{ fontSize:24, flexShrink:0 }}>✉️</div>
                <div>
                  <div style={{ color:"white", fontSize:16, fontWeight:700, marginBottom:3 }}>I was invited to a workspace</div>
                  <div style={{ color:"rgba(255,255,255,0.92)", fontSize:14, lineHeight:1.5 }}>My manager added me — I'll enter the email they used to invite me</div>
                </div>
              </div>

              <button onClick={()=>{ setMe(null); setGUser(null); setAuthMode2("choose"); doGoogleSignIn("select_account"); }}
                style={{ display:"block", margin:"14px auto 0", background:"none", border:"none", color:"white", fontSize:14, cursor:"pointer", fontFamily:"inherit", textDecoration:"underline" }}>
                ← Use a different Google account
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }

  // ══════════════════════════════════════════════════════════════════════════
  // TASK DETAIL
  // ══════════════════════════════════════════════════════════════════════════
  if (sel) {
    const t     = tasks.find(x=>x.id===sel) || {};
    const asgnIds = Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo].filter(Boolean); const asgns = asgnIds.map(id=>users.find(u=>u.id===id)).filter(Boolean); const asgn = asgns[0];
    const crtby = users.find(u=>u.id===t.createdBy);
    const supUser = t.supervisorId ? users.find(u=>u.id===t.supervisorId) : null;
    const tl    = timeLeft(t.deadline);
    const sc    = STATUS[t.status]||STATUS.not_done;
    const cat   = getCat(t.categoryId);
    const canSt = (Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo]).includes(me.id)||me.role==="manager"||me.role==="supervisor"||t.supervisorId===me.id;
    const canUp = (Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo]).includes(me.id)||me.role==="supervisor"||me.role==="manager"||t.supervisorId===me.id;
    const coms  = t.comments||[];

    return (
      <div style={{ minHeight:"100vh", background:"#cecece", display:"flex", justifyContent:"center" }}>
      <div style={{ width:"100%", maxWidth:1000, minHeight:"100vh", background:"#f8fafc", fontFamily:"system-ui,-apple-system,sans-serif", fontSize:16, position:"relative", boxShadow:"0 0 40px rgba(0,0,0,0.12)" }}>
        <ToastContainer toasts={toasts} onDismiss={dismissToast} onAction={handleToastAction} />
        <SyncBar />

        <SigModal />

        {/* Invite overlay (task detail) */}
        {showInvite && (
          <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:200, display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
            <div style={{ background:"white", borderRadius:"20px 20px 0 0", padding:24, width:"100%", maxWidth:560, boxSizing:"border-box", fontFamily:"inherit" }}>
              <div style={{ display:"flex", justifyContent:"space-between", marginBottom:14 }}>
                <h3 style={{ margin:0, fontSize:16, color:"#1e293b" }}>👥 Assign or Invite</h3>
                <button onClick={()=>{setShowInvite(false);setInvMsg(""); setInvTab("existing");}} style={{ background:"#f1f5f9", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>✕</button>
              </div>
              {/* Step 1: Assign existing or invite new */}
              {!invEmailTarget && (
                <>
                  {/* Tabs */}
                  <div style={{ display:"flex", gap:0, marginBottom:14, background:"#f1f5f9", borderRadius:9, padding:3 }}>
                    {[["existing","Existing User"],["new","New User"]].map(([k,l])=>(
                      <button key={k} onClick={()=>setInvTab(k)} style={{ flex:1, padding:"7px", borderRadius:7, border:"none", background:invTab===k?"white":"transparent", color:invTab===k?"#1e293b":"#64748b", fontSize:14, fontWeight:invTab===k?700:400, cursor:"pointer", fontFamily:"inherit" }}>{l}</button>
                    ))}
                  </div>

                  {/* Existing users tab */}
                  {invTab==="existing" && (
                    <div style={{ border:"1px solid #e2e8f0", borderRadius:9, overflow:"hidden", marginBottom:10 }}>
                      {users.length===0
                        ? <p style={{ color:"#475569", fontSize:14, margin:0, padding:"12px" }}>No team members yet.</p>
                        : users.map(u=>(
                          <div key={u.id} onClick={()=>{
                            const currentAssigned = Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo].filter(Boolean);
                            if (!currentAssigned.includes(u.id)) {
                              setTasks(p=>p.map(tk=>tk.id!==sel?tk:{...tk,assignedTo:[...currentAssigned,u.id]}));
                              logActivity("user_assigned", u.name);
                            }
                            setShowInvite(false); setInvMsg(""); setInvTab("existing");
                          }}
                            style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 13px", borderBottom:"1px solid #f1f5f9", cursor:"pointer", background:"white" }}>
                            <div style={{ width:32, height:32, borderRadius:"50%", background:grad, display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:13, fontWeight:700, flexShrink:0 }}>{u.avatar||u.name?.slice(0,2).toUpperCase()}</div>
                            <div style={{ flex:1 }}>
                              <div style={{ color:"#1e293b", fontSize:15, fontWeight:600 }}>{u.name}</div>
                              <div style={{ color:"#64748b", fontSize:12, textTransform:"capitalize" }}>{u.role}</div>
                            </div>
                            <span style={{ fontSize:13, color:theme.primary, fontWeight:700 }}>Assign →</span>
                          </div>
                        ))
                      }
                    </div>
                  )}

                  {/* New user tab */}
                  {invTab==="new" && (
                    <>
                      <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:9, padding:"8px 12px", marginBottom:10 }}>
                        <p style={{ color:"#15803d", fontSize:13, margin:0, lineHeight:1.5 }}>They sign in with whatever Google account they use. No password needed.</p>
                      </div>
                      <label style={lbl}>Invite Email (any email address)</label>
                      <input value={invEmail} onChange={e=>setInvEmail(e.target.value)} placeholder="e.g. john@company.com"
                        style={{ ...inp, marginBottom:10 }} />
                      <div style={{ display:"flex", gap:8, marginBottom:12 }}>
                        {[["staff","👤 Staff"],["supervisor","🔷 Supervisor"]].map(([k,l])=>(
                          <button key={k} onClick={()=>setInvRole(k)} style={{ flex:1, padding:8, borderRadius:9, border:`1.5px solid ${invRole===k?theme.primary:"#e2e8f0"}`, background:invRole===k?`${theme.primary}10`:"white", color:invRole===k?theme.primary:"#475569", fontSize:14, cursor:"pointer", fontFamily:"inherit", fontWeight:invRole===k?700:400 }}>{l}</button>
                        ))}
                      </div>
                      {invMsg && <p style={{ fontSize:15, padding:"8px 12px", borderRadius:8, background:invMsg.includes("⚠️")?"#fef2f2":"#f0fdf4", color:invMsg.includes("⚠️")?"#ef4444":"#15803d", margin:"0 0 10px" }}>{invMsg}</p>}
                      <button onClick={()=>{
                        if(!invEmail.trim())return;
                        if(users.find(u=>u.email.toLowerCase()===invEmail.toLowerCase())){setInvMsg("⚠️ Email already registered.");return;}
                        const newUser={id:`u${Date.now()}`,name:invEmail.split("@")[0],email:invEmail.trim(),pw:"",role:invRole,avatar:invEmail.slice(0,2).toUpperCase(),dept:"Operations",pending:true};
                        const updatedUsers1=[...users,newUser];
                        setUsers(updatedUsers1);
                        const ws1=workspaces.find(w=>w.id===activeWsId);
                        if(ws1?.sheetId) syncToSheet(ws1.sheetId,{company,users:updatedUsers1,tasks,cats}).catch(()=>{});
                        const currentAssigned=Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo].filter(Boolean);
                        setTasks(p=>p.map(tk=>tk.id!==sel?tk:{...tk,assignedTo:[...currentAssigned,newUser.id]}));
                        logActivity("user_invited_assigned",newUser.name);
                        setInvEmailTarget(newUser);
                        setInvMsg("");
                      }} style={{ width:"100%", padding:12, background:grad, border:"none", borderRadius:10, color:"white", fontSize:16, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                        Add & Assign →
                      </button>
                    </>
                  )}
                </>
              )}

              {/* Step 2: Send email invite */}
              {invEmailTarget && (
                <div style={{ textAlign:"center" }}>
                  <div style={{ fontSize:40, marginBottom:8 }}>✅</div>
                  <p style={{ color:"#1e293b", fontSize:17, fontWeight:700, margin:"0 0 4px" }}>{invEmailTarget.name} added to team!</p>
                  <p style={{ color:"#334155", fontSize:15, margin:"0 0 20px" }}>Now send them an email so they know how to sign in and install the app.</p>

                  {/* Email preview */}
                  <div style={{ background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:12, padding:14, marginBottom:16, textAlign:"left" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:8 }}>
                      <span style={{ fontSize:17 }}>📧</span>
                      <span style={{ color:"#1e293b", fontSize:15, fontWeight:700 }}>Email preview</span>
                      <span style={{ marginLeft:"auto", fontSize:12, color:"#334155", background:"#f1f5f9", padding:"2px 7px", borderRadius:4 }}>To: {invEmailTarget.email}</span>
                    </div>
                    <p style={{ color:"#334155", fontSize:14, margin:"0 0 6px", fontWeight:700 }}>You're invited to join {company.name} on Tasks Therapy</p>
                    <p style={{ color:"#334155", fontSize:13, margin:"0 0 4px", lineHeight:1.5 }}>Hi {invEmailTarget.name}, {me?.name} has invited you to join {company.name}'s task management app.</p>
                    <p style={{ color:"#334155", fontSize:13, margin:"0 0 4px" }}>✅ Sign in link included</p>
                    <p style={{ color:"#334155", fontSize:13, margin:"0 0 4px" }}>📱 Android install instructions included</p>
                    <p style={{ color:"#334155", fontSize:13, margin:0 }}>👤 Role: {invEmailTarget.role}</p>
                  </div>

                  {!invEmailSent ? (
                    <button onClick={()=>openMailInvite(invEmailTarget)} style={{ width:"100%", padding:13, background:grad, border:"none", borderRadius:12, color:"white", fontSize:17, fontWeight:700, cursor:"pointer", fontFamily:"inherit", marginBottom:10 }}>
                      📤 Share Invite
                    </button>
                  ) : (
                    <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:"10px 14px", marginBottom:10 }}>
                      <p style={{ color:"#15803d", fontSize:15, fontWeight:700, margin:"0 0 2px" }}>✅ Email opened in your mail app!</p>
                      <p style={{ color:"#15803d", fontSize:14, margin:0 }}>Review and send it from there.</p>
                    </div>
                  )}
                  <button onClick={()=>{ setInvEmailTarget(null); setInvMsg(""); }} style={{ width:"100%", padding:11, background:"white", border:"1px solid #e2e8f0", borderRadius:12, color:"#334155", fontSize:16, cursor:"pointer", fontFamily:"inherit" }}>
                    + Invite Another Person
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Detail header */}
        <div style={{ background:headerBg, paddingTop:18+sbHeight, paddingBottom:"22px", paddingLeft:"18px", paddingRight:"18px", position:"sticky", top:0, zIndex:50 }}>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
            <button onClick={()=>setSel(null)} style={{ background:"rgba(255,255,255,0.08)", border:"none", color:"white", padding:"7px 13px", borderRadius:8, cursor:"pointer", fontSize:15, fontFamily:"inherit" }}>← Back</button>
            <div style={{ display:"flex", gap:7 }}>
              {me.role==="manager" && <button onClick={()=>setShowInvite(true)} style={{ background:"rgba(255,255,255,0.08)", border:"none", color:"white", padding:"7px 13px", borderRadius:8, cursor:"pointer", fontSize:14, fontFamily:"inherit", fontWeight:700 }}>✉️ Invite Staff</button>}
              {canManageTasks && (() => {
                const mediaCount = (t.media||[]).length
                  + (t.updates||[]).reduce((s,u)=>s+(u.media||[]).length,0)
                  + (t.comments||[]).reduce((s,c)=>s+(c.media||[]).length,0);
                return (
                  <button onClick={()=>setDelModal({taskId:t.id, title:t.title, hasMedia:mediaCount>0, mediaCount})}
                    style={{ background:"rgba(239,68,68,0.25)", border:"1px solid rgba(239,68,68,0.4)", color:"#fca5a5", padding:"7px 13px", borderRadius:8, cursor:"pointer", fontSize:14, fontFamily:"inherit", fontWeight:700 }}>
                    🗑️ Delete
                  </button>
                );
              })()}
            </div>
          </div>
          <div style={{ display:"flex", gap:8, alignItems:"flex-start" }}>
            <span style={{ fontSize:12, padding:"3px 9px", borderRadius:20, background:PRIORITY[t.priority]?.bg, color:PRIORITY[t.priority]?.color, fontWeight:700, flexShrink:0, marginTop:4 }}>{(t.priority||"").toUpperCase()}</span>
            <h2 style={{ color:"white", fontSize:16, margin:0, lineHeight:1.3, fontWeight:700 }}>{t.title}</h2>
          </div>
        </div>

        <div style={{ padding:16 }}>
          {/* Status / time / category chips */}
          <div style={{ display:"flex", gap:7, marginBottom:12 }}>
            {[
              {bg:sc.bg,  c:sc.color, icon:sc.icon, label:sc.label},
              {bg:tl.overdue?"#fef2f2":"#f0fdf4", c:tl.overdue?"#ef4444":"#10b981", icon:tl.overdue?"⚠️":"⏱", label:tl.label},
              {bg:`${cat?.color||"#6366f1"}15`, c:cat?.color||"#6366f1", icon:cat?.icon||"📋", label:cat?.name||"—"},
            ].map((s,i)=>(
              <div key={i} style={{ flex:1, background:s.bg, border:`1px solid ${s.c}25`, borderRadius:11, padding:"9px 6px", textAlign:"center" }}>
                <div style={{ fontSize:15, marginBottom:2 }}>{s.icon}</div>
                <div style={{ color:s.c, fontSize:13, fontWeight:700 }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Recurrence banner */}
          {t.recurrence&&t.recurrence!=="none" && (
            <div style={{ background:"#f5f3ff", border:"1px solid #ddd6fe", borderRadius:10, padding:"10px 13px", marginBottom:10, display:"flex", alignItems:"center", gap:9 }}>
              <span style={{ fontSize:18 }}>🔁</span>
              <div style={{ flex:1 }}>
                <div style={{ color:"#7c3aed", fontSize:15, fontWeight:700 }}>Recurring · {RECUR_OPTIONS.find(r=>r.value===t.recurrence)?.label}</div>
                <div style={{ color:"#8b5cf6", fontSize:13, marginTop:1 }}>
                  {t.status==="done" ? "✅ Done · next occurrence auto-created" : recurDescription(t.recurrence, t.deadline)||""}
                </div>
              </div>
              {me.role==="manager"&&t.status!=="done" && (
                <button onClick={()=>{ setTasks(p=>p.map(x=>x.id===t.id?{...x,recurrence:"none"}:x)); logActivity("recurrence_stopped",t.title); }}
                  style={{ fontSize:12, color:"#7c3aed", background:"#ede9fe", border:"1px solid #ddd6fe", borderRadius:6, padding:"3px 8px", cursor:"pointer", fontFamily:"inherit", fontWeight:700, whiteSpace:"nowrap" }}>
                  Stop repeating
                </button>
              )}
            </div>
          )}

          <Card>
            <Lbl ch="Description" />
            <p style={{ color:"#334155", fontSize:16, margin:0, lineHeight:1.6 }}><RichText text={t.description} /></p>
            <MediaGallery attachments={t.media||[]} />
          </Card>

          <Card>
            <Lbl ch="People" />
            <div style={{ marginBottom:8 }}>
              <div style={{ color:"#475569", fontSize:13, fontWeight:600, marginBottom:6 }}>Assigned To</div>
              {asgns.length>0
                ? <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                    {asgns.map(u=>(
                      <div key={u.id} style={{ display:"flex", alignItems:"center", gap:9 }}>
                        <Av user={u} size={28} grad={grad} />
                        <div>
                          <div style={{ color:"#1e293b", fontSize:15, fontWeight:600 }}>{u?.name}</div>
                          <div style={{ color:"#334155", fontSize:12, textTransform:"capitalize" }}>{u?.role}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                : <div style={{ color:"#475569", fontSize:14 }}>Unassigned</div>
              }
            </div>
            {supUser && (
              <div style={{ display:"flex", alignItems:"center", gap:9, marginBottom:8, paddingTop:8, borderTop:"1px solid #f1f5f9" }}>
                <Av user={supUser} size={28} grad={grad} />
                <div>
                  <div style={{ color:"#1e293b", fontSize:15, fontWeight:600 }}>{supUser.name}</div>
                  <div style={{ color:"#334155", fontSize:12 }}>🔷 Supervisor</div>
                </div>
              </div>
            )}
            <div style={{ display:"flex", alignItems:"center", gap:9, marginBottom:8, paddingTop:8, borderTop:"1px solid #f1f5f9" }}>
              <Av user={crtby} size={28} grad={grad} />
              <div>
                <div style={{ color:"#1e293b", fontSize:15, fontWeight:600 }}>{crtby?.name}</div>
                <div style={{ color:"#334155", fontSize:12 }}>Created By · {crtby?.role}</div>
              </div>
            </div>
            <div style={{ color:"#334155", fontSize:14, marginTop:7, paddingTop:7, borderTop:"1px solid #f1f5f9" }}>
              Deadline: <strong style={{ color:tl.overdue?"#ef4444":"#334155" }}>{fmt(t.deadline)}</strong> · Created: {fmt(t.createdAt)}
            </div>
          </Card>

          {/* Status change */}
          {canSt && t.status!=="done" && (
            <Card>
              <Lbl ch="Update Status" />
              <div style={{ display:"flex", gap:7 }}>
                {Object.entries(STATUS).filter(([k])=>k!==t.status).map(([k,v])=>(
                  <button key={k} onClick={()=>changeStatus(t.id,k)} style={{ flex:1, padding:"9px 5px", borderRadius:9, border:`1.5px solid ${v.color}35`, background:v.bg, color:v.color, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>{v.icon} {v.label}</button>
                ))}
              </div>
            </Card>
          )}

          {/* Status log */}
          <Card>
            <Lbl ch="Status History & Signatures" />
            {(t.statusLog||[]).map((log,i)=>{
              const u=users.find(x=>x.id===log.userId), cfg=STATUS[log.status]||STATUS.not_done;
              return (
                <div key={i} style={{ display:"flex", gap:9, marginBottom:9, paddingBottom:9, borderBottom:i<(t.statusLog||[]).length-1?"1px solid #f1f5f9":"none" }}>
                  <div style={{ width:24, height:24, borderRadius:"50%", background:cfg.bg, border:`1.5px solid ${cfg.color}40`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, flexShrink:0 }}>{cfg.icon}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ display:"flex", justifyContent:"space-between" }}>
                      <span style={{ color:cfg.color, fontSize:14, fontWeight:700 }}>{cfg.label}</span>
                      <span style={{ color:"#334155", fontSize:12 }}>{fmt(log.timestamp)}</span>
                    </div>
                    <div style={{ color:"#1e293b", fontSize:14, marginTop:1 }}>✍️ <em>{log.signature}</em> <span style={{ color:"#334155" }}>({u?.name})</span></div>
                  </div>
                </div>
              );
            })}
          </Card>

          {/* Progress updates */}
          <Card>
            <Lbl ch={`Progress Updates (${(t.updates||[]).length})`} />
            {(t.updates||[]).length===0 && <p style={{ color:"#334155", fontSize:15, textAlign:"center", padding:"8px 0" }}>No updates yet.</p>}
            {(t.updates||[]).map(upd=>{
              const u=users.find(x=>x.id===upd.userId);
              return (
                <div key={upd.id} style={{ marginBottom:9, paddingBottom:9, borderBottom:"1px solid #f1f5f9" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", marginBottom:2 }}>
                    <span style={{ color:theme.primary, fontSize:14, fontWeight:700 }}>{u?.name}</span>
                    <span style={{ color:"#334155", fontSize:12 }}>{fmt(upd.timestamp)}</span>
                  </div>
                  {upd.message && <p style={{ color:"#334155", fontSize:15, margin:"0 0 0", lineHeight:1.5 }}><RichText text={upd.message} /></p>}
                  <MediaGallery attachments={upd.media||[]} />
                </div>
              );
            })}
            {canUp && t.status!=="done" && (
              <div style={{ marginTop:7 }}>
                <MentionBox value={updIn[t.id]||""} onChange={v=>setUpdIn(p=>({...p,[t.id]:v}))} placeholder="Add progress update… @ to mention" users={users} rows={2} accent={theme.primary} />
                <div style={{ marginTop:6 }}>
                  <MediaAttach attachments={updMedia[t.id]||[]} setAttachments={v=>setUpdMedia(p=>({...p,[t.id]:typeof v==="function"?v(p[t.id]||[]):v}))} accent={theme.primary} folderId={mediaFolderId} accessToken={gUser?.accessToken} onError={msg=>{setSyncState("error");setSyncMsg(msg);}} />
                </div>
                <button onClick={()=>addUpd(t.id)} style={{ marginTop:5, padding:"7px 14px", background:grad, border:"none", borderRadius:8, color:"white", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>Post Update ↑</button>
              </div>
            )}
          </Card>

          {/* Comments */}
          <Card mb={28}>
            <Lbl ch={`Comments (${coms.length})`} />
            {coms.length===0 && <p style={{ color:"#334155", fontSize:15, textAlign:"center", padding:"8px 0" }}>No comments yet.</p>}
            {coms.map(c=>{
              const u=users.find(x=>x.id===c.userId);
              return (
                <div key={c.id} style={{ display:"flex", gap:8, marginBottom:10, paddingBottom:10, borderBottom:"1px solid #f8fafc" }}>
                  <div style={{ width:26, height:26, borderRadius:"50%", background:"linear-gradient(135deg,#f59e0b,#f97316)", display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:12, fontWeight:700, flexShrink:0 }}>{u?.avatar}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:2 }}>
                      <span style={{ color:"#1e293b", fontSize:14, fontWeight:700 }}>{u?.name} <span style={{ color:"#334155", fontWeight:400 }}>· {u?.role}</span></span>
                      <span style={{ color:"#334155", fontSize:12 }}>{fmt(c.timestamp)}</span>
                    </div>
                    {c.message && <p style={{ color:"#334155", fontSize:15, margin:0, lineHeight:1.5 }}><RichText text={c.message} /></p>}
                    <MediaGallery attachments={c.media||[]} />
                  </div>
                </div>
              );
            })}
            <div style={{ marginTop:7 }}>
              <MentionBox value={comIn[t.id]||""} onChange={v=>setComIn(p=>({...p,[t.id]:v}))} placeholder="Add a comment… @ to mention" users={users} rows={2} accent="#f59e0b" />
              <div style={{ marginTop:6 }}>
                <MediaAttach attachments={comMedia[t.id]||[]} setAttachments={v=>setComMedia(p=>({...p,[t.id]:typeof v==="function"?v(p[t.id]||[]):v}))} accent="#f59e0b" folderId={mediaFolderId} accessToken={gUser?.accessToken} onError={msg=>{setSyncState("error");setSyncMsg(msg);}} />
              </div>
              <button onClick={()=>addCom(t.id)} style={{ marginTop:5, padding:"7px 14px", background:"linear-gradient(135deg,#f59e0b,#f97316)", border:"none", borderRadius:8, color:"white", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>Post Comment 💬</button>
            </div>
          </Card>
        </div>

        {/* ── DELETE TASK CONFIRMATION MODAL ─────────────────────────────────── */}
        {delModal && (
          <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:600, display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
            <div style={{ background:"white", borderRadius:"20px 20px 0 0", padding:26, width:"100%", maxWidth:560, boxSizing:"border-box", fontFamily:"inherit" }}>
              {/* Icon + title */}
              <div style={{ textAlign:"center", marginBottom:16 }}>
                <div style={{ fontSize:44, marginBottom:6 }}>🗑️</div>
                <h3 style={{ margin:"0 0 4px", fontSize:17, color:"#1e293b" }}>Delete Task?</h3>
                <p style={{ color:"#334155", fontSize:16, margin:0, lineHeight:1.5 }}>
                  "<strong>{delModal.title}</strong>"
                </p>
              </div>

              {/* Warning box */}
              <div style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:12, padding:"13px 15px", marginBottom:16 }}>
                <p style={{ color:"#991b1b", fontSize:15, fontWeight:700, margin:"0 0 6px" }}>⚠️ This action cannot be undone</p>
                <ul style={{ color:"#b91c1c", fontSize:15, margin:0, paddingLeft:18, lineHeight:1.8 }}>
                  <li>The task and all its data will be permanently removed</li>
                  <li>All progress updates and comments will be deleted</li>
                  {delModal.hasMedia && (
                    <li style={{ fontWeight:700 }}>
                      This will delete {delModal.mediaCount} attached image{delModal.mediaCount!==1?"s/videos":" / video"} from the app and from all future backups
                    </li>
                  )}
                  <li>This task will no longer appear in any backup exported after this point</li>
                </ul>
                {delModal.hasMedia && (
                  <div style={{ marginTop:10, padding:"8px 10px", background:"#fee2e2", borderRadius:8, display:"flex", gap:8, alignItems:"flex-start" }}>
                    <span style={{ fontSize:16, flexShrink:0 }}>📸</span>
                    <p style={{ color:"#7f1d1d", fontSize:14, margin:0, lineHeight:1.5 }}>
                      <strong>Media files detected:</strong> {delModal.mediaCount} image{delModal.mediaCount!==1?"s/videos":" / video"} attached to this task will be permanently erased from app storage and will not be included in future backups. Download a backup first if you need to keep them.
                    </p>
                  </div>
                )}
              </div>

              {/* Tip: backup first */}
              <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:10, padding:"10px 13px", marginBottom:18, display:"flex", gap:9, alignItems:"center" }}>
                <span style={{ fontSize:18 }}>💡</span>
                <p style={{ color:"#1d4ed8", fontSize:14, margin:0, lineHeight:1.4 }}>
                  Tip: Download a backup first (💾 in the header) so you can restore this task later if needed.
                </p>
              </div>

              <div style={{ display:"flex", gap:10 }}>
                <button onClick={()=>setDelModal(null)} style={{ flex:1, padding:"12px", borderRadius:11, border:"1px solid #e2e8f0", background:"white", color:"#334155", fontSize:16, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                  Cancel
                </button>
                <button onClick={confirmDeleteTask} style={{ flex:1, padding:"12px", borderRadius:11, border:"none", background:"linear-gradient(135deg,#ef4444,#dc2626)", color:"white", fontSize:16, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                  Yes, Delete Permanently
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
      </div>
    );
  }

  // ══════════════════════════════════════════════════════════════════════════
  // DASHBOARD
  // ══════════════════════════════════════════════════════════════════════════
  return (
    <div style={{ minHeight:"100vh", background:"#cecece", display:"flex", justifyContent:"center" }}
      onMouseMove={resetIdleTimer}
      onKeyDown={resetIdleTimer}>
    <div style={{ width:"100%", maxWidth:1000, minHeight:"100vh", background:"#f8fafc", fontFamily:"system-ui,-apple-system,sans-serif", fontSize:16, position:"relative", boxShadow:"0 0 40px rgba(0,0,0,0.12)" }}
      onTouchStart={resetIdleTimer}
      onClick={resetIdleTimer}>
      <ToastContainer toasts={toasts} onDismiss={dismissToast} onAction={handleToastAction} />
      <SyncBar />
      <SigModal />
      {/* ── IDLE WARNING ── */}
      {showIdleWarn && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:900, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
          <div style={{ background:"white", borderRadius:20, padding:28, width:"100%", maxWidth:360, boxSizing:"border-box", fontFamily:"inherit", textAlign:"center" }}>
            <div style={{ fontSize:40, marginBottom:12 }}>⏱️</div>
            <h3 style={{ margin:"0 0 8px", fontSize:18, color:"#1e293b" }}>Still there?</h3>
            <p style={{ color:"#475569", fontSize:15, margin:"0 0 20px", lineHeight:1.6 }}>You'll be signed out in 1 minute due to inactivity.</p>
            <button onClick={resetIdleTimer} style={{ width:"100%", padding:13, background:"linear-gradient(135deg,#7c3aed,#6d28d9)", border:"none", borderRadius:12, color:"white", fontSize:16, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
              I'm still here
            </button>
          </div>
        </div>
      )}
      <WsSwitcher />
      <AboutPage />
      <WelcomePopup />

      {/* ── NOTIFICATIONS ───────────────────────────────────────────────────── */}
      {showNotif && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:150 }} onClick={()=>setShowNotif(false)}>
          <div style={{ position:"absolute", top:0, right:"max(0px, calc((100% - 1000px)/2))", bottom:0, width:"85%", maxWidth:370, background:"white", overflowY:"auto", padding:18, paddingTop:18+sbHeight, fontFamily:"inherit" }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:16 }}>
              <h3 style={{ margin:0, fontSize:16, color:"#1e293b" }}>🔔 Notifications</h3>
              <button onClick={()=>setShowNotif(false)} style={{ background:"#f1f5f9", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>✕</button>
            </div>
            {notifs.length===0 && <p style={{ color:"#334155", textAlign:"center", padding:20 }}>All clear!</p>}
            {notifs.map(n=>{
              const icon={missed:"⚠️",urgent:"🔴",reminder:"🔔",done:"✅",mention:"💬"}[n.type];
              const col ={missed:"#ef4444",urgent:"#f59e0b",reminder:theme.primary,done:"#10b981",mention:"#6366f1"}[n.type];
              return (
                <div key={n.id} onClick={()=>{setSel(n.task.id); setShowNotif(false); setUnreadMentions(prev=>{ const next=new Set(prev); next.delete(n.task.id); try{localStorage.setItem("tt_unread_mentions",JSON.stringify([...next]));}catch(e){} try{const d=JSON.parse(localStorage.getItem("tt_mention_details")||"[]").filter(m=>m.taskId!==n.task.id);localStorage.setItem("tt_mention_details",JSON.stringify(d));}catch(e){} return next; });}} style={{ padding:"10px 12px", borderRadius:10, marginBottom:7, cursor:"pointer", background:"#f8fafc", borderLeft:`3px solid ${col}` }}>
                  <div style={{ display:"flex", gap:7 }}><span>{icon}</span><div><p style={{ color:"#1e293b", fontSize:15, margin:"0 0 2px", lineHeight:1.4 }}>{n.msg}</p><p style={{ color:"#334155", fontSize:12, margin:0 }}>{fmt(n.time)}</p></div></div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── EMAIL LOG ────────────────────────────────────────────────────────── */}
      {/* ── TASK LOG ────────────────────────────────────────────────────────── */}
      {showTaskLog && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:150 }} onClick={()=>setShowTaskLog(false)}>
          <div style={{ position:"absolute", top:0, right:"max(0px, calc((100% - 1000px)/2))", bottom:0, width:"92%", maxWidth:460, background:"white", overflowY:"auto", fontFamily:"inherit" }} onClick={e=>e.stopPropagation()}>
            <div style={{ background:headerBg, paddingTop:18+sbHeight, paddingBottom:"16px", paddingLeft:"18px", paddingRight:"18px", position:"sticky", top:0, zIndex:10 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
                <h3 style={{ margin:0, fontSize:16, color:"white", fontWeight:700 }}>📋 Task Log</h3>
                <button onClick={()=>setShowTaskLog(false)} style={{ background:"rgba(255,255,255,0.12)", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", color:"white", fontFamily:"inherit" }}>✕</button>
              </div>
              <p style={{ color:"rgba(255,255,255,0.95)", fontSize:13, margin:0 }}>🔔 Push notifications · {notifSched.morningTime} morning + {notifSched.eveningTime} evening</p>
            </div>
            <div style={{ padding:16 }}>
              <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:11, padding:"11px 14px", marginBottom:14 }}>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                  <span style={{ fontSize:17 }}>🔔</span>
                  <span style={{ color:"#166534", fontSize:15, fontWeight:700 }}>Push notifications {notifSched.enabled?"active":"off"}</span>
                </div>
                <div style={{ display:"flex", gap:10 }}>
                  {notifSched.morningEnabled && notifSched.enabled && (
                    <div style={{ flex:1, background:"white", borderRadius:8, padding:"7px 10px", border:"1px solid #d1fae5" }}>
                      <div style={{ color:"#166534", fontSize:14, fontWeight:700 }}>🌅 Morning</div>
                      <div style={{ color:"#15803d", fontSize:16, fontWeight:700 }}>{notifSched.morningTime}</div>
                      <div style={{ color:"#334155", fontSize:12 }}>Today's tasks + urgent</div>
                    </div>
                  )}
                  {notifSched.eveningEnabled && notifSched.enabled && (
                    <div style={{ flex:1, background:"white", borderRadius:8, padding:"7px 10px", border:"1px solid #d1fae5" }}>
                      <div style={{ color:"#166634", fontSize:14, fontWeight:700 }}>🌇 End of Day</div>
                      <div style={{ color:"#15803d", fontSize:16, fontWeight:700 }}>{notifSched.eveningTime}</div>
                      <div style={{ color:"#334155", fontSize:12 }}>Progress + carry-forward</div>
                    </div>
                  )}
                </div>
              </div>
              <p style={{ color:"#334155", fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:1, marginBottom:10 }}>Today's Email Previews</p>
              {buildTaskLog().map(entry=>(
                <div key={entry.id} style={{ borderRadius:12, border:`1px solid ${entry.type==="morning"?"#bfdbfe":"#fed7aa"}`, overflow:"hidden", marginBottom:14 }}>
                  <div style={{ background:entry.type==="morning"?"#eff6ff":"#fff7ed", padding:"10px 14px", borderBottom:`1px solid ${entry.type==="morning"?"#bfdbfe":"#fed7aa"}` }}>
                    <div style={{ display:"flex", alignItems:"center", gap:7, marginBottom:4 }}>
                      <span style={{ fontSize:16 }}>{entry.type==="morning"?"🌅":"🌇"}</span>
                      <span style={{ color:"#1e293b", fontSize:15, fontWeight:700, lineHeight:1.3 }}>{entry.subject}</span>
                    </div>
                    <div style={{ display:"flex", gap:10 }}>
                      <span style={{ color:"#334155", fontSize:12 }}>To: {entry.to}</span>
                      <span style={{ color:"#334155", fontSize:12 }}>Scheduled: {entry.scheduled}</span>
                    </div>
                  </div>
                  <pre style={{ color:"#374151", fontSize:14, lineHeight:1.8, margin:0, padding:"12px 14px", fontFamily:"inherit", whiteSpace:"pre-wrap", background:"white" }}>{entry.body}</pre>
                </div>
              ))}
              <div style={{ background:"#fefce8", border:"1px solid #fef08a", borderRadius:11, padding:"13px 14px" }}>
                <p style={{ color:"#854d0e", fontSize:15, fontWeight:700, margin:"0 0 6px" }}>📜 Powered by Google Apps Script</p>
                <p style={{ color:"#92400e", fontSize:14, margin:"0 0 6px", lineHeight:1.6 }}>Emails are sent automatically by a script inside your Google Sheet — free, no external service, runs on Google's servers.</p>
                <p style={{ color:"#92400e", fontSize:13, margin:0, lineHeight:1.5 }}>One-time setup: Sheet → Extensions → Apps Script → paste script → set time trigger. Done forever.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── EMAIL SCHEDULE SETTINGS ───────────────────────────────────────────── */}

      {/* ── COMPANY PREFERENCES ──────────────────────────────────────────────── */}
      {showPrefs && me.role==="manager" && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:150, display:"flex", alignItems:"flex-end", justifyContent:"center" }} onClick={()=>setShowPrefs(false)}>
          <div style={{ background:"white", borderRadius:"20px 20px 0 0", padding:22, width:"100%", maxWidth:560, maxHeight:"92vh", overflowY:"auto", boxSizing:"border-box", fontFamily:"inherit" }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18 }}>
              <div>
                <h3 style={{ margin:"0 0 2px", fontSize:17, color:"#1e293b" }}>⚙️ Company Preferences</h3>
                <p style={{ margin:0, fontSize:14, color:"#334155" }}>Customise Tasks Therapy for your organisation</p>
              </div>
              <button onClick={()=>setShowPrefs(false)} style={{ background:"#f1f5f9", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>✕</button>
            </div>

            {/* Company Name */}
            <div style={{ marginBottom:16 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", marginBottom:4 }}>
                <label style={{ ...lbl, margin:0 }}>Company Name</label>
                <span style={{ fontSize:12, color: pf.name.length>=23?"#ef4444":"#94a3b8" }}>{pf.name.length}/25</span>
              </div>
              <input value={pf.name} onChange={e=>setPf(p=>({...p,name:e.target.value.slice(0,25)}))} placeholder="Your company name" maxLength={25} style={inp} />
            </div>

            {/* Logo */}
            <div style={{ marginBottom:18 }}>
              <label style={lbl}>Company Logo</label>
              <div style={{ display:"flex", alignItems:"center", gap:14 }}>
                <div style={{ width:68, height:68, borderRadius:14, border:"2px dashed #e2e8f0", display:"flex", alignItems:"center", justifyContent:"center", background:"#f8fafc", flexShrink:0, overflow:"hidden" }}>
                  {pf.logo ? <img src={pf.logo} alt="logo" style={{ width:"100%", height:"100%", objectFit:"contain" }} /> : <span style={{ fontSize:28, color:"#475569" }}>🏢</span>}
                </div>
                <div style={{ flex:1 }}>
                  <input ref={logoRef} type="file" accept="image/*" onChange={onLogo} style={{ display:"none" }} />
                  <button onClick={()=>logoRef.current?.click()} style={{ width:"100%", padding:"9px 12px", borderRadius:9, border:"1.5px dashed #cbd5e1", background:"#f8fafc", color:"#334155", fontSize:15, cursor:"pointer", fontFamily:"inherit", fontWeight:600, marginBottom:6 }}>📤 Upload Logo</button>
                  {pf.logo && <button onClick={()=>setPf(p=>({...p,logo:""}))} style={{ width:"100%", padding:"7px 12px", borderRadius:9, border:"1px solid #fecaca", background:"#fef2f2", color:"#ef4444", fontSize:14, cursor:"pointer", fontFamily:"inherit" }}>Remove Logo</button>}
                  <p style={{ color:"#334155", fontSize:13, margin:"5px 0 0" }}>PNG, JPG or SVG · Shown on login & header</p>
                </div>
              </div>
            </div>

            {/* Colour Theme */}
            <div style={{ marginBottom:20 }}>
              <label style={lbl}>Colour Theme</label>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8, marginBottom:14 }}>
                {THEMES.map((t,i)=>(
                  <button key={i} onClick={()=>setPf(p=>({...p,themeIdx:i}))}
                    style={{ padding:"10px 6px", borderRadius:10, border:pf.themeIdx===i?`2.5px solid ${t.primary}`:"1.5px solid #e2e8f0", background:pf.themeIdx===i?`${t.primary}12`:"white", cursor:"pointer", fontFamily:"inherit", transition:"all 0.15s" }}>
                    <div style={{ width:22, height:22, borderRadius:"50%", background:`linear-gradient(135deg,${t.primary},${t.secondary})`, margin:"0 auto 5px" }} />
                    <div style={{ fontSize:12, color:pf.themeIdx===i?t.primary:"#64748b", fontWeight:pf.themeIdx===i?700:400 }}>{t.name}</div>
                  </button>
                ))}
              </div>
              {/* Live Preview */}
              <div style={{ borderRadius:12, overflow:"hidden", border:"1px solid #e2e8f0" }}>
                <div style={{ background:`linear-gradient(135deg,${(THEMES[pf.themeIdx]||THEMES[0]).dark},${(THEMES[pf.themeIdx]||THEMES[0]).darker})`, padding:"12px 16px", display:"flex", alignItems:"center", gap:10 }}>
                  {pf.logo ? <img src={pf.logo} alt="" style={{ width:30, height:30, borderRadius:8, objectFit:"contain", background:"white", padding:2 }} /> : <div style={{ fontSize:22 }}>🩺</div>}
                  <div>
                    <div style={{ color:"white", fontSize:17, fontWeight:700 }}>Tasks Therapy</div>
                    <div style={{ color:"rgba(255,255,255,0.92)", fontSize:13 }}>{pf.name||"Your Company"}</div>
                  </div>
                  <div style={{ marginLeft:"auto", background:`linear-gradient(135deg,${(THEMES[pf.themeIdx]||THEMES[0]).primary},${(THEMES[pf.themeIdx]||THEMES[0]).secondary})`, borderRadius:7, padding:"5px 10px", color:"white", fontSize:13, fontWeight:700 }}>Preview</div>
                </div>
                <div style={{ padding:"9px 14px", background:"#f8fafc" }}>
                  <p style={{ fontSize:13, color:"#334155", margin:0 }}>Live preview of your app header</p>
                </div>
              </div>
            </div>

            {/* Media Storage Setting */}
            <div style={{ marginBottom:20 }}>
              <label style={lbl}>📎 Media Storage (Images & Videos)</label>
              <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                <button onClick={()=>setMediaStorage("drive")}
                  style={{ display:"flex", alignItems:"flex-start", gap:12, padding:"12px 14px", borderRadius:11, border:`1.5px solid ${mediaStorage==="drive"?"#0284c7":"#e2e8f0"}`, background:mediaStorage==="drive"?"#f0f9ff":"white", cursor:"pointer", fontFamily:"inherit", textAlign:"left" }}>
                  <div style={{ width:18, height:18, borderRadius:"50%", border:`2px solid ${mediaStorage==="drive"?"#0284c7":"#cbd5e1"}`, background:mediaStorage==="drive"?"#0284c7":"white", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:1 }}>
                    {mediaStorage==="drive" && <div style={{ width:7, height:7, borderRadius:"50%", background:"white" }} />}
                  </div>
                  <div>
                    <div style={{ color:mediaStorage==="drive"?"#0284c7":"#1e293b", fontSize:16, fontWeight:700 }}>☁️ Google Drive (Recommended)</div>
                    <div style={{ color:"#334155", fontSize:14, marginTop:2, lineHeight:1.4 }}>Files are saved to your structured Drive folder and synced to all team devices.</div>
                    <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:6, padding:"5px 8px", marginTop:6, fontFamily:"monospace" }}>
                      <div style={{ color:"#1e40af", fontSize:13, marginBottom:2 }}>📁 Tasks Therapy — {company.name}</div>
                      <div style={{ color:"#3b82f6", fontSize:12, paddingLeft:12 }}>└── 📁 Media → 📁 task_[id]_[title]</div>
                    </div>
                  </div>
                </button>

                <button onClick={()=>setMediaStorage("local")}
                  style={{ display:"flex", alignItems:"flex-start", gap:12, padding:"12px 14px", borderRadius:11, border:`1.5px solid ${mediaStorage==="local"?"#f59e0b":"#e2e8f0"}`, background:mediaStorage==="local"?"#fffbeb":"white", cursor:"pointer", fontFamily:"inherit", textAlign:"left" }}>
                  <div style={{ width:18, height:18, borderRadius:"50%", border:`2px solid ${mediaStorage==="local"?"#f59e0b":"#cbd5e1"}`, background:mediaStorage==="local"?"#f59e0b":"white", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:1 }}>
                    {mediaStorage==="local" && <div style={{ width:7, height:7, borderRadius:"50%", background:"white" }} />}
                  </div>
                  <div>
                    <div style={{ color:mediaStorage==="local"?"#d97706":"#1e293b", fontSize:16, fontWeight:700 }}>📱 Local Device Only</div>
                    <div style={{ color:"#334155", fontSize:14, marginTop:2, lineHeight:1.4 }}>Images and videos are saved on each user's device only. Saves Google Drive space.</div>
                    <div style={{ background:"#fef3c7", border:"1px solid #fde68a", borderRadius:6, padding:"5px 8px", marginTop:6 }}>
                      <p style={{ color:"#92400e", fontSize:13, margin:0 }}>⚠️ Media will not sync to other devices or team members. Only visible to the person who uploaded it.</p>
                    </div>
                  </div>
                </button>
              </div>
            </div>

            {/* ── Push Notifications ── */}
            <div style={{ marginBottom:20 }}>
              <label style={lbl}>🔔 Daily Push Notifications</label>
              <div style={{ background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:12, padding:14 }}>
                {/* Master toggle */}
                <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom: notifSched.enabled ? 14 : 0 }}>
                  <div>
                    <div style={{ fontSize:15, fontWeight:700, color:"#1e293b" }}>Daily task reminders</div>
                    <div style={{ fontSize:13, color:"#64748b" }}>Morning briefing + end-of-day summary</div>
                  </div>
                  <button onClick={()=>{ const n={...notifSched, enabled:!notifSched.enabled}; setNotifSched(n); if(n.enabled){ scheduleNotifications(n,tasks,me,company); } else { cancelNotifications(); } }}
                    style={{ padding:"6px 18px", borderRadius:20, border:"none", background:notifSched.enabled?theme.primary:"#e2e8f0", color:notifSched.enabled?"white":"#94a3b8", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit", flexShrink:0 }}>
                    {notifSched.enabled?"ON":"OFF"}
                  </button>
                </div>
                {notifSched.enabled && (<>
                  {/* Morning */}
                  <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10, padding:"10px 12px", background:"#eff6ff", borderRadius:10 }}>
                    <span style={{ fontSize:20 }}>🌅</span>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:14, fontWeight:700, color:"#1e40af" }}>Morning Briefing</div>
                      <div style={{ fontSize:12, color:"#3b82f6" }}>Overdue · due today · open tasks</div>
                    </div>
                    <button onClick={()=>setNotifSched(p=>({...p,morningEnabled:!p.morningEnabled}))}
                      style={{ padding:"4px 12px", borderRadius:20, border:"none", background:notifSched.morningEnabled?"#2563eb":"#e2e8f0", color:notifSched.morningEnabled?"white":"#94a3b8", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                      {notifSched.morningEnabled?"ON":"OFF"}
                    </button>
                  </div>
                  {notifSched.morningEnabled && (
                    <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10, paddingLeft:8 }}>
                      <label style={{ fontSize:13, color:"#1e40af", fontWeight:600, whiteSpace:"nowrap" }}>Send at:</label>
                      <input type="time" value={notifSched.morningTime} onChange={e=>setNotifSched(p=>({...p,morningTime:e.target.value}))}
                        style={{ padding:"6px 10px", borderRadius:8, border:"1px solid #bfdbfe", fontSize:16, fontFamily:"inherit", color:"#1e293b", fontWeight:700 }} />
                    </div>
                  )}
                  {/* Evening */}
                  <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10, padding:"10px 12px", background:"#fff7ed", borderRadius:10 }}>
                    <span style={{ fontSize:20 }}>🌇</span>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:14, fontWeight:700, color:"#9a3412" }}>End-of-Day Summary</div>
                      <div style={{ fontSize:12, color:"#ea580c" }}>Completed · still open · overdue</div>
                    </div>
                    <button onClick={()=>setNotifSched(p=>({...p,eveningEnabled:!p.eveningEnabled}))}
                      style={{ padding:"4px 12px", borderRadius:20, border:"none", background:notifSched.eveningEnabled?"#ea580c":"#e2e8f0", color:notifSched.eveningEnabled?"white":"#94a3b8", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                      {notifSched.eveningEnabled?"ON":"OFF"}
                    </button>
                  </div>
                  {notifSched.eveningEnabled && (
                    <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:6, paddingLeft:8 }}>
                      <label style={{ fontSize:13, color:"#9a3412", fontWeight:600, whiteSpace:"nowrap" }}>Send at:</label>
                      <input type="time" value={notifSched.eveningTime} onChange={e=>setNotifSched(p=>({...p,eveningTime:e.target.value}))}
                        style={{ padding:"6px 10px", borderRadius:8, border:"1px solid #fed7aa", fontSize:16, fontFamily:"inherit", color:"#1e293b", fontWeight:700 }} />
                    </div>
                  )}
                  <p style={{ fontSize:12, color:"#94a3b8", margin:"8px 0 0", textAlign:"center" }}>Each team member receives notifications based on their own tasks</p>
                </>)}
              </div>
            </div>

                        <button onClick={savePrefs} style={{ width:"100%", padding:13, background:`linear-gradient(135deg,${(THEMES[pf.themeIdx]||THEMES[0]).primary},${(THEMES[pf.themeIdx]||THEMES[0]).secondary})`, border:"none", borderRadius:12, color:"white", fontSize:17, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>Save Preferences</button>

                      {/* Delete Workspace */}
                      <div style={{ marginTop:24, paddingTop:20, borderTop:"1px solid #fee2e2" }}>
                        <div style={{ fontSize:13, color:"#94a3b8", marginBottom:10, lineHeight:1.5 }}>
                          ⚠️ Deleting this workspace removes it from the app for all members. Your Google Sheet and files in Google Drive will NOT be deleted — you can still access them directly from your Drive.
                        </div>
                        <button onClick={()=>setShowDeleteConfirm(true)}
                          style={{ width:"100%", padding:11, background:"#fef2f2", border:"1px solid #fecaca", borderRadius:10, color:"#dc2626", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                          🗑 Delete Workspace
                        </button>
                      </div>
          </div>
        </div>
      )}

      {/* ── DELETE WORKSPACE CONFIRMATION ─────────────────────────────────────── */}
      {showDeleteConfirm && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:300, display:"flex", alignItems:"flex-end", justifyContent:"center" }}
          onClick={()=>setShowDeleteConfirm(false)}>
          <div style={{ background:"white", borderRadius:"20px 20px 0 0", padding:"24px 24px 40px", width:"100%", maxWidth:560, boxSizing:"border-box", fontFamily:"inherit" }}
            onClick={e=>e.stopPropagation()}>
            <div style={{ width:36, height:4, background:"#e2e8f0", borderRadius:4, margin:"0 auto 20px" }} />
            <div style={{ fontSize:17, fontWeight:700, color:"#dc2626", marginBottom:8 }}>🗑 Delete Workspace</div>
            <div style={{ fontSize:14, color:"#64748b", lineHeight:1.6, marginBottom:24 }}>
              This removes the workspace from Tasks Therapy for all members.<br/><br/>
              Your Google Sheet and Drive files will NOT be deleted — you can still access them from Google Drive.
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={()=>setShowDeleteConfirm(false)}
                style={{ flex:1, padding:13, background:"#f1f5f9", border:"none", borderRadius:10, color:"#64748b", fontSize:15, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>
                Cancel
              </button>
              <button onClick={()=>{
                setShowDeleteConfirm(false);
                const updWs = workspaces.filter(w=>w.id!==activeWsId);
                (async()=>{
                  try { await saveWorkspaceIndex(updWs, gUser); } catch(e) {}
                  await doSignOut(updWs.length > 0);
                  if (updWs.length > 0) setWorkspaces(updWs);
                })();
              }}
                style={{ flex:2, padding:13, background:"#dc2626", border:"none", borderRadius:10, color:"white", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                Delete Workspace
               </button>
            </div>
          </div>
        </div>
      )}

      {/* ── BACKUP & STORAGE (manager only) ──────────────────────────────────── */}
      {showBkp && me.role==="manager" && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:150, display:"flex", alignItems:"flex-end", justifyContent:"center" }} onClick={()=>setShowBkp(false)}>
          <div style={{ background:"white", borderRadius:"20px 20px 0 0", padding:22, width:"100%", maxWidth:560, maxHeight:"94vh", overflowY:"auto", boxSizing:"border-box", fontFamily:"inherit" }} onClick={e=>e.stopPropagation()}>

            {/* Header */}
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18 }}>
              <div>
                <h3 style={{ margin:"0 0 2px", fontSize:17, color:"#1e293b" }}>💾 Backup & Storage</h3>
                <p style={{ margin:0, fontSize:14, color:"#334155" }}>Google Sheets primary · device cache for offline · {mediaStorage==="drive"?"Drive":"filesystem"} for media</p>
              </div>
              <button onClick={()=>setShowBkp(false)} style={{ background:"#f1f5f9", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>✕</button>
            </div>

            {/* Google Drive folder structure */}
            <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:12, padding:"14px 15px", marginBottom:10 }}>
              <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:12 }}>
                <span style={{ fontSize:20 }}>☁️</span>
                <div>
                  <div style={{ color:"#166534", fontSize:16, fontWeight:700 }}>Google Drive — Active</div>
                  <div style={{ color:"#15803d", fontSize:13 }}>All data syncing to your Drive</div>
                </div>
              </div>

              {/* Folder tree */}
              <div style={{ background:"white", borderRadius:10, border:"1px solid #d1fae5", padding:"10px 12px", marginBottom:10, fontFamily:"monospace" }}>
                <div style={{ fontSize:14, color:"#374151", marginBottom:5 }}>
                  <span style={{ color:"#374151" }}>📁 </span>
                  <span style={{ fontWeight:700, color:"#1e293b" }}>Tasks Therapy — {company.name}</span>
                  <span style={{ color:"#374151", fontSize:12, marginLeft:6 }}>root folder</span>
                </div>
                <div style={{ paddingLeft:18, borderLeft:"2px solid #d1fae5", marginLeft:6 }}>
                  <div style={{ fontSize:14, color:"#374151", marginBottom:4 }}>
                    <span style={{ color:"#10b981" }}>📊 </span>
                    <span style={{ color:"#1e293b" }}>TasksTherapy_Data</span>
                    <span style={{ color:"#374151", fontSize:12, marginLeft:6 }}>spreadsheet · all task data</span>
                  </div>
                  <div style={{ fontSize:14, color:"#374151", marginBottom: mediaStorage==="drive" ? 4 : 0 }}>
                    <span style={{ color:"#f59e0b" }}>📁 </span>
                    <span style={{ color:"#1e293b" }}>Media</span>
                    <span style={{ color:mediaStorage==="drive"?"#9ca3af":"#ef4444", fontSize:12, marginLeft:6 }}>
                      {mediaStorage==="drive" ? "images & videos" : "⚠️ local-only mode — not syncing"}
                    </span>
                  </div>
                  {mediaStorage==="drive" && tasks.slice(0,3).map(t=>(
                    <div key={t.id} style={{ paddingLeft:18, borderLeft:"2px solid #fde68a", marginLeft:6, marginBottom:2 }}>
                      <div style={{ fontSize:13, color:"#92400e" }}>
                        <span>📁 </span>
                        <span>task_{t.id}_{t.title.replace(/\s+/g,"_").slice(0,20)}</span>
                        {(t.media||[]).length > 0 && <span style={{ color:"#374151", marginLeft:4 }}>{(t.media||[]).length} file{(t.media||[]).length!==1?"s":""}</span>}
                      </div>
                    </div>
                  ))}
                  {mediaStorage==="drive" && tasks.length > 3 && (
                    <div style={{ paddingLeft:18, marginLeft:6 }}>
                      <span style={{ fontSize:13, color:"#374151" }}>… {tasks.length - 3} more task folders</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Quick links */}
              <div style={{ display:"flex", gap:8 }}>
                <button onClick={()=>{ if(rootFolderId && rootFolderId!=="demo_folder_id") window.open(driveRootUrl,"_blank"); }}
                  style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", gap:5, padding:"8px 10px", borderRadius:8, background:"#dcfce7", border:"1px solid #bbf7d0", color:"#166534", fontSize:14, fontWeight:700, cursor:"pointer" }}>
                  📁 Open Drive Folder
                </button>
                <button onClick={()=>{ const ws = workspaces.find(w=>w.id===activeWsId); const sid = ws?.sheetId || activeWsId; if(sid) window.open(`https://docs.google.com/spreadsheets/d/${sid}`,"_blank"); }}
                  style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", gap:5, padding:"8px 10px", borderRadius:8, background:"#f0fdf4", border:"1px solid #bbf7d0", color:"#15803d", fontSize:14, fontWeight:700, cursor:"pointer" }}>
                  📊 Open Spreadsheet
                </button>
              </div>
            </div>

            {/* ── Storage overview: two separate concepts ── */}
            {(() => {
              try {
                // ── Cache: task data, users, settings (WebView localStorage, ~10 MB cap)
                let cacheBytes = 0;
                Object.values(LS).forEach(k => { const v=localStorage.getItem(k); if(v) cacheBytes+=v.length; });
                const cacheKb  = (cacheBytes/1024).toFixed(1);
                const CACHE_CAP = 10485760; // 10 MB WebView hard cap
                const cachePct  = Math.min(100, Math.round((cacheBytes/CACHE_CAP)*100));
                const cacheWarn = cachePct >= 70;

                // ── Media: images & videos (Capacitor Filesystem, device storage)
                const mediaCount = tasks.reduce((n,t)=>{
                  return n+(t.media||[]).length
                    +t.updates.reduce((s,u)=>s+(u.media||[]).length,0)
                    +(t.comments||[]).reduce((s,c)=>s+(c.media||[]).length,0);
                },0);
                // Estimate media size from base64 length (rough: 1 char ≈ 0.75 bytes)
                let mediaBytesEst = 0;
                tasks.forEach(t=>{
                  [...(t.media||[]),...(t.updates||[]).flatMap(u=>u.media||[]),...(t.comments||[]).flatMap(c=>c.media||[])].forEach(m=>{
                    if(m?.dataUrl) mediaBytesEst += m.dataUrl.length*0.75;
                  });
                });
                const mediaMb = (mediaBytesEst/1048576).toFixed(1);
                const doneTasks = tasks.filter(t=>t.status==="done");

                return (
                  <div style={{ marginBottom:16 }}>

                    {/* ── Card 1: Device Cache (task data) ── */}
                    <div style={{ background:cacheWarn?"#fef2f2":"#f8fafc", border:`1px solid ${cacheWarn?"#fecaca":"#e2e8f0"}`, borderRadius:12, padding:"12px 14px", marginBottom:10 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                        <span style={{ fontSize:18 }}>📱</span>
                        <div style={{ flex:1 }}>
                          <div style={{ color:cacheWarn?"#991b1b":"#1e293b", fontSize:15, fontWeight:700 }}>Device Cache — Task Data</div>
                          <div style={{ color:"#334155", fontSize:13 }}>Tasks, users, settings · stored in app's private storage</div>
                        </div>
                        <span style={{ color:cacheWarn?"#ef4444":"#10b981", fontSize:14, fontWeight:700 }}>{cacheKb} KB</span>
                      </div>
                      <div style={{ background:"#e2e8f0", borderRadius:99, height:6, overflow:"hidden", marginBottom:5 }}>
                        <div style={{ width:`${cachePct}%`, minWidth:cachePct>0?"4px":0, height:"100%", background:cachePct>=90?"#ef4444":cachePct>=70?"#f59e0b":"#10b981", borderRadius:99, transition:"width 0.4s" }} />
                      </div>
                      <div style={{ display:"flex", justifyContent:"space-between" }}>
                        <span style={{ color:"#334155", fontSize:12 }}>{cachePct}% of 10 MB cap · {tasks.length} tasks · {users.length} users</span>
                        <span style={{ color:"#334155", fontSize:12 }}>{doneTasks.length} completed</span>
                      </div>
                      {cacheWarn && (
                        <div style={{ marginTop:8, background:"#fef2f2", borderRadius:8, padding:"7px 10px" }}>
                          <p style={{ color:"#b91c1c", fontSize:13, margin:0, lineHeight:1.5 }}>
                            ⚠️ Device cache is {cachePct}% full. The app caches task data for offline access — the cap is 10 MB (Android WebView limit). Delete finished tasks or export a backup to free space. Media files are stored separately and don't count toward this limit.
                          </p>
                        </div>
                      )}
                      {!cacheWarn && (
                        <p style={{ color:"#334155", fontSize:12, margin:"5px 0 0", lineHeight:1.4 }}>
                          App cache holds task data for offline access. Cap is 10 MB (Android WebView) — well within normal usage. Media files are stored separately via {mediaStorage==="drive"?"Google Drive":"device filesystem"} and don't count here.
                        </p>
                      )}
                    </div>

                    {/* ── Card 2: Media Storage ── */}
                    <div style={{ background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:12, padding:"12px 14px", marginBottom:10 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6 }}>
                        <span style={{ fontSize:18 }}>{mediaStorage==="drive"?"☁️":"🗂️"}</span>
                        <div style={{ flex:1 }}>
                          <div style={{ color:"#1e293b", fontSize:15, fontWeight:700 }}>
                            {mediaStorage==="drive" ? "Media → Google Drive" : "Media → Device Filesystem"}
                          </div>
                          <div style={{ color:"#334155", fontSize:13 }}>
                            {mediaStorage==="drive"
                              ? "Images & videos upload to your Drive folder · no device space used"
                              : "Images & videos saved to app's private filesystem · no 10 MB cap"}
                          </div>
                        </div>
                        <span style={{ color:"#334155", fontSize:14, fontWeight:700 }}>{mediaCount} files</span>
                      </div>
                      {mediaBytesEst > 0 && (
                        <p style={{ color:"#334155", fontSize:12, margin:"4px 0 0" }}>
                          ~{mediaMb} MB estimated · {mediaStorage==="drive"?"stored in Google Drive, not on device":"stored in app private filesystem"}
                        </p>
                      )}
                      {mediaBytesEst === 0 && (
                        <p style={{ color:"#334155", fontSize:12, margin:"4px 0 0" }}>No media attached to tasks yet.</p>
                      )}
                    </div>

                    {/* ── Summary footnote ── */}
                    <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:9, padding:"8px 12px" }}>
                      <p style={{ color:"#15803d", fontSize:13, margin:0, lineHeight:1.6 }}>
                        ✅ <strong>Android best practice:</strong> Task data is cached in the app's private WebView storage (10 MB cap, always fast). Media files go to {mediaStorage==="drive"?"Google Drive (recommended — unlimited)":"the device filesystem (unlimited, private to app)"}. Google Sheets is the primary database — the device cache is just for speed and offline use.
                      </p>
                    </div>
                  </div>
                );
              } catch { return null; }
            })()}

            {/* Divider */}
            <div style={{ borderTop:"1px solid #f1f5f9", margin:"4px 0 16px" }} />

            {/* Manual backup & import row */}
            <label style={lbl}>Manual Backup & Restore</label>
            <div style={{ display:"flex", gap:8, marginBottom:8 }}>
              <button onClick={()=>doBackup(false)} style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", gap:6, padding:"11px 10px", borderRadius:10, border:"none", background:grad, color:"white", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                ⬇️ Download Backup
              </button>
              <button onClick={()=>importRef.current?.click()} style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", gap:6, padding:"11px 10px", borderRadius:10, border:`1.5px solid ${theme.primary}`, background:"white", color:theme.primary, fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                ⬆️ Restore from File
              </button>
            </div>
            <input ref={importRef} type="file" accept=".json" onChange={doImport} style={{ display:"none" }} />
            <p style={{ color:"#334155", fontSize:13, margin:"0 0 16px" }}>
              Backup saves task data only (not media files). Media stays safely in your Google Drive. Restoring will overwrite your Google Sheet with the backup data.
            </p>

            {/* Divider */}
            <div style={{ borderTop:"1px solid #f1f5f9", margin:"4px 0 16px" }} />

            {/* Auto-backup settings */}
            <label style={lbl}>Automatic Backup Schedule</label>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:7, marginBottom:10 }}>
              {BACKUP_OPTS.map(opt=>(
                <button key={opt.label} onClick={()=>setBkpCfg(p=>({...p, intervalMs:opt.ms, enabled:opt.ms>0}))}
                  style={{ padding:"10px 4px", borderRadius:10, border:`1.5px solid ${(bkpCfg.intervalMs===opt.ms&&(opt.ms===0?!bkpCfg.enabled:bkpCfg.enabled))?theme.primary:"#e2e8f0"}`, background:(bkpCfg.intervalMs===opt.ms&&(opt.ms===0?!bkpCfg.enabled:bkpCfg.enabled))?`${theme.primary}12`:"white", cursor:"pointer", fontFamily:"inherit" }}>
                  <div style={{ fontSize:17, marginBottom:3 }}>
                    {opt.label==="Off"?"🔕":opt.label==="Hourly"?"⏰":opt.label==="Daily"?"📅":"🗓️"}
                  </div>
                  <div style={{ fontSize:12, fontWeight:700, color:(bkpCfg.intervalMs===opt.ms&&(opt.ms===0?!bkpCfg.enabled:bkpCfg.enabled))?theme.primary:"#64748b" }}>
                    {opt.label}
                  </div>
                </button>
              ))}
            </div>

            {/* Schedule status */}
            {bkpCfg.enabled && bkpCfg.intervalMs>0 ? (
              <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:9, padding:"9px 12px", marginBottom:12, fontSize:14, color:"#1d4ed8" }}>
                🔄 Auto-backup is <strong>ON</strong> — {BACKUP_OPTS.find(o=>o.ms===bkpCfg.intervalMs)?.label||"Custom"}.
                {bkpCfg.lastBackup
                  ? ` Last backup: ${new Date(bkpCfg.lastBackup).toLocaleString()}`
                  : " First backup will run shortly."}
              </div>
            ) : (
              <div style={{ background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:9, padding:"9px 12px", marginBottom:12, fontSize:14, color:"#334155" }}>
                ⏸️ Auto-backup is <strong>off</strong>. Select a schedule above to enable it.
              </div>
            )}

            {/* Download folder note — Android */}
            <div style={{ background:"#fefce8", border:"1px solid #fef08a", borderRadius:9, padding:"10px 13px", marginBottom:16 }}>
              <p style={{ color:"#854d0e", fontSize:14, margin:"0 0 6px", fontWeight:700 }}>📁 Where backups are saved on Android</p>
              <p style={{ color:"#92400e", fontSize:13, margin:"0 0 6px", lineHeight:1.5 }}>
                Backup files save to your device's <strong>Downloads</strong> folder automatically. To move or share them:
              </p>
              <ul style={{ color:"#92400e", fontSize:13, margin:"0", paddingLeft:16, lineHeight:1.8 }}>
                <li>Open <strong>Files by Google</strong> (or any file manager) → Downloads</li>
                <li>Tap the backup file → <strong>Share</strong> to save to Google Drive, send by email, or copy to another folder</li>
                <li>Android 10+ makes Downloads accessible to all apps automatically</li>
              </ul>
            </div>

            {/* Divider */}
            <div style={{ borderTop:"1px solid #f1f5f9", margin:"4px 0 16px" }} />

            {/* Bulk delete finished tasks */}
            {(() => {
              const doneTasks = tasks.filter(t=>t.status==="done");
              const doneMedia = doneTasks.reduce((n,t)=>{
                return n+(t.media||[]).length
                  +t.updates.reduce((s,u)=>s+(u.media||[]).length,0)
                  +(t.comments||[]).reduce((s,c)=>s+(c.media||[]).length,0);
              },0);
              if (doneTasks.length === 0) return null;
              return (
                <div style={{ background:"#fff7ed", border:"1px solid #fed7aa", borderRadius:12, padding:"13px 15px", marginBottom:16 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
                    <span style={{ fontSize:22 }}>🧹</span>
                    <div>
                      <div style={{ color:"#92400e", fontSize:16, fontWeight:700 }}>Free Up Space</div>
                      <div style={{ color:"#b45309", fontSize:14 }}>
                        {doneTasks.length} finished task{doneTasks.length!==1?"s":""} found
                        {doneMedia>0 ? ` · ${doneMedia} media file${doneMedia!==1?"s":""}` : " · no media attached"}
                      </div>
                    </div>
                  </div>
                  <p style={{ color:"#92400e", fontSize:14, margin:"0 0 10px", lineHeight:1.5 }}>
                    Deleting finished tasks removes them permanently from the app and from all future backups.
                    {doneMedia>0 && <strong> This includes {doneMedia} attached image{doneMedia!==1?"s/videos":" / video"} which will be erased from storage.</strong>}
                  </p>
                  <button onClick={()=>{
                    if (false) return; // confirmed inline
                    const doneIds = new Set(doneTasks.map(t=>t.id));
                    setTasks(p=>p.filter(t=>!doneIds.has(t.id)));
                    logActivity("bulk_delete", `${doneTasks.length} finished tasks (${doneMedia} media files)`);
                    setBkpMsg(`✅ Deleted ${doneTasks.length} finished tasks and ${doneMedia} media files.`);
                  }} style={{ width:"100%", padding:"10px", borderRadius:9, border:"1px solid #fb923c", background:"white", color:"#ea580c", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                    🗑️ Delete All {doneTasks.length} Finished Task{doneTasks.length!==1?"s":""}
                    {doneMedia>0 && ` & ${doneMedia} Media File${doneMedia!==1?"s":""}`}
                  </button>
                </div>
              );
            })()}

            {/* Divider */}
            <div style={{ borderTop:"1px solid #f1f5f9", margin:"4px 0 16px" }} />

            {/* Activity log */}
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
              <label style={{...lbl, margin:0}}>Activity Log ({actLog.length})</label>
              {actLog.length>0 && <button onClick={()=>{ triggerDownload(actLog, `TasksTherapy_Log_${Date.now()}.json`); }} style={{ fontSize:13, color:theme.primary, background:"none", border:`1px solid ${theme.primary}30`, borderRadius:6, padding:"3px 8px", cursor:"pointer", fontFamily:"inherit" }}>Export Log</button>}
            </div>
            <div style={{ maxHeight:180, overflowY:"auto", borderRadius:10, border:"1px solid #f1f5f9" }}>
              {actLog.length===0 ? (
                <p style={{ color:"#334155", fontSize:14, textAlign:"center", padding:"16px 0" }}>No activity recorded yet.</p>
              ) : actLog.slice(0,50).map((entry,i)=>{
                const icons={"task_created":"✅","status_changed":"🔄","user_added":"👤+","user_updated":"✏️","user_removed":"🗑️","backup":"💾"};
                return (
                  <div key={entry.id||i} style={{ display:"flex", gap:9, padding:"8px 12px", borderBottom:i<actLog.slice(0,50).length-1?"1px solid #f8fafc":"none", background:i%2===0?"white":"#fafafa" }}>
                    <span style={{ fontSize:15, flexShrink:0, marginTop:1 }}>{icons[entry.action]||"•"}</span>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ color:"#1e293b", fontSize:14, fontWeight:600, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{entry.detail||entry.action}</div>
                      <div style={{ color:"#334155", fontSize:12 }}>{entry.userName} · {new Date(entry.ts).toLocaleString()}</div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Divider */}
            <div style={{ borderTop:"1px solid #f1f5f9", margin:"16px 0 12px" }} />

            {/* Danger zone */}
            <div style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:12, padding:"13px 15px" }}>
              <p style={{ color:"#991b1b", fontSize:15, fontWeight:700, margin:"0 0 6px" }}>⚠️ Danger Zone</p>
              <p style={{ color:"#b91c1c", fontSize:14, margin:"0 0 10px", lineHeight:1.5 }}>
                Clear all device cache and reset the app to factory defaults. This cannot be undone — download a backup first. Your Google Sheets data is unaffected.
              </p>
              {!showClearConfirm ? (
                <button onClick={()=>setShowClearConfirm(true)} style={{ padding:"9px 16px", borderRadius:9, border:"1px solid #fca5a5", background:"white", color:"#ef4444", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                  🗑️ Clear All Data & Reset
                </button>
              ) : (
                <div style={{ display:"flex", gap:8 }}>
                  <button onClick={()=>setShowClearConfirm(false)} style={{ flex:1, padding:"9px 0", borderRadius:9, border:"1px solid #e2e8f0", background:"#f8fafc", color:"#64748b", fontSize:14, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>
                    Cancel
                  </button>
                  <button onClick={()=>{ setShowClearConfirm(false); clearAllData(); }} style={{ flex:2, padding:"9px 0", borderRadius:9, border:"1px solid #fca5a5", background:"#fef2f2", color:"#ef4444", fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                    Yes, Reset Everything
                  </button>
                </div>
              )}
            </div>

            {bkpMsg && (
              <div style={{ marginTop:14, padding:"10px 14px", borderRadius:10, background:bkpMsg.startsWith("✅")?"#f0fdf4":"#fef2f2", border:`1px solid ${bkpMsg.startsWith("✅")?"#bbf7d0":"#fecaca"}`, color:bkpMsg.startsWith("✅")?"#166534":"#991b1b", fontSize:15, fontWeight:600 }}>
                {bkpMsg}
              </div>
            )}

          </div>
        </div>
      )}

            {/* ── USER MANAGER (manager only) ───────────────────────────────────────── */}
      {showUserMgr && me.role==="manager" && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:150, display:"flex", alignItems:"flex-end", justifyContent:"center" }} onClick={()=>{setShowUserMgr(false);setUmPanel("list");setUmErr("");}}>
          <div style={{ background:"white", borderRadius:"20px 20px 0 0", padding:22, width:"100%", maxWidth:560, maxHeight:"92vh", overflowY:"auto", boxSizing:"border-box", fontFamily:"inherit" }} onClick={e=>e.stopPropagation()}>

            {umPanel==="list" ? (
              <>
                {/* Header */}
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
                  <div>
                     <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <h3 style={{ margin:"0 0 2px", fontSize:17, color:"#1e293b" }}>👥 User Settings</h3>
                       <button onClick={()=>{const ws=workspaces.find(w=>w.id===activeWsId);if(ws?.sheetId&&gUser?.accessToken)fetch(`https://sheets.googleapis.com/v4/spreadsheets/${ws.sheetId}/values/Users`,{headers:{Authorization:`Bearer ${gUser.accessToken}`}}).then(r=>r.json()).then(d=>{const rows=d.values||[];if(rows.length>=2){const h=rows[0];const p=rows.slice(1).map(row=>{const o={};h.forEach((k,ii)=>{o[k]=row[ii]||"";}); if("pending" in o)o.pending=o.pending===true||o.pending==="true"||o.pending==="TRUE"; return o;}); mergeUsersFromSheet(p);}}).catch(()=>{});}} style={{fontSize:11,padding:"2px 8px",background:"#f1f5f9",border:"1px solid #e2e8f0",borderRadius:5,cursor:"pointer",color:"#64748b",fontFamily:"inherit"}}>↺</button>
                     </div>
                    <p style={{ margin:0, fontSize:14, color:"#334155" }}>{users.length} users · manage roles and access</p>
                  </div>
                  <div style={{ display:"flex", gap:7 }}>
                    <button onClick={openAddUser} style={{ background:grad, border:"none", borderRadius:8, padding:"7px 14px", cursor:"pointer", color:"white", fontSize:15, fontWeight:700, fontFamily:"inherit" }}>+ Add User</button>
                    <button onClick={()=>setShowUserMgr(false)} style={{ background:"#f1f5f9", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>✕</button>
                  </div>
                </div>

                {/* Role legend */}
                <div style={{ display:"flex", gap:6, marginBottom:16, padding:"10px 12px", background:"#f8fafc", borderRadius:10, border:"1px solid #f1f5f9" }}>
                  {Object.entries(ROLES).filter(([k])=>k!=="manager").map(([k,v])=>(
                    <div key={k} style={{ flex:1, textAlign:"center" }}>
                      <div style={{ fontSize:16, marginBottom:2 }}>{v.icon}</div>
                      <div style={{ fontSize:12, fontWeight:700, color:v.color }}>{v.label}</div>
                    </div>
                  ))}
                </div>

                {/* Workspace Code — manager only */}
                {me?.role==="manager" && (()=>{
                  const ws = workspaces.find(w=>w.id===activeWsId);
                  return ws?.sheetId ? (
                    <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:"10px 13px", marginBottom:14 }}>
                      <p style={{ color:"#15803d", fontSize:12, fontWeight:700, margin:"0 0 4px", textTransform:"uppercase", letterSpacing:1 }}>Workspace Code</p>
                      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                        <p style={{ color:"#166534", fontSize:13, margin:0, wordBreak:"break-all", flex:1, fontFamily:"monospace" }}>{ws.sheetId}</p>
                        <button onClick={()=>{ try { navigator.clipboard.writeText(ws.sheetId); } catch(e){} }}
                          style={{ background:"#16a34a", border:"none", borderRadius:7, padding:"5px 10px", color:"white", fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", flexShrink:0 }}>
                          Copy
                        </button>
                      </div>
                      <p style={{ color:"#15803d", fontSize:12, margin:"4px 0 0" }}>Share this code with users you invite so they can join the workspace.</p>
                    </div>
                  ) : null;
                })()}

                {/* User list */}
                {users.map(u=>{
                  const rc = ROLES[u.role]||ROLES.staff;
                  const taskCount = tasks.filter(t=>(Array.isArray(t.assignedTo)?t.assignedTo:[t.assignedTo]).includes(u.id)).length;
                  return (
                    <div key={u.id} style={{ display:"flex", alignItems:"center", gap:11, padding:"11px 13px", borderRadius:12, border:"1.5px solid #e2e8f0", marginBottom:8, background: u.id===me.id?"#f8f9ff":"#fafafa" }}>
                      {/* Avatar */}
                      <div style={{ width:38, height:38, borderRadius:"50%", background:grad, display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:16, fontWeight:700, flexShrink:0 }}>{u.avatar}</div>
                      {/* Info */}
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:2 }}>
                          <span style={{ color:"#1e293b", fontSize:16, fontWeight:700, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{u.name}</span>
                          {u.id===me.id && <span style={{ fontSize:11, background:`${theme.primary}18`, color:theme.primary, padding:"1px 6px", borderRadius:4, fontWeight:700, flexShrink:0 }}>You</span>}
                          
                        </div>
                        <div style={{ color:"#334155", fontSize:13, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{u.email}</div>
                        <div style={{ display:"flex", alignItems:"center", gap:6, marginTop:3 }}>
                          <span style={{ fontSize:12, padding:"1px 8px", borderRadius:9, background:rc.bg, color:rc.color, fontWeight:700 }}>{rc.icon} {rc.label}</span>
                          <span style={{ color:"#475569", fontSize:12 }}>{u.dept}</span>
                          <span style={{ color:"#475569", fontSize:12 }}>· {taskCount} task{taskCount!==1?"s":""}</span>
                        </div>
                      </div>
                      {/* Actions */}
                      <div style={{ display:"flex", flexDirection:"column", gap:5, flexShrink:0 }}>
                        <button onClick={()=>openEditUser(u)} style={{ padding:"4px 10px", borderRadius:7, border:`1px solid ${theme.primary}30`, background:`${theme.primary}10`, color:theme.primary, fontSize:13, cursor:"pointer", fontFamily:"inherit", fontWeight:700 }}>Edit</button>
                        {u.id!==me.id && (
                          <button onClick={()=>deleteUser(u.id)} style={{ padding:"4px 10px", borderRadius:7, border:"1px solid #fecaca", background:"#fef2f2", color:"#ef4444", fontSize:13, cursor:"pointer", fontFamily:"inherit", fontWeight:700 }}>Remove</button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {/* Add / Edit form */}
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18 }}>
                  <div>
                    <h3 style={{ margin:"0 0 2px", fontSize:17, color:"#1e293b" }}>{umEdit?"✏️ Edit User":"➕ Add New User"}</h3>
                    <p style={{ margin:0, fontSize:14, color:"#334155" }}>{umEdit?"Update name, email, role or department":"Add a Google account — they sign in with Google, no password needed"}</p>
                  </div>
                  <button onClick={()=>{setUmPanel("list");setUmErr("");}} style={{ background:"#f1f5f9", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>← Back</button>
                </div>

                {/* Name */}
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", marginBottom:4 }}>
                  <label style={{ ...lbl, margin:0 }}>Full Name *</label>
                  <span style={{ fontSize:12, color: umForm.name.length>=23?"#ef4444":"#94a3b8" }}>{umForm.name.length}/25</span>
                </div>
                <input value={umForm.name} onChange={e=>setUmForm(p=>({...p,name:e.target.value.slice(0,25)}))} placeholder="e.g. Jane Smith" maxLength={25}
                  style={{ ...inp, marginBottom:12 }} />

                {/* Email */}
                <label style={lbl}>Invite Email (any address) *</label>
                <input type="email" value={umForm.email} onChange={e=>setUmForm(p=>({...p,email:e.target.value}))} placeholder="e.g. jane@company.com or jane@gmail.com"
                  style={{ ...inp, marginBottom:12 }} />

                {/* Google sign-in note — replaces password */}
                <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:"10px 13px", marginBottom:12, display:"flex", gap:10, alignItems:"flex-start" }}>
                  <span style={{ fontSize:18, flexShrink:0 }}>🔐</span>
                  <div>
                    <p style={{ color:"#166534", fontSize:15, fontWeight:700, margin:"0 0 4px" }}>Any email works — no password needed</p>
                    <p style={{ color:"#15803d", fontSize:14, margin:0, lineHeight:1.5 }}>
                      {umEdit
                        ? "Use their work email, Gmail, or any address you communicate with. They sign in with whichever Google account they prefer — passwords are handled entirely by Google."
                        : "Enter the email you know them by — work email, Gmail, anything. On their first sign-in they'll confirm this email to link their Google account. They only do this once."}
                    </p>
                  </div>
                </div>

                {/* Department */}
                <label style={lbl}>Department</label>
                <input value={umForm.dept} onChange={e=>setUmForm(p=>({...p,dept:e.target.value}))} placeholder="e.g. Operations"
                  style={{ ...inp, marginBottom:14 }} />

                {/* Role picker */}
                <label style={lbl}>Role & Permissions *</label>
                <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:16 }}>
                  {Object.entries(ROLES).filter(([k])=>k!=="manager").map(([k,v])=>(
                    <button key={k} onClick={()=>setUmForm(p=>({...p,role:k}))}
                      style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 14px", borderRadius:11, border:`1.5px solid ${umForm.role===k?v.color:"#e2e8f0"}`, background:umForm.role===k?v.bg:"white", cursor:"pointer", fontFamily:"inherit", textAlign:"left", transition:"all 0.15s" }}>
                      <span style={{ fontSize:20, flexShrink:0 }}>{v.icon}</span>
                      <div style={{ flex:1 }}>
                        <div style={{ color:umForm.role===k?v.color:"#1e293b", fontSize:16, fontWeight:700, marginBottom:1 }}>{v.label}</div>
                        <div style={{ color:"#334155", fontSize:13, lineHeight:1.4 }}>{v.desc}</div>
                      </div>
                      <div style={{ width:18, height:18, borderRadius:"50%", border:`2px solid ${umForm.role===k?v.color:"#e2e8f0"}`, background:umForm.role===k?v.color:"white", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                        {umForm.role===k && <div style={{ width:7, height:7, borderRadius:"50%", background:"white" }} />}
                      </div>
                    </button>
                  ))}
                </div>

                {umErr && <p style={{ color:"#ef4444", fontSize:15, margin:"0 0 12px", padding:"8px 12px", background:"#fef2f2", borderRadius:8 }}>{umErr}</p>}
                {umEdit && <button onClick={()=>openMailInvite(umEdit)} style={{ width:"100%", padding:13, background:"white", border:`1px solid ${theme.primary}`, borderRadius:12, color:theme.primary, fontSize:16, fontWeight:700, cursor:"pointer", fontFamily:"inherit", marginBottom:10 }}>✉️ Send Invitation</button>}
                <button onClick={saveUser} style={{ width:"100%", padding:13, background:grad, border:"none", borderRadius:12, color:"white", fontSize:17, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>{umEdit?"Save Changes ✓":"Add User & Send Invite +"}</button>
              </>
            )}
          </div>
        </div>
      )}

      {/* ── CATEGORY MANAGER ─────────────────────────────────────────────────── */}
      {showCatMgr && (me.role==="manager"||me.role==="supervisor") && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:150, display:"flex", alignItems:"flex-end", justifyContent:"center" }} onClick={()=>{setShowCatMgr(false);setCatEdit(null);setCatErr("");setCatPanel("list");}}>
          <div style={{ background:"white", borderRadius:"20px 20px 0 0", padding:22, width:"100%", maxWidth:560, maxHeight:"88vh", overflowY:"auto", boxSizing:"border-box", fontFamily:"inherit" }} onClick={e=>e.stopPropagation()}>

            {catPanel==="list" ? (
              <>
                {/* Header */}
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
                  <div>
                    <h3 style={{ margin:"0 0 2px", fontSize:17, color:"#1e293b" }}>🏷 Task Categories</h3>
                    <p style={{ margin:0, fontSize:14, color:"#334155" }}>{cats.length} categories total</p>
                  </div>
                  <div style={{ display:"flex", gap:7 }}>
                    <button onClick={openNewCat} style={{ background:grad, border:"none", borderRadius:8, padding:"7px 14px", cursor:"pointer", color:"white", fontSize:15, fontWeight:700, fontFamily:"inherit" }}>+ Add</button>
                    <button onClick={()=>{setShowCatMgr(false);setCatEdit(null);setCatErr("");setCatPanel("list");}} style={{ background:"#f1f5f9", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>✕</button>
                  </div>
                </div>

                {/* Category list */}
                {cats.length===0 && <p style={{ color:"#334155", textAlign:"center", padding:"28px 0" }}>No categories yet. Press + Add to create one.</p>}
                {cats.map(cat=>{
                  const tc=tasks.filter(t=>t.categoryId===cat.id).length;
                  return (
                    <div key={cat.id} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"11px 13px", borderRadius:12, border:"1.5px solid #e2e8f0", marginBottom:8, background:"#fafafa" }}>
                      <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                        <div style={{ width:36, height:36, borderRadius:10, background:`${cat.color}18`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18 }}>{cat.icon||"📋"}</div>
                        <div>
                          <div style={{ color:"#1e293b", fontSize:16, fontWeight:700 }}>{cat.name}</div>
                          <div style={{ display:"flex", alignItems:"center", gap:6, marginTop:2 }}>
                            <div style={{ width:8, height:8, borderRadius:"50%", background:cat.color }} />
                            <span style={{ color:"#334155", fontSize:13 }}>{tc} task{tc!==1?"s":""}</span>
                          </div>
                        </div>
                      </div>
                      <div style={{ display:"flex", gap:6 }}>
                        <button onClick={()=>openEditCat(cat)} style={{ padding:"5px 11px", borderRadius:7, border:`1px solid ${cat.color}40`, background:`${cat.color}10`, color:cat.color, fontSize:14, cursor:"pointer", fontFamily:"inherit", fontWeight:700 }}>Edit</button>
                        <button onClick={()=>delCat(cat.id)} style={{ padding:"5px 11px", borderRadius:7, border:"1px solid #fecaca", background:"#fef2f2", color:"#ef4444", fontSize:14, cursor:"pointer", fontFamily:"inherit", fontWeight:700 }}>Delete</button>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {/* Form header */}
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18 }}>
                  <div>
                    <h3 style={{ margin:"0 0 2px", fontSize:17, color:"#1e293b" }}>{catEdit?"✏️ Edit Category":"➕ New Category"}</h3>
                    <p style={{ margin:0, fontSize:14, color:"#334155" }}>{catEdit?"Update name, colour and icon":"Add a new task category"}</p>
                  </div>
                  <button onClick={()=>{setCatPanel("list");setCatEdit(null);setCatErr("");}} style={{ background:"#f1f5f9", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>← Back</button>
                </div>

                {/* Name + colour */}
                <label style={lbl}>Category Name *</label>
                <div style={{ display:"flex", gap:8, marginBottom:14 }}>
                  <input value={catForm.name} onChange={e=>setCatForm(p=>({...p,name:e.target.value}))} placeholder="e.g. Marketing"
                    style={{ flex:1, ...inp }} />
                  <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
                    <input type="color" value={catForm.color} onChange={e=>setCatForm(p=>({...p,color:e.target.value}))}
                      style={{ width:42, height:42, borderRadius:9, border:"1px solid #e2e8f0", cursor:"pointer", padding:2 }} />
                    <span style={{ fontSize:11, color:"#334155" }}>Colour</span>
                  </div>
                </div>

                {/* Preview badge */}
                <div style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", borderRadius:10, background:`${catForm.color}12`, border:`1.5px solid ${catForm.color}30`, marginBottom:14 }}>
                  <div style={{ width:36, height:36, borderRadius:9, background:`${catForm.color}25`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20 }}>{catForm.icon}</div>
                  <div>
                    <div style={{ color:catForm.color, fontSize:16, fontWeight:700 }}>{catForm.name||"Category Name"}</div>
                    <div style={{ color:"#334155", fontSize:13 }}>Preview</div>
                  </div>
                </div>

                {/* Icon picker */}
                <label style={lbl}>Choose Icon</label>
                <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:16 }}>
                  {CAT_ICONS.map(ic=>(
                    <button key={ic} onClick={()=>setCatForm(p=>({...p,icon:ic}))}
                      style={{ width:36, height:36, borderRadius:8, border:`1.5px solid ${catForm.icon===ic?catForm.color:"#e2e8f0"}`, background:catForm.icon===ic?`${catForm.color}18`:"white", fontSize:18, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.1s" }}>
                      {ic}
                    </button>
                  ))}
                </div>

                {catErr && <p style={{ color:"#ef4444", fontSize:15, margin:"0 0 10px", padding:"8px 12px", background:"#fef2f2", borderRadius:8 }}>{catErr}</p>}
                <button onClick={saveCat} style={{ width:"100%", padding:13, background:grad, border:"none", borderRadius:12, color:"white", fontSize:17, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>{catEdit?"Save Changes ✓":"Add Category +"}</button>
              </>
            )}
          </div>
        </div>
      )}

      {/* ── CREATE TASK ──────────────────────────────────────────────────────── */}
      {showCreate && canManageTasks && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:150, display:"flex", alignItems:"flex-end", justifyContent:"center" }} onClick={()=>setShowCreate(false)}>
          <div style={{ background:"white", borderRadius:"20px 20px 0 0", padding:22, width:"100%", maxWidth:560, maxHeight:"92vh", overflowY:"auto", boxSizing:"border-box", fontFamily:"inherit" }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:16 }}>
              <h3 style={{ margin:0, fontSize:16, color:"#1e293b" }}>➕ Create New Task</h3>
              <button onClick={()=>setShowCreate(false)} style={{ background:"#f1f5f9", border:"none", borderRadius:7, padding:"5px 10px", cursor:"pointer", fontFamily:"inherit" }}>✕</button>
            </div>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", marginBottom:4 }}>
              <label style={{ ...lbl, margin:0 }}>Task Title *</label>
              <span style={{ fontSize:12, color: nt.title.length>=50?"#ef4444":"#94a3b8" }}>{nt.title.length}/55</span>
            </div>
            <input value={nt.title} onChange={e=>setNt(p=>({...p,title:e.target.value.slice(0,55)}))} placeholder="e.g. Prepare Monthly Report" maxLength={55} style={{ ...inp, marginBottom:12 }} />
            <label style={lbl}>Description (@ to mention)</label>
            <MentionBox value={nt.description} onChange={v=>setNt(p=>({...p,description:v}))} placeholder="Describe the task… @mention team" users={users} rows={3} accent={theme.primary} />
            <div style={{ height:12 }} />
            <label style={lbl}>Deadline *</label>
            <input type="datetime-local" value={nt.deadline} onChange={e=>setNt(p=>({...p,deadline:e.target.value}))} style={{ ...inp, marginBottom:12 }} />
            <div style={{ display:"flex", gap:8, marginBottom:12 }}>
              <div style={{ flex:1 }}>
                <label style={lbl}>Priority</label>
                <select value={nt.priority} onChange={e=>setNt(p=>({...p,priority:e.target.value}))} style={inp}>
                  <option value="high">High</option><option value="medium">Medium</option><option value="low">Low</option>
                </select>
              </div>
              <div style={{ flex:1 }}>
                <label style={lbl}>Category</label>
                <select value={nt.categoryId} onChange={e=>setNt(p=>({...p,categoryId:e.target.value}))} style={inp}>
                  {cats.map(c=><option key={c.id} value={c.id}>{c.icon} {c.name}</option>)}
                </select>
              </div>
            </div>
            <label style={lbl}>Assign To * <span style={{ fontWeight:400, color:"#475569", fontSize:13 }}>(select one or more)</span></label>
            <div style={{ border:"1px solid #e2e8f0", borderRadius:9, background:"white", marginBottom:showQuickInvite?10:14, overflow:"hidden" }}>
              {users.length===0
                ? <p style={{ color:"#475569", fontSize:14, margin:0, padding:"10px 12px" }}>No team members yet — invite someone below</p>
                : users.map(u=>{
                    const sel = nt.assignedTo.includes(u.id);
                    return (
                      <div key={u.id} onClick={()=>setNt(p=>({ ...p, assignedTo: sel ? p.assignedTo.filter(id=>id!==u.id) : [...p.assignedTo, u.id] }))}
                        style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 13px", borderBottom:"1px solid #f1f5f9", cursor:"pointer", background:sel?`${theme.primary}08`:"white" }}>
                        <div style={{ width:20, height:20, borderRadius:5, border:`2px solid ${sel?theme.primary:"#cbd5e1"}`, background:sel?theme.primary:"white", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                          {sel && <span style={{ color:"white", fontSize:13, fontWeight:700, lineHeight:1 }}>✓</span>}
                        </div>
                        <div style={{ width:28, height:28, borderRadius:"50%", background:`linear-gradient(135deg,${theme.primary},${theme.secondary})`, display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:11, fontWeight:700, flexShrink:0 }}>{u.avatar}</div>
                        <div style={{ flex:1 }}>
                          <div style={{ color:"#1e293b", fontSize:15, fontWeight:sel?700:400 }}>{u.name}</div>
                          <div style={{ color:"#475569", fontSize:12, textTransform:"capitalize" }}>{u.role}</div>
                        </div>
                      </div>
                    );
                  })
              }
              <div onClick={()=>setShowQuickInvite(true)}
                style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 13px", cursor:"pointer", background:"#f8fafc" }}>
                <div style={{ width:20, height:20, borderRadius:5, border:"1.5px dashed #cbd5e1", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                  <span style={{ color:"#94a3b8", fontSize:14, lineHeight:1 }}>+</span>
                </div>
                <span style={{ color:"#6366f1", fontSize:14, fontWeight:600 }}>✉️ Invite someone new…</span>
              </div>
            </div>
            {nt.assignedTo.length>0 && (
              <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:10, marginTop:-8 }}>
                {nt.assignedTo.map(id=>{ const u=users.find(x=>x.id===id); return u ? (
                  <span key={id} style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"3px 9px", borderRadius:20, background:`${theme.primary}15`, color:theme.primary, fontSize:13, fontWeight:600 }}>
                    {u.name}
                    <span onClick={()=>setNt(p=>({...p,assignedTo:p.assignedTo.filter(x=>x!==id)}))} style={{ cursor:"pointer", fontSize:14, lineHeight:1, opacity:0.7 }}>✕</span>
                  </span>
                ) : null; })}
              </div>
            )}

            {/* Quick invite inline panel */}
            {showQuickInvite && (
              <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:12, padding:14, marginBottom:14 }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                  <p style={{ color:"#166534", fontSize:15, fontWeight:700, margin:0 }}>✉️ Invite & assign someone new</p>
                  <button onClick={()=>{setShowQuickInvite(false);setQuickInvMsg("");}} style={{ background:"none", border:"none", color:"#334155", fontSize:17, cursor:"pointer", padding:0 }}>✕</button>
                </div>
                <input value={quickInvEmail} onChange={e=>setQuickInvEmail(e.target.value)} placeholder="colleague@gmail.com"
                  style={{ ...inp, marginBottom:8, fontSize:15 }} />
                <div style={{ display:"flex", gap:6, marginBottom:10 }}>
                  {[["staff","👤 Staff"]].map(([k,l])=>(
                    <button key={k} onClick={()=>setQuickInvRole(k)} style={{ flex:1, padding:"6px 4px", borderRadius:8, border:`1.5px solid ${quickInvRole===k?"#15803d":"#d1fae5"}`, background:quickInvRole===k?"#dcfce7":"white", color:quickInvRole===k?"#15803d":"#64748b", fontSize:14, cursor:"pointer", fontFamily:"inherit", fontWeight:quickInvRole===k?700:400 }}>{l}</button>
                  ))}
                </div>
                {quickInvMsg && <p style={{ fontSize:14, color:quickInvMsg.includes("⚠️")?"#ef4444":"#15803d", margin:"0 0 8px", padding:"6px 10px", background:quickInvMsg.includes("⚠️")?"#fef2f2":"#f0fdf4", borderRadius:7 }}>{quickInvMsg}</p>}
                <button onClick={doQuickInvite} disabled={!quickInvEmail.trim()} style={{ width:"100%", padding:"9px", background:"#16a34a", border:"none", borderRadius:9, color:"white", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit", opacity:quickInvEmail.trim()?1:0.5 }}>
                  Add & Send Email Invite →
                </button>
                <p style={{ color:"#334155", fontSize:12, textAlign:"center", margin:"6px 0 0" }}>They'll be assigned to this task and receive an install email</p>
              </div>
            )}
            {/* ── Optional supervisor ── */}
            <div style={{ marginBottom:14 }}>
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:nt.supervisorId!==undefined&&nt._showSupervisor?8:0 }}>
                <label style={{ ...lbl, margin:0 }}>🔷 Supervisor <span style={{ fontWeight:400, color:"#475569", fontSize:13 }}>(optional)</span></label>
                <button onClick={()=>setNt(p=>({ ...p, _showSupervisor:!p._showSupervisor, supervisorId:p._showSupervisor?"":p.supervisorId }))}
                  style={{ fontSize:13, padding:"3px 10px", borderRadius:20, border:`1.5px solid ${nt._showSupervisor?"#6366f1":"#e2e8f0"}`, background:nt._showSupervisor?"#eef2ff":"#f8fafc", color:nt._showSupervisor?"#6366f1":"#64748b", cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>
                  {nt._showSupervisor?"✕ Remove":"+ Add"}
                </button>
              </div>
              {nt._showSupervisor && (
                <div style={{ border:"1px solid #e2e8f0", borderRadius:9, background:"white", overflow:"hidden" }}>
                  {[{id:"",name:"No supervisor",role:"",avatar:"—"},...users.filter(u=>u.role==="supervisor"||u.role==="manager")].map(u=>{
                    const sel = nt.supervisorId===u.id;
                    return (
                      <div key={u.id} onClick={()=>setNt(p=>({...p,supervisorId:u.id}))}
                        style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 13px", borderBottom:"1px solid #f1f5f9", cursor:"pointer", background:sel?`${theme.primary}08`:"white" }}>
                        <div style={{ width:20, height:20, borderRadius:"50%", border:`2px solid ${sel?theme.primary:"#cbd5e1"}`, background:sel?theme.primary:"white", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                          {sel && <span style={{ color:"white", fontSize:10, fontWeight:700, lineHeight:1 }}>✓</span>}
                        </div>
                        {u.id
                          ? <React.Fragment><div style={{ width:28, height:28, borderRadius:"50%", background:`linear-gradient(135deg,${theme.primary},${theme.secondary})`, display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:11, fontWeight:700, flexShrink:0 }}>{u.avatar}</div>
                              <div style={{ flex:1 }}>
                                <div style={{ color:"#1e293b", fontSize:15, fontWeight:sel?700:400 }}>{u.name}</div>
                                <div style={{ color:"#475569", fontSize:12, textTransform:"capitalize" }}>{u.role}</div>
                              </div></React.Fragment>
                          : <div style={{ color:"#64748b", fontSize:14 }}>No supervisor</div>
                        }
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <label style={lbl}>🔁 Repeat</label>
            <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:nt.recurrence&&nt.recurrence!=="none"&&nt.deadline?6:14 }}>
              {RECUR_OPTIONS.map(opt=>(
                <button key={opt.value} onClick={()=>setNt(p=>({...p,recurrence:opt.value}))}
                  style={{ padding:"6px 12px", borderRadius:20, border:`1.5px solid ${nt.recurrence===opt.value?theme.primary:"#e2e8f0"}`, background:nt.recurrence===opt.value?`${theme.primary}12`:"white", color:nt.recurrence===opt.value?theme.primary:"#64748b", fontSize:14, cursor:"pointer", fontFamily:"inherit", fontWeight:nt.recurrence===opt.value?700:400, transition:"all 0.12s" }}>
                  {opt.value==="none"?"🚫 None":`🔁 ${opt.label}`}
                </button>
              ))}
            </div>
            {nt.recurrence&&nt.recurrence!=="none"&&nt.deadline && (
              <div style={{ background:`${theme.primary}08`, border:`1px solid ${theme.primary}25`, borderRadius:9, padding:"7px 11px", marginBottom:14 }}>
                <p style={{ color:theme.primary, fontSize:14, margin:0 }}>🔁 {RECUR_OPTIONS.find(r=>r.value===nt.recurrence)?.label} · {recurDescription(nt.recurrence, nt.deadline)}</p>
              </div>
            )}
            <label style={lbl}>Attachments (optional)</label>
            <div style={{ padding:"12px", borderRadius:10, border:"1px solid #e2e8f0", background:"#f8fafc", marginBottom:16 }}>
              <MediaAttach attachments={ntMedia} setAttachments={setNtMedia} accent={theme.primary} folderId={mediaFolderId} accessToken={gUser?.accessToken} onError={msg=>{setSyncState("error");setSyncMsg(msg);}} />
              {ntMedia.length===0 && <p style={{ color:"#334155", fontSize:13, margin:"4px 0 0" }}>Add images or videos to provide task context</p>}
            </div>
            <div style={{ display:"flex", alignItems:"flex-start", gap:8, padding:"10px 12px", borderRadius:10, background:"#fffbeb", border:"1px solid #fde68a", marginBottom:12 }}>
              <span style={{ fontSize:17, flexShrink:0 }}>💡</span>
              <p style={{ margin:0, fontSize:14, color:"#92400e", lineHeight:1.5 }}>
                <strong>Heads up —</strong> task details cannot be edited after creation. Please review the title, description, and assignment before submitting.
              </p>
            </div>
            <button onClick={createTask} style={{ width:"100%", padding:13, background:grad, border:"none", borderRadius:12, color:"white", fontSize:17, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>Create Task</button>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════════════════ */}
      {/* DASHBOARD HEADER                                                       */}
      {/* ══════════════════════════════════════════════════════════════════════ */}
      <div style={{ background:headerBg, position:"sticky", top:0, zIndex:50 }}>

        {/* ── App branding strip — thin, centred ── */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:7, padding:"5px 18px", borderBottom:"1px solid rgba(255,255,255,0.08)" }}>
          <img src={APP_LOGO_B64} alt="Tasks Therapy" style={{ width:14, height:14, objectFit:"contain", opacity:0.85 }} />
          <span style={{ color:"white", fontSize:13, fontWeight:600, letterSpacing:0.3 }}>Tasks Therapy</span>
        </div>

        {/* ── Company row + actions ── */}
        <div style={{ padding:"12px 18px 18px" }}>
        {/* Top bar */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
          {/* Company branding */}
          <div style={{ display:"flex", alignItems:"center", gap:10 }}
            onClick={workspaces.length>1?()=>setShowWsSwitcher(true):undefined}
            style={{ display:"flex", alignItems:"center", gap:10, cursor:workspaces.length>1?"pointer":"default" }}>
            {company.logo
              ? <img src={company.logo} alt="logo" style={{ width:34, height:34, borderRadius:9, objectFit:"cover", background:"white", padding:0, overflow:"hidden" }} />
              : <div style={{ width:34, height:34, borderRadius:9, background:"rgba(255,255,255,0.12)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:18 }}>🏢</div>
            }
            <div>
              <h1 style={{ color:"white", fontSize:16, margin:0, fontWeight:700, letterSpacing:"-0.3px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:160 }}>{company.name}</h1>
              {workspaces.length>1 && <p style={{ color:"rgba(255,255,255,0.92)", fontSize:12, margin:0 }}>⌄ {workspaces.length} workspaces</p>}
            </div>
          </div>
          {/* Actions — notification always visible, rest behind hamburger */}
          <div style={{ display:"flex", gap:6, alignItems:"center" }}>
            <button onClick={()=>setShowNotif(true)} style={{ position:"relative", background:"rgba(255,255,255,0.12)", border:"none", borderRadius:8, padding:"7px 9px", cursor:"pointer", fontSize:17, lineHeight:1 }}>
              🔔{notifs.length>0&&<span style={{ position:"absolute", top:-3, right:-3, background:"#ef4444", color:"white", fontSize:11, fontWeight:700, borderRadius:8, padding:"1px 4px", minWidth:12, textAlign:"center", lineHeight:"14px" }}>{notifs.length}</span>}
            </button>
            {/* Hamburger */}
            <button onClick={()=>setShowMenu(true)} style={{ background:"rgba(255,255,255,0.12)", border:"none", borderRadius:8, padding:"7px 10px", cursor:"pointer", display:"flex", flexDirection:"column", gap:4, alignItems:"center", justifyContent:"center" }}>
              <span style={{ display:"block", width:16, height:2, background:"rgba(255,255,255,0.85)", borderRadius:2 }} />
              <span style={{ display:"block", width:16, height:2, background:"rgba(255,255,255,0.85)", borderRadius:2 }} />
              <span style={{ display:"block", width:16, height:2, background:"rgba(255,255,255,0.85)", borderRadius:2 }} />
            </button>
          </div>

          {/* ── SLIDE-IN SIDEBAR MENU ─────────────────────────────────────── */}
          {/* Menu panel — top aligned with SyncBar */}
          {showMenu && (
            <div style={{ position:"fixed", top:sbHeight+30, left:"max(0px, calc((100% - 1000px)/2))", right:"max(0px, calc((100% - 1000px)/2))", bottom:0, zIndex:500, display:"flex" }} onClick={()=>setShowMenu(false)}>
              <div style={{ flex:1, background:"rgba(0,0,0,0.45)" }} />
              <div style={{ width:240, background:"white", overflowY:"auto", display:"flex", flexDirection:"column", boxShadow:"-6px 0 24px rgba(0,0,0,0.18)" }} onClick={e=>e.stopPropagation()}>
                {/* Sidebar header */}
                <div style={{ background:headerBg, paddingLeft:18, paddingRight:18, paddingBottom:18, paddingTop:16 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                    <span style={{ color:"white", fontSize:17, fontWeight:700 }}>Menu</span>
                    <button onClick={()=>setShowMenu(false)} style={{ background:"rgba(255,255,255,0.08)", border:"none", borderRadius:6, width:26, height:26, color:"white", fontSize:17, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>✕</button>
                  </div>
                  {/* User info */}
                  <div style={{ display:"flex", alignItems:"center", gap:9 }}>
                    <div style={{ width:34, height:34, borderRadius:"50%", background:grad, display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:15, fontWeight:700, flexShrink:0 }}>{me.avatar}</div>
                    <div style={{ overflow:"hidden" }}>
                      <div style={{ color:"white", fontSize:15, fontWeight:700, lineHeight:1.2, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:130 }}>{me.name}</div>
                      <div style={{ color:"rgba(255,255,255,0.95)", fontSize:12, textTransform:"uppercase", letterSpacing:0.5 }}>{me.role}</div>
                      {gUser?.email && <div style={{ color:"rgba(255,255,255,0.7)", fontSize:11, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:160, marginTop:2 }}>{gUser.email}</div>}
                    </div>
                  </div>
                </div>

                {/* Menu items */}
                <div style={{ flex:1, padding:"10px 0" }}>
                  {/* Shared items — all roles */}
                  {[
                    { label:"Task Log",         action:()=>{ setShowTaskLog(true); setShowMenu(false); } },
                    { label:"ℹ️ About App",     action:()=>{ setShowAbout(true); setShowMenu(false); } },
                    { label:"＋ New Workspace",  action:()=>{ setShowWsSwitcher(true); setShowMenu(false); } },
                  ].map(item=>(
                    <button key={item.label} onClick={item.action}
                      style={{ width:"100%", textAlign:"left", padding:"13px 20px", background:"none", border:"none", borderBottom:"1px solid #f1f5f9", color:"#334155", fontSize:16, cursor:"pointer", fontFamily:"inherit", fontWeight:500 }}>
                      {item.label}
                    </button>
                  ))}

                  {/* Supervisor + Manager items */}
                  {(me.role==="manager"||me.role==="supervisor") && (
                    <>
                      <div style={{ padding:"10px 20px 4px", color:"#334155", fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:1.2 }}>Manage</div>
                      {[
                        { label:"Categories",      action:()=>{ setShowCatMgr(true); setShowMenu(false); } },
                      ].map(item=>(
                        <button key={item.label} onClick={item.action}
                          style={{ width:"100%", textAlign:"left", padding:"13px 20px", background:"none", border:"none", borderBottom:"1px solid #f1f5f9", color:"#334155", fontSize:16, cursor:"pointer", fontFamily:"inherit", fontWeight:500 }}>
                          {item.label}
                        </button>
                      ))}
                    </>
                  )}

                  {/* Manager-only items */}
                  {me.role==="manager" && (
                    <>
                      {[
                        { label:"User Settings",      action:()=>{ setShowUserMgr(true); setUmPanel("list"); setShowMenu(false); const ws=workspaces.find(w=>w.id===activeWsId); if(ws?.sheetId&&gUser?.accessToken) fetch(`https://sheets.googleapis.com/v4/spreadsheets/${ws.sheetId}/values/Users`,{headers:{Authorization:`Bearer ${gUser.accessToken}`}}).then(r=>r.json()).then(d=>{const rows=d.values||[];if(rows.length>=2){const hdrs=rows[0];const parsed=rows.slice(1).map(row=>{const o={};hdrs.forEach((h,i)=>{o[h]=row[i]||"";});if("pending" in o)o.pending=o.pending===true||o.pending==="true"||o.pending==="TRUE";return o;});mergeUsersFromSheet(parsed);}}).catch(()=>{}); } },
                        { label:"Company Preferences",action:()=>{ openPrefs(); setShowMenu(false); } },
                        { label:"Backup & Storage",   action:()=>{ setShowBkp(true); setBkpMsg(""); setShowMenu(false); } },

                      ].map(item=>(
                        <button key={item.label} onClick={item.action}
                          style={{ width:"100%", textAlign:"left", padding:"13px 20px", background:"none", border:"none", borderBottom:"1px solid #f1f5f9", color:"#334155", fontSize:16, cursor:"pointer", fontFamily:"inherit", fontWeight:500 }}>
                          {item.label}
                        </button>
                      ))}
                    </>
                  )}

                  {/* Divider */}
                  <div style={{ height:8 }} />

                  {/* Switch workspace */}
                  {workspaces.length > 1 && (
                    <button onClick={()=>{setShowWsSwitcher(true);setShowMenu(false);}}
                      style={{ width:"100%", textAlign:"left", padding:"13px 20px", background:"#f5f3ff", border:"none", borderTop:"1px solid #f1f5f9", color:"#7c3aed", fontSize:16, cursor:"pointer", fontFamily:"inherit", fontWeight:600, display:"flex", alignItems:"center", gap:10 }}>
                      <span>🏢</span>
                      <div style={{ flex:1 }}>
                        <div>Switch Workspace</div>
                        <div style={{ fontSize:12, color:"#a78bfa", fontWeight:400, marginTop:1 }}>
                          {workspaces.find(w=>w.id===activeWsId)?.name || company.name} · {workspaces.length} workspaces
                        </div>
                      </div>
                      <span style={{ color:"#a78bfa" }}>›</span>
                    </button>
                  )}

                  {/* Sign out */}
                  <button onClick={()=>doSignOut(true)}
                     style={{ width:"100%", textAlign:"left", padding:"13px 20px", background:"none", border:"none", borderTop:"1px solid #f1f5f9", color:"#ef4444", fontSize:16, cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>
                     Sign Out
                   </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* User greeting */}
        <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:13 }}>
          <Av user={me} size={36} grad={grad} />
          <div>
            <p style={{ color:"rgba(255,255,255,0.92)", fontSize:12, margin:"0 0 1px", textTransform:"uppercase", letterSpacing:1 }}>Welcome back</p>
            <p style={{ color:"white", fontSize:17, margin:0, fontWeight:700 }}>{me.name} <span style={{ fontSize:12, background:"rgba(255,255,255,0.08)", padding:"2px 7px", borderRadius:9, fontWeight:700, marginLeft:4, textTransform:"uppercase", letterSpacing:0.5 }}>{me.role}</span></p>
          </div>
        </div>

        {/* Stats */}
        <div style={{ display:"flex", gap:5, marginBottom:13 }}>
          {[{l:"Total",v:stats.total,c:"#a5b4fc"},{l:"Done",v:stats.done,c:"#6ee7b7"},{l:"Active",v:stats.prog,c:"#fcd34d"},{l:"Missed",v:stats.missed,c:"#fca5a5"}].map(s=>(
            <div key={s.l} style={{ flex:1, background:"rgba(255,255,255,0.08)", borderRadius:9, padding:"7px 0", textAlign:"center" }}>
              <div style={{ color:s.c, fontSize:17, fontWeight:700 }}>{s.v}</div>
              <div style={{ color:"rgba(255,255,255,0.92)", fontSize:11 }}>{s.l}</div>
            </div>
          ))}
        </div>

        {/* Search */}
        <div style={{ position:"relative" }}>
          <span style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)", fontSize:15, opacity:0.5 }}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search tasks, people, categories…"
            style={{ width:"100%", padding:"9px 12px 9px 30px", borderRadius:9, border:"none", background:"rgba(255,255,255,0.8)", color:"#1e293b", fontSize:15, outline:"none", boxSizing:"border-box", fontFamily:"inherit" }} />
        </div>
        </div>{/* end company row */}
      </div>

      {/* Filter rows */}
      <div style={{ padding:"10px 18px 0", display:"flex", gap:5, overflowX:"auto", scrollbarWidth:"none" }}>
        <button onClick={()=>setFSt("all")} style={{ padding:"5px 11px", borderRadius:20, border:"none", background:fSt==="all"?grad:"#f1f5f9", color:fSt==="all"?"white":"#64748b", fontSize:13, cursor:"pointer", whiteSpace:"nowrap", fontFamily:"inherit", fontWeight:fSt==="all"?700:400 }}>All</button>
        {Object.entries(STATUS).map(([k,v])=>(
          <button key={k} onClick={()=>setFSt(k)} style={{ padding:"5px 11px", borderRadius:20, border:"none", background:fSt===k?v.color:"#f1f5f9", color:fSt===k?"white":"#64748b", fontSize:13, cursor:"pointer", whiteSpace:"nowrap", fontFamily:"inherit", fontWeight:fSt===k?700:400 }}>{v.icon} {v.label}</button>
        ))}
      </div>
      <div style={{ padding:"5px 18px 8px", display:"flex", gap:5, overflowX:"auto", scrollbarWidth:"none" }}>
        <button onClick={()=>setFCat("all")} style={{ padding:"4px 10px", borderRadius:20, border:"none", background:fCat==="all"?headerBg:"#f1f5f9", color:fCat==="all"?"white":"#64748b", fontSize:12, cursor:"pointer", whiteSpace:"nowrap", fontFamily:"inherit", fontWeight:fCat==="all"?700:400 }}>All Cats</button>
        {cats.map(cat=>(
          <button key={cat.id} onClick={()=>setFCat(cat.id)} style={{ padding:"4px 10px", borderRadius:20, border:"none", background:fCat===cat.id?cat.color:"#f1f5f9", color:fCat===cat.id?"white":"#64748b", fontSize:14, cursor:"pointer", whiteSpace:"nowrap", fontFamily:"inherit", fontWeight:fCat===cat.id?700:500 }}>{cat.icon} {cat.name}</button>
        ))}
      </div>

      {search && <p style={{ color:"#334155", fontSize:14, padding:"2px 18px", margin:0 }}>{filtered.length} result{filtered.length!==1?"s":""} for "{search}"</p>}

      {/* Task list */}
      <div style={{ padding:"6px 18px 110px" }}>
        {filtered.length===0 && (
          <div style={{ textAlign:"center", padding:"40px 20px" }}>
            <div style={{ fontSize:36, marginBottom:10 }}>🩺</div>
            <p style={{ color:"#334155", fontSize:16 }}>{search?`No tasks match "${search}"`:"No tasks here yet."}</p>
          </div>
        )}
        {filtered.map(task=>{
          const tl=timeLeft(task.deadline), sc=STATUS[task.status]||STATUS.not_done, pc=PRIORITY[task.priority]||PRIORITY.low;
          const asgnArr=Array.isArray(task.assignedTo)?task.assignedTo:[task.assignedTo].filter(Boolean); const asgns_c=asgnArr.map(id=>users.find(u=>u.id===id)).filter(Boolean); const asgn=asgns_c[0], cat=getCat(task.categoryId);
          return (
            <div key={task.id} onClick={()=>{ setSel(task.id); setUnreadMentions(prev=>{ const next=new Set(prev); next.delete(task.id); try{localStorage.setItem("tt_unread_mentions",JSON.stringify([...next]));}catch(e){} try{const d=JSON.parse(localStorage.getItem("tt_mention_details")||"[]").filter(m=>m.taskId!==task.id);localStorage.setItem("tt_mention_details",JSON.stringify(d));}catch(e){} return next; }); }}
              style={{ background:"white", borderRadius:13, padding:13, marginBottom:8, cursor:"pointer", border:"1px solid #e2e8f0", borderLeft:`4px solid ${task.missedDeadline?"#ef4444":sc.color}`, boxShadow:"0 1px 3px rgba(0,0,0,0.04)" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:6 }}>
                <div style={{ flex:1, marginRight:7 }}>
                  <h3 style={{ color:"#1e293b", fontSize:16, fontWeight:700, margin:"0 0 2px", lineHeight:1.3 }}>
                    {task.title}
                    {unreadMentions.has(task.id) && (
                      <span style={{ marginLeft:6, fontSize:12, background:"#6366f1", color:"white", borderRadius:8, padding:"1px 6px", fontWeight:600, verticalAlign:"middle" }}>🔔 Mentioned</span>
                    )}
                  </h3>
                  {task.deadline && (
                    <p style={{ margin:"0 0 4px", fontSize:13, color: new Date(task.deadline) < new Date() && task.status !== "done" ? "#ef4444" : "#64748b" }}>
                      Due {fmt(task.deadline)}
                    </p>
                  )}
                  <div style={{ display:"flex", alignItems:"center", gap:4, flexWrap:"wrap" }}>
                    {cat && <span style={{ fontSize:13, padding:"2px 9px", borderRadius:9, background:`${cat.color}22`, color:cat.color, fontWeight:700 }}>{cat.icon} {cat.name}</span>}
                    {task.supervisorId && <span style={{ fontSize:12, padding:"2px 8px", borderRadius:9, background:"#eef2ff", color:"#6366f1", fontWeight:600 }}>🔷 Supervised</span>}
                    <span style={{ fontSize:12, padding:"1px 6px", borderRadius:9, background:pc.bg, color:pc.color, fontWeight:700 }}>{pc.label}</span>
                  </div>
                </div>
                <span style={{ fontSize:12, padding:"2px 8px", borderRadius:9, background:sc.bg, color:sc.color, fontWeight:700, flexShrink:0 }}>{sc.icon} {sc.label}</span>
              </div>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <div style={{ display:"flex", alignItems:"center", gap:5 }}>
                  {/* Avatar stack for multiple assignees */}
                  <div style={{ display:"flex", alignItems:"center" }}>
                    {asgns_c.slice(0,3).map((u,i)=>(
                      <div key={u.id} style={{ marginLeft:i===0?0:-6, zIndex:3-i, position:"relative" }}>
                        <Av user={u} size={20} grad={grad} />
                      </div>
                    ))}
                    {asgns_c.length>3 && <span style={{ marginLeft:2, fontSize:11, color:"#64748b", fontWeight:700 }}>+{asgns_c.length-3}</span>}
                  </div>
                  <span style={{ color:"#334155", fontSize:14 }}>
                    {asgns_c.length===0?"Unassigned":asgns_c.length===1?asgns_c[0].name:asgns_c.length===2?`${asgns_c[0].name} & ${asgns_c[1].name}`:`${asgns_c[0].name} +${asgns_c.length-1}`}
                  </span>
                  {task.updates.length>0           && <span style={{ fontSize:11, background:"#f0f4ff", color:theme.primary, padding:"1px 5px", borderRadius:6 }}>↑{task.updates.length}</span>}
                  {(task.comments||[]).length>0    && <span style={{ fontSize:11, background:"#fff7ed", color:"#f59e0b",     padding:"1px 5px", borderRadius:6 }}>💬{(task.comments||[]).length}</span>}
                  {(task.media||[]).length>0       && <span style={{ fontSize:11, background:"#f0fdf4", color:"#10b981",     padding:"1px 5px", borderRadius:6 }}>📎{(task.media||[]).length}</span>}
                  {task.recurrence&&task.recurrence!=="none" && <span style={{ fontSize:11, background:"#f5f3ff", color:"#7c3aed", padding:"1px 5px", borderRadius:6, fontWeight:700 }}>🔁 {RECUR_OPTIONS.find(r=>r.value===task.recurrence)?.short}</span>}
                </div>
                <span style={{ fontSize:13, color:tl.overdue?"#ef4444":"#94a3b8", fontWeight:tl.overdue?700:400 }}>
                  {task.missedDeadline?"⚠️ Missed":tl.overdue?"Overdue":`⏱ ${tl.label}`}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {/* FAB */}
      {canManageTasks && (
        <div style={{ position:"fixed", bottom:0, left:"50%", transform:"translateX(-50%)", width:"100%", maxWidth:1000, padding:"10px 18px 20px", background:"linear-gradient(to top,#f8fafc 65%,transparent)", zIndex:100, boxSizing:"border-box" }}>
          <button onClick={()=>setShowCreate(true)} style={{ width:"100%", padding:"13px", background:grad, border:"none", borderRadius:14, color:"white", fontSize:17, fontWeight:700, cursor:"pointer", boxShadow:`0 4px 18px ${theme.primary}50`, fontFamily:"inherit" }}>＋ Create New Task</button>
        </div>
      )}
    </div>
    </div>
  );
}
